import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from 'graphql';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = {
  [X in Exclude<keyof T, K>]?: T[X];
} &
  { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  DateTime: any;
  /** Represents a URL, encoded as string */
  URL: any;
  /** Represents a monetary value in cents to avoid floating point problems, encoded as number. */
  MonetaryValue: any;
  /** Represents a currency code, encoded as string. */
  CurrencyCode: any;
  /** Represents a page slug, encoded as a string with a restricted URL-safe alphabet. */
  Slug: any;
  /** Represents a page preview flag, as a boolean. */
  Preview: any;
  /** Represents the ID for a leaderboard, as a string. */
  LeaderboardId: any;
  FixedFloat: any;
  /** Represents a universally unique identifier (https://en.wikipedia.org/wiki/Universally_unique_identifier), as a string. */
  UUID: any;
  /** Represents stringified JSON */
  JSON: any;
};

export enum ApplicationType {
  Fitness = 'FITNESS',
}

export type Application = FitnessApplication;

/** Fitness applications */
export enum FitnessApplicationActivityType {
  Run = 'RUN',
  Ride = 'RIDE',
  Walk = 'WALK',
  Hike = 'HIKE',
  Swim = 'SWIM',
  Wheelchair = 'WHEELCHAIR',
}

export type FitnessApplicationSettings = {
  __typename?: 'FitnessApplicationSettings';
  measurementSystem?: Maybe<MeasurementSystem>;
  subscribedActivities?: Maybe<Array<Maybe<FitnessApplicationActivityType>>>;
  showDistance?: Maybe<Scalars['Boolean']>;
  showDuration?: Maybe<Scalars['Boolean']>;
  showElevation?: Maybe<Scalars['Boolean']>;
  showPhotos?: Maybe<Scalars['Boolean']>;
  showMap?: Maybe<Scalars['Boolean']>;
  showTotaliser?: Maybe<Scalars['Boolean']>;
};

export type FitnessApplication = {
  __typename?: 'FitnessApplication';
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<FitnessApplicationSettings>;
};

export type FitnessApplicationSettingsInput = {
  pageId: Scalars['ID'];
  name: Scalars['String'];
  measurementSystem?: Maybe<MeasurementSystem>;
  subscribedActivities?: Maybe<Array<Maybe<FitnessApplicationActivityType>>>;
  showDistance?: Maybe<Scalars['Boolean']>;
  showDuration?: Maybe<Scalars['Boolean']>;
  showElevation?: Maybe<Scalars['Boolean']>;
  showPhotos?: Maybe<Scalars['Boolean']>;
  showMap?: Maybe<Scalars['Boolean']>;
  showTotaliser?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * **DEPRECATED**
   * `saveFitnessApplicationSettings` Mutation is deprecated as of 26/05/2020. Use `setFitnessApplicationSettings` instead.
   */
  saveFitnessApplicationSettings?: Maybe<Scalars['Boolean']>;
  setFitnessApplicationSettings?: Maybe<FitnessApplicationSettings>;
  updateCheckoutPersonalisation?: Maybe<Checkout>;
  updateCheckoutGiftAidDeclaration?: Maybe<Checkout>;
  updateCheckoutOrderAmount?: Maybe<Checkout>;
  updateCheckoutSelectedCard?: Maybe<Checkout>;
  updateCheckoutRemoveCard?: Maybe<Checkout>;
  confirmCheckout?: Maybe<Checkout>;
  updateCheckoutApplyPoints?: Maybe<Checkout>;
  updateCheckoutPaymentType?: Maybe<Checkout>;
  initialiseCheckoutWalletToken?: Maybe<CheckoutWalletToken>;
  /** @deprecated Was combined for paymentcard, now split for other use cases */
  initialiseCheckout3DS?: Maybe<Checkout3DsData>;
  checkout3dsInitialise?: Maybe<CheckoutInitialise3DsResponse>;
  checkout3dsNonce?: Maybe<Checkout3DsNonceResponse>;
  verifyCheckout3DS?: Maybe<Checkout3DsVerification>;
  verifyCheckoutWallet?: Maybe<CheckoutWalletVerification>;
  initialiseCheckoutPayWithBankTransfer?: Maybe<
    CheckoutPayWithBankTransferInitData
  >;
  startCheckoutSession?: Maybe<StartSessionResult>;
  /** Sends a message to a donor to say thanks. */
  thankDonor?: Maybe<Donation>;
  createEvent?: Maybe<Event>;
  connectFitness: Scalars['Boolean'];
  connectFitbit: Scalars['Boolean'];
  disconnectFitness: Scalars['Boolean'];
  disconnectFitbit: Scalars['Boolean'];
  /** Create a new video story */
  createVideoStory: Scalars['Boolean'];
  /** Create a new livestream entry */
  createLivestreamEntry?: Maybe<Livestream>;
  /** Delete a livestream entry */
  deleteLivestreamEntry?: Maybe<Livestream>;
  /** Update a livestream entry */
  updateLivestreamEntry?: Maybe<Livestream>;
  addOfflineDonation?: Maybe<OfflineDonation>;
  deleteOfflineDonation: Scalars['ID'];
  editOfflineDonation?: Maybe<OfflineDonation>;
  updatePage?: Maybe<UpdatePagePayload>;
  updatePageAsStaff?: Maybe<UpdatePagePayload>;
  updatePreferenceService?: Maybe<PreferenceServicePayload>;
  /** @deprecated Use updatePageGallery */
  addMediaItem?: Maybe<AddMediaItemPayload>;
  assignTagsToChildren?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use updatePageGallery */
  deleteMediaItem?: Maybe<DeleteMediaItemPayload>;
  cancelPage?: Maybe<CancelPagePayload>;
  /** @deprecated Use updatePageCover or updatePageGallery */
  setPageMedia?: Maybe<SetPageMediaPayload>;
  createPageV2?: Maybe<Page>;
  addPageRelationships?: Maybe<PageRelationshipsPayload>;
  deletePageRelationships?: Maybe<PageRelationshipsPayload>;
  updatePageCover?: Maybe<UpdatePageCoverPayload>;
  updatePageGallery?: Maybe<UpdatePageGalleryPayload>;
  linkPageToCampaign?: Maybe<Scalars['Boolean']>;
  completeTask?: Maybe<Tasks>;
  createTeam?: Maybe<Page>;
  joinTeam?: Maybe<JoinTeamPayload>;
  unlinkTeam?: Maybe<UnlinkTeamPayload>;
  /** Create a new timeline entry */
  createTimelineEntry?: Maybe<TimelineEntry>;
  deleteTimelineEntry: Scalars['ID'];
  refreshTimelineEntry: Scalars['ID'];
};

export type MutationSaveFitnessApplicationSettingsArgs = {
  input: FitnessApplicationSettingsInput;
};

export type MutationSetFitnessApplicationSettingsArgs = {
  input: FitnessApplicationSettingsInput;
};

export type MutationUpdateCheckoutPersonalisationArgs = {
  input: UpdateCheckoutPersonalisationInput;
};

export type MutationUpdateCheckoutGiftAidDeclarationArgs = {
  input: UpdateCheckoutGiftAidDeclarationInput;
};

export type MutationUpdateCheckoutOrderAmountArgs = {
  input: UpdateCheckoutOrderAmountInput;
};

export type MutationUpdateCheckoutSelectedCardArgs = {
  input: UpdateCheckoutSelectedCardInput;
};

export type MutationUpdateCheckoutRemoveCardArgs = {
  input: UpdateCheckoutRemoveCardInput;
};

export type MutationConfirmCheckoutArgs = {
  input: ConfirmCheckoutInput;
};

export type MutationUpdateCheckoutApplyPointsArgs = {
  input: UpdateCheckoutApplyPointsInput;
};

export type MutationUpdateCheckoutPaymentTypeArgs = {
  input: UpdateCheckoutPaymentTypeInput;
};

export type MutationInitialiseCheckoutWalletTokenArgs = {
  input: InitialiseCheckoutWalletTokenInput;
};

export type MutationInitialiseCheckout3DsArgs = {
  input: InitialiseCheckout3DsInput;
};

export type MutationCheckout3dsInitialiseArgs = {
  input: Checkout3dsInitialiseCallInput;
};

export type MutationCheckout3dsNonceArgs = {
  input: Checkout3DsNonceCallInput;
};

export type MutationVerifyCheckout3DsArgs = {
  input: VerifyCheckout3DsInput;
};

export type MutationVerifyCheckoutWalletArgs = {
  input: VerifyCheckoutWalletInput;
};

export type MutationInitialiseCheckoutPayWithBankTransferArgs = {
  input: InitialiseCheckoutPayWithBankTransferInput;
};

export type MutationStartCheckoutSessionArgs = {
  input: StartDonationInput;
};

export type MutationThankDonorArgs = {
  donorId: Scalars['String'];
  pageId: Scalars['String'];
  message: Scalars['String'];
};

export type MutationCreateEventArgs = {
  input: CreateEventInput;
};

export type MutationConnectFitnessArgs = {
  input: ConnectFitnessInput;
};

export type MutationConnectFitbitArgs = {
  input: ConnectFitnessInput;
};

export type MutationCreateVideoStoryArgs = {
  input: CreateVideoStoryInput;
};

export type MutationCreateLivestreamEntryArgs = {
  input: CreateLivestreamInput;
};

export type MutationDeleteLivestreamEntryArgs = {
  input: DeleteLivestreamInput;
};

export type MutationUpdateLivestreamEntryArgs = {
  input: UpdateLivestreamInput;
};

export type MutationAddOfflineDonationArgs = {
  input: CreateOfflineDonationInput;
};

export type MutationDeleteOfflineDonationArgs = {
  input: DeleteOfflineDonationInput;
};

export type MutationEditOfflineDonationArgs = {
  input: EditOfflineDonationInput;
};

export type MutationUpdatePageArgs = {
  input: UpdatePageInput;
};

export type MutationUpdatePageAsStaffArgs = {
  input: UpdatePageAsStaffInput;
};

export type MutationUpdatePreferenceServiceArgs = {
  input: UpdatePreferenceServiceInput;
};

export type MutationAddMediaItemArgs = {
  input: AddMediaItemInput;
};

export type MutationAssignTagsToChildrenArgs = {
  input: AssignTagsToChildrenInput;
};

export type MutationDeleteMediaItemArgs = {
  input: DeleteMediaItemInput;
};

export type MutationCancelPageArgs = {
  input: CancelPageInput;
};

export type MutationSetPageMediaArgs = {
  input: SetPageMediaInput;
};

export type MutationCreatePageV2Args = {
  input: CreatePageV2Input;
  createPageMetadata?: Maybe<CreatePageMetadataInput>;
};

export type MutationAddPageRelationshipsArgs = {
  input: PageRelationshipsInput;
};

export type MutationDeletePageRelationshipsArgs = {
  input: PageRelationshipsInput;
};

export type MutationUpdatePageCoverArgs = {
  input: UpdatePageCoverInput;
};

export type MutationUpdatePageGalleryArgs = {
  input: UpdatePageGalleryInput;
};

export type MutationLinkPageToCampaignArgs = {
  input: LinkPageToCampaignInput;
};

export type MutationCompleteTaskArgs = {
  input?: Maybe<TaskInput>;
};

export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};

export type MutationJoinTeamArgs = {
  input: JoinTeamInput;
};

export type MutationUnlinkTeamArgs = {
  input: UnlinkTeamInput;
};

export type MutationCreateTimelineEntryArgs = {
  input: CreateTimelineEntryInput;
};

export type MutationDeleteTimelineEntryArgs = {
  input: DeleteTimelineEntryInput;
};

export type MutationRefreshTimelineEntryArgs = {
  input: RefreshTimelineEntryInput;
};

export type ThirdPartyApplications = {
  __typename?: 'ThirdPartyApplications';
  strava?: Maybe<Strava>;
  fitbit?: Maybe<Fitbit>;
};

export type AsksItem = {
  __typename?: 'AsksItem';
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  amountRaised?: Maybe<Scalars['MonetaryValue']>;
  target?: Maybe<Scalars['MonetaryValue']>;
  hasTarget?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['CurrencyCode']>;
  isYimby?: Maybe<Scalars['Boolean']>;
  progress?: Maybe<Scalars['String']>;
  yimbyPitchFor?: Maybe<Scalars['String']>;
  yimbyPitchBecause?: Maybe<Scalars['String']>;
  beneficiaryName?: Maybe<Scalars['String']>;
  askStatus?: Maybe<Scalars['String']>;
  editUrl?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  availableSlugs?: Maybe<AvailableSlugs>;
  /** Gets a Cause from the Cause API by Cause Ref */
  getCauseByCauseRef?: Maybe<Cause>;
  /** Gets a Cause from the Cause API by Source Ref */
  getCauseBySourceRef?: Maybe<Cause>;
  /** Gets a charity by charity ID. */
  charity?: Maybe<Charity>;
  /** Gets a charity by the external ID. */
  charityByExternalId?: Maybe<Charity>;
  /** Gets a Checkout from the Donation Collection API */
  checkout?: Maybe<Checkout>;
  /** Gets the status for a Checkout Transaction from the Donations API */
  transactionStatus?: Maybe<TransactionStatus>;
  /** Gets the available points balance for a payment card */
  paymentCardPointsBalance?: Maybe<PaymentCardPointsBalance>;
  discoverPersistedPages?: Maybe<DiscoverPersistedPages>;
  /** Gets funds data */
  funds?: Maybe<Funds>;
  /** Get the the video story */
  getVideoStory: VideoStory;
  leaderboard: Leaderboard;
  livestream?: Maybe<Livestream>;
  livestreamByType?: Maybe<Array<Maybe<LivestreamMetaData>>>;
  meta: Meta;
  /** Gets the page data by the page type and slug or ID. */
  page?: Maybe<Page>;
  /**
   * Gets the page data by the page type and ID.
   * @deprecated Use the page query with an id argument type
   */
  pageById?: Maybe<Page>;
  pageCreatedCountSummary: Array<PageCreatedCountSummaryItem>;
  /** Gets node by id (node can anything that can be fetched by a unique global ID, for example: a page, user etc.) */
  node?: Maybe<Node>;
  /** Gets the logged-in user data. */
  viewer?: Maybe<User>;
  tagValues: Array<TagValue>;
  tasks?: Maybe<Tasks>;
  totals: Array<Total>;
  trendingCharities?: Maybe<TrendingCharities>;
};

export type QueryAvailableSlugsArgs = {
  slug: Scalars['Slug'];
  type?: Maybe<PageType>;
};

export type QueryGetCauseByCauseRefArgs = {
  input: CauseByCauseRefInput;
};

export type QueryGetCauseBySourceRefArgs = {
  input: CauseBySourceRefInput;
};

export type QueryCharityArgs = {
  charityId: Scalars['UUID'];
};

export type QueryCharityByExternalIdArgs = {
  externalId: Scalars['Int'];
};

export type QueryCheckoutArgs = {
  input: CheckoutInput;
};

export type QueryTransactionStatusArgs = {
  input: TransactionStatusInput;
};

export type QueryPaymentCardPointsBalanceArgs = {
  input: PaymentCardCardPointsBalanceInput;
};

export type QueryFundsArgs = {
  input: FundsInput;
};

export type QueryGetVideoStoryArgs = {
  legacyId: Scalars['ID'];
};

export type QueryLeaderboardArgs = {
  id: Scalars['LeaderboardId'];
};

export type QueryLivestreamArgs = {
  legacyId: Scalars['String'];
};

export type QueryLivestreamByTypeArgs = {
  streamType: Scalars['String'];
  isLive: Scalars['Boolean'];
};

export type QueryPageArgs = {
  type: PageType;
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['Slug']>;
  preview?: Maybe<Scalars['Preview']>;
};

export type QueryPageByIdArgs = {
  type: PageType;
  id: Scalars['String'];
  preview?: Maybe<Scalars['Preview']>;
};

export type QueryPageCreatedCountSummaryArgs = {
  pageId: Scalars['UUID'];
  month: Scalars['Int'];
  year: Scalars['Int'];
  productName?: Maybe<ProductType>;
};

export type QueryNodeArgs = {
  id: Scalars['ID'];
};

export type QueryTagValuesArgs = {
  assignee: Scalars['String'];
};

export type QueryTasksArgs = {
  input: TaskInput;
};

export type QueryTotalsArgs = {
  segment: Scalars['String'];
  tagDefinitionId: Scalars['String'];
  tagValue: Scalars['String'];
  measurementDomain?: Maybe<Scalars['String']>;
};

export type AvailableSlugs = {
  __typename?: 'AvailableSlugs';
  slugs?: Maybe<Array<Maybe<Scalars['Slug']>>>;
  isAvailable?: Maybe<Scalars['Boolean']>;
};

export type Branding = {
  __typename?: 'Branding';
  id?: Maybe<Scalars['UUID']>;
  backgroundColor?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  headerImage?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
};

export type CauseByCauseRefInput = {
  causeRef: Scalars['String'];
};

export type CauseBySourceRefInput = {
  sourceRef: Scalars['String'];
};

export type Cause = {
  __typename?: 'Cause';
  type: Scalars['String'];
  sourceRef: Scalars['String'];
  causeRef: Scalars['String'];
  beneficiaryRef: Scalars['String'];
  tip: CauseTip;
  marketCode: MarketCode;
  settlementCurrency: AcceptedCurrencyCode;
  bbms?: Maybe<CauseBbms>;
  supportsGuest: Scalars['Boolean'];
  giftAid: CauseGiftAid;
  paymentMethods: Array<PaymentMethod>;
};

export type CauseTip = {
  __typename?: 'CauseTip';
  tipScheme: TipScheme;
  tipJarConfiguration?: Maybe<Array<TipJarConfiguration>>;
};

export type CauseBbms = {
  __typename?: 'CauseBbms';
  merchantAccountId?: Maybe<Scalars['String']>;
};

export type CauseGiftAid = {
  __typename?: 'CauseGiftAid';
  supported: Scalars['Boolean'];
  externalProviderEnabled: Scalars['Boolean'];
};

export type TipJarConfiguration = {
  __typename?: 'TipJarConfiguration';
  from: Scalars['Float'];
  to: Scalars['Float'];
  isToInfinity: Scalars['Boolean'];
  valueType: TipJarValueType;
  values?: Maybe<Array<Scalars['Int']>>;
  defaultValue: Scalars['Int'];
};

export enum TipJarValueType {
  Amount = 'Amount',
  Percentage = 'Percentage',
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  currency: Scalars['CurrencyCode'];
  card?: Maybe<Array<CardType>>;
  supportsRecurringCard: Scalars['Boolean'];
  alternative?: Maybe<Array<AlternativePaymentMethod>>;
};

export enum AlternativePaymentMethod {
  DirectDebit = 'DirectDebit',
  PayPal = 'PayPal',
  GooglePay = 'GooglePay',
  ApplePay = 'ApplePay',
  AmexPayWithBank = 'AmexPayWithBank',
  Venmo = 'Venmo',
}

export enum MarketCode {
  Au = 'AU',
  Ca = 'CA',
  Gb = 'GB',
  Nz = 'NZ',
  Us = 'US',
}

export type Charity = Node & {
  __typename?: 'Charity';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  registrationNumber?: Maybe<Scalars['String']>;
  slug: Scalars['Slug'];
  profilePageUrl?: Maybe<Scalars['URL']>;
  logo?: Maybe<Scalars['URL']>;
  impactStatement?: Maybe<Scalars['String']>;
  causeId?: Maybe<Scalars['String']>;
  externalUrl?: Maybe<Scalars['URL']>;
  /** @deprecated Use landingPage.targetWithCurrency */
  targetWithCurrency?: Maybe<MonetaryAmount>;
  /** @deprecated Use landingPage.legacyId */
  pageId?: Maybe<Scalars['String']>;
  legacyCharityId?: Maybe<Scalars['Int']>;
  displayCurrency?: Maybe<Scalars['String']>;
  donationPrompts?: Maybe<Array<DonationPrompt>>;
  countryCode?: Maybe<Scalars['String']>;
  thankYouMessage?: Maybe<Scalars['String']>;
  landingPage?: Maybe<Page>;
  externalId?: Maybe<Scalars['Int']>;
  beneficiaryId?: Maybe<Scalars['UUID']>;
  supportsGiftAid?: Maybe<Scalars['Boolean']>;
};

export type CheckoutInput = {
  checkoutId: Scalars['ID'];
  isPayWithBankTransfer?: Maybe<Scalars['Boolean']>;
};

export type TransactionStatusInput = {
  transactionReference: Scalars['ID'];
};

export type PaymentCardCardPointsBalanceInput = {
  checkoutId: Scalars['ID'];
  paymentCardId: Scalars['String'];
};

export type PaymentCardPointsBalance = {
  __typename?: 'PaymentCardPointsBalance';
  checkoutId: Scalars['ID'];
  paymentCardId: Scalars['String'];
  totalPoints?: Maybe<Scalars['Int']>;
  conversionRate?: Maybe<Scalars['Float']>;
  isEligible?: Maybe<Scalars['Boolean']>;
};

export type CheckoutInitialise3DsResponse = {
  __typename?: 'CheckoutInitialise3DSResponse';
  token: Scalars['String'];
  clientTokenUnavailable?: Maybe<Scalars['Boolean']>;
};

export type Checkout3DsNonceBillingAddress = {
  __typename?: 'Checkout3DSNonceBillingAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  townCity?: Maybe<Scalars['String']>;
  countyStateRegion?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  postalCode: Scalars['String'];
  udprn?: Maybe<Scalars['String']>;
  billingAddressId: Scalars['String'];
};

export type Checkout3DsNonceResponse = {
  __typename?: 'Checkout3DSNonceResponse';
  exemptionRequested: Scalars['Boolean'];
  paymentCardId: Scalars['String'];
  nonce: Scalars['String'];
  bin: Scalars['Int'];
  emailAddress: Scalars['String'];
  billingAddress: Checkout3DsNonceBillingAddress;
};

export type VerifyCheckoutWalletInput = {
  checkoutId: Scalars['ID'];
  paymentType: WalletPaymentType;
  paymentProviderDetails: Scalars['JSON'];
};

export type CheckoutWalletVerification = {
  __typename?: 'CheckoutWalletVerification';
  isSuccessful: Scalars['Boolean'];
};

export type VerifyCheckout3DsInput = {
  checkoutId: Scalars['ID'];
  nonce: Scalars['String'];
};

export type Checkout3DsVerification = {
  __typename?: 'Checkout3DSVerification';
  isSuccessful: Scalars['Boolean'];
};

export type InitialiseCheckoutPayWithBankTransferAmountInput = {
  tipScheme: TipScheme;
  tipValue: Scalars['MonetaryValue'];
  value: Scalars['MonetaryValue'];
};

export type InitialiseCheckoutPayWithBankTransferInput = {
  checkoutId: Scalars['ID'];
  amount?: Maybe<InitialiseCheckoutPayWithBankTransferAmountInput>;
};

export type CheckoutPayWithBankTransferInitData = {
  __typename?: 'CheckoutPayWithBankTransferInitData';
  custom_data_encryption: CheckoutPayWithBankTransferKey;
  button_type: Scalars['String'];
  country_code: Scalars['String'];
  locale: Scalars['String'];
  merchant_id: Scalars['String'];
  order_details: Scalars['String'];
  request_id: Scalars['String'];
};

export type CheckoutPayWithBankTransferKey = {
  __typename?: 'CheckoutPayWithBankTransferKey';
  public_key: Scalars['String'];
  public_key_version: Scalars['String'];
};

export type InitialiseCheckout3DsInput = {
  checkoutId: Scalars['ID'];
  deviceType: DeviceType;
};

export type Checkout3dsInitialiseCallInput = {
  checkoutId: Scalars['ID'];
};

export type Checkout3DsNonceCallInput = {
  checkoutId: Scalars['ID'];
  deviceType: DeviceType;
};

export type Checkout3DsData = {
  __typename?: 'Checkout3DSData';
  token?: Maybe<Scalars['String']>;
  nonce?: Maybe<Scalars['String']>;
  bin?: Maybe<Scalars['String']>;
  exemptionRequested?: Maybe<Scalars['Boolean']>;
  postalCode?: Maybe<Scalars['String']>;
  clientTokenUnavailable: Scalars['Boolean'];
};

export type InitialiseCheckoutWalletTokenInput = {
  checkoutId: Scalars['ID'];
  paymentServiceProvider: PaymentServiceProvider;
};

export type CheckoutWalletToken = {
  __typename?: 'CheckoutWalletToken';
  token: Scalars['String'];
};

export type ConfirmCheckoutInput = {
  checkoutId: Scalars['String'];
  deviceType: Scalars['String'];
  preferences?: Maybe<PreferencesInput>;
  donorDetails: DonorDetailsInput;
  sessionInformation?: Maybe<SessionInformationInput>;
};

export type PreferencesInput = {
  consentStatement?: Maybe<Scalars['Int']>;
  collectionLocationId?: Maybe<Scalars['Int']>;
  transactionTypeId?: Maybe<Scalars['String']>;
  isConsentRequired?: Maybe<Scalars['Boolean']>;
  donationCauseSourceRef?: Maybe<Scalars['String']>;
  consents: Array<ConsentInput>;
  TransactionId?: Maybe<Scalars['String']>;
};

export type ConsentInput = {
  consentStatementId?: Maybe<Scalars['Int']>;
  entityType: EntityType;
  consentStatementText?: Maybe<Scalars['String']>;
  consentGiven?: Maybe<Scalars['Boolean']>;
  directMarketingType: Scalars['Boolean'];
  hidden: Scalars['Boolean'];
};

export type DonorDetailsInput = {
  emailAddress?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  address?: Maybe<AddressInput>;
};

export type SessionInformationInput = {
  transactionId: Scalars['String'];
  payload: Scalars['String'];
};

export type UpdateCheckoutApplyPointsInput = {
  checkoutId: Scalars['ID'];
  paymentCardId: Scalars['String'];
  points: Scalars['Int'];
};

export type UpdateCheckoutSelectedCardInput = {
  checkoutId: Scalars['ID'];
  selectedPaymentCardId: Scalars['String'];
};

export type UpdateCheckoutRemoveCardInput = {
  checkoutId: Scalars['ID'];
  paymentCardId: Scalars['String'];
};

export type UpdateCheckoutPaymentTypeInput = {
  checkoutId: Scalars['ID'];
  selectedPaymentType: PaymentType;
};

export type UpdateCheckoutPersonalisationInput = {
  checkoutId: Scalars['ID'];
  displayName?: Maybe<Scalars['String']>;
  isAnonymous: Scalars['Boolean'];
  message: Scalars['String'];
};

export type UpdateCheckoutGiftAidDeclarationInput = {
  checkoutId: Scalars['ID'];
  isClaimed: Scalars['Boolean'];
  giftAidDetails?: Maybe<GiftAidDetailsInput>;
};

export type GiftAidDetailsInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  isOverseas: Scalars['Boolean'];
  address: AddressInput;
};

export type AddressInput = {
  line1: Scalars['String'];
  line2?: Maybe<Scalars['String']>;
  townCity: Scalars['String'];
  countyStateRegion?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  country: Scalars['String'];
  selectionHash?: Maybe<Scalars['String']>;
};

export type UpdateCheckoutOrderAmountInput = {
  checkoutId: Scalars['ID'];
  currency: AcceptedCurrencyCode;
  isAmountPrivate: Scalars['Boolean'];
  isRecurring: Scalars['Boolean'];
  tipScheme: TipScheme;
  tipValue?: Maybe<Scalars['MonetaryValue']>;
  directDebit?: Maybe<DirectDebitInput>;
  recurrenceDayOfMonth?: Maybe<Scalars['String']>;
  value: Scalars['MonetaryValue'];
};

export type DirectDebitInput = {
  accountHolderName: Scalars['String'];
  sortCode: Scalars['String'];
  accountNumber: Scalars['String'];
  dayOfMonth: Scalars['Int'];
  cancelWhenCauseExpires?: Maybe<Scalars['Boolean']>;
};

export type Checkout = Node & {
  __typename?: 'Checkout';
  id: Scalars['ID'];
  checkoutId: Scalars['ID'];
  userLocale?: Maybe<Locale>;
  transactingUser?: Maybe<TransactingUser>;
  additionalData: Scalars['JSON'];
  customAttributes?: Maybe<CustomAttributes>;
  transaction?: Maybe<Transaction>;
  giftAid?: Maybe<GiftAid>;
  order?: Maybe<Order>;
  payment?: Maybe<Payment>;
};

export type TransactingUser = {
  __typename?: 'TransactingUser';
  id: Scalars['ID'];
  transactingUserId: Scalars['ID'];
  type?: Maybe<TransactingUserType>;
  savedCards: Array<PaymentCard>;
  lastUsedPaymentType?: Maybe<PaymentType>;
};

export type PaymentCard = {
  __typename?: 'PaymentCard';
  id: Scalars['ID'];
  paymentCardId?: Maybe<Scalars['ID']>;
  nameOnCard: Scalars['String'];
  lastFourDigits: Scalars['String'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  saved: Scalars['Boolean'];
  disabled: Scalars['Boolean'];
  cardCountryCode?: Maybe<Scalars['String']>;
  cardType: CardType;
  billingAddress: Address;
  requires3DS: Scalars['Boolean'];
  points?: Maybe<PaymentCardPoints>;
};

export type Address = {
  __typename?: 'Address';
  id: Scalars['ID'];
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  townCity?: Maybe<Scalars['String']>;
  countyStateRegion?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
};

export type PaymentCardPoints = {
  __typename?: 'PaymentCardPoints';
  appliedPoints?: Maybe<Scalars['Int']>;
  totalPoints: Scalars['Int'];
  isEligible: Scalars['Boolean'];
  conversionRate: Scalars['Float'];
};

export type CustomAttributes = {
  __typename?: 'CustomAttributes';
  currency: AcceptedCurrencyCode;
  tipScheme?: Maybe<TipScheme>;
  message?: Maybe<Scalars['String']>;
  skipGiftAid?: Maybe<Scalars['Boolean']>;
  skipMessage?: Maybe<Scalars['Boolean']>;
  suggestedPaymentType?: Maybe<PaymentType>;
  successUrl?: Maybe<Scalars['URL']>;
  redirectOnSuccess: Scalars['Boolean'];
};

export type Transaction = {
  __typename?: 'Transaction';
  id: Scalars['ID'];
  transactionId?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  isComplete: Scalars['Boolean'];
  startedTime: Scalars['String'];
};

export type GiftAid = {
  __typename?: 'GiftAid';
  id: Scalars['ID'];
  taxPayerDetails?: Maybe<TaxPayerDetails>;
  ratePercent: Scalars['Float'];
  isClaimed?: Maybe<Scalars['Boolean']>;
  isExternalGiftAidProviderEnabled: Scalars['Boolean'];
  isMatchedInExternalGiftAidProvider?: Maybe<Scalars['Boolean']>;
};

export type TaxPayerDetails = {
  __typename?: 'TaxPayerDetails';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  selectionHash?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  supportedCurrencies: SupportedCurrencies;
  currency?: Maybe<AcceptedCurrencyCode>;
  appliedTipScheme?: Maybe<TipScheme>;
  lineItems: Array<LineItem>;
  tipAmount?: Maybe<Scalars['MonetaryValue']>;
  totalAmount?: Maybe<Scalars['MonetaryValue']>;
  fees?: Maybe<Fees>;
  voluntaryContributionConfig?: Maybe<Array<VoluntaryContributionConfig>>;
  requiresFullBillingAddress?: Maybe<Scalars['Boolean']>;
  supportedFeatures?: Maybe<SupportedFeatures>;
};

export type SupportedCurrencies = {
  __typename?: 'SupportedCurrencies';
  GBP?: Maybe<CurrencyDefaults>;
  USD?: Maybe<CurrencyDefaults>;
  AUD?: Maybe<CurrencyDefaults>;
  CAD?: Maybe<CurrencyDefaults>;
  EUR?: Maybe<CurrencyDefaults>;
  NZD?: Maybe<CurrencyDefaults>;
};

export type CurrencyDefaults = {
  __typename?: 'CurrencyDefaults';
  supportedPaymentTypes: Array<PaymentType>;
  supportedCardTypes: Array<CardType>;
  supportedPointsSchemes: Array<PointsScheme>;
  suggestedAmounts: Array<SuggestedAmount>;
  default: Scalars['MonetaryValue'];
  minimum: Scalars['MonetaryValue'];
  maximum: Scalars['MonetaryValue'];
};

export type SuggestedAmount = {
  __typename?: 'SuggestedAmount';
  value: Scalars['MonetaryValue'];
  description?: Maybe<Scalars['String']>;
};

export type LineItem = {
  __typename?: 'LineItem';
  id: Scalars['ID'];
  lineItemId: Scalars['ID'];
  value?: Maybe<Scalars['MonetaryValue']>;
  name: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  sourceUrl?: Maybe<Scalars['URL']>;
  type: LineItemType;
  details?: Maybe<LineItemDetails>;
};

export type LineItemDetails = DonationItemDetails | ProductItemDetails;

export type DonationItemDetails = {
  __typename?: 'DonationItemDetails';
  cause?: Maybe<DonationCause>;
  page?: Maybe<Page>;
  isAmountPrivate: Scalars['Boolean'];
  isRecurring: Scalars['Boolean'];
  recurrenceDayOfMonth?: Maybe<Scalars['String']>;
  recurrenceNextPaymentDate?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  isAnonymous?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
};

export type ProductItemDetails = {
  __typename?: 'ProductItemDetails';
  quantity?: Maybe<Scalars['Int']>;
};

export type DonationCause = {
  __typename?: 'DonationCause';
  id: Scalars['ID'];
  causeId: Scalars['ID'];
  sourceRef: Scalars['String'];
  marketCode: Locale;
  tipScheme?: Maybe<TipScheme>;
  supportsGiftAid: Scalars['Boolean'];
  isBbms: Scalars['Boolean'];
  displayHideAmountOption: Scalars['Boolean'];
  supportsRecurringPayments?: Maybe<Scalars['Boolean']>;
  sourceUrl?: Maybe<Scalars['URL']>;
  supportsGuest?: Maybe<Scalars['Boolean']>;
  voluntaryContributionConfig?: Maybe<
    Array<Maybe<VoluntaryContributionConfig>>
  >;
  isExternalGiftAidProviderEnabled?: Maybe<Scalars['Boolean']>;
};

export type Fees = {
  __typename?: 'Fees';
  platformFeePercentage?: Maybe<Scalars['Float']>;
  processingFeePercentage?: Maybe<Scalars['Float']>;
};

export type VoluntaryContributionConfig = {
  __typename?: 'VoluntaryContributionConfig';
  from: Scalars['MonetaryValue'];
  to: Scalars['MonetaryValue'];
  valueType: VoluntaryContributionConfigValueType;
  values: Array<Scalars['MonetaryValue']>;
  defaultValue: Scalars['MonetaryValue'];
};

export type SupportedFeatures = {
  __typename?: 'SupportedFeatures';
  guest?: Maybe<Scalars['Boolean']>;
  giftAid?: Maybe<Scalars['Boolean']>;
};

export type Payment = {
  __typename?: 'Payment';
  id: Scalars['ID'];
  type: PaymentType;
  details?: Maybe<PaymentDetails>;
};

export type PaymentDetails = PaymentCard | DirectDebit;

export type DirectDebit = {
  __typename?: 'DirectDebit';
  id: Scalars['ID'];
  accountHolderName: Scalars['String'];
  sortCode: Scalars['String'];
  accountNumber: Scalars['String'];
  dayOfMonth: Scalars['Int'];
  nextPaymentDate: Scalars['DateTime'];
  mandateReference?: Maybe<Scalars['String']>;
  cancelWhenCauseExpires?: Maybe<Scalars['Boolean']>;
};

export type DonationPublicReadModel = {
  __typename?: 'DonationPublicReadModel';
  id: Scalars['String'];
};

export type StartSessionResult = {
  __typename?: 'StartSessionResult';
  id: Scalars['String'];
  createdInCheckoutApi: Scalars['Boolean'];
};

export type SuggestedAmountDescription = {
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type ExternalRef = {
  name?: Maybe<Scalars['String']>;
  ref?: Maybe<Scalars['String']>;
};

export type DonationAmountDetails = {
  donationValue?: Maybe<Scalars['Float']>;
  donationTotal?: Maybe<Scalars['Float']>;
  donationCurrencyCode?: Maybe<Scalars['String']>;
  donationValuePrivacy?: Maybe<Scalars['String']>;
  tipScheme?: Maybe<TipScheme>;
};

export type CrowdfundingPageOwner = {
  name: Scalars['String'];
  emailAddress: Scalars['String'];
};

export type CrowdfundingPageDetails = {
  id: Scalars['String'];
  targetAmount: Scalars['Float'];
  targetCurrencyIsoCode?: Maybe<Scalars['String']>;
  owner?: Maybe<CrowdfundingPageOwner>;
};

export type DonationDeepLinkParameters = {
  isRecurring?: Maybe<Scalars['Boolean']>;
  supportsGiftAid?: Maybe<Scalars['Boolean']>;
  skipGiftAid?: Maybe<Scalars['Boolean']>;
  supportsGuest?: Maybe<Scalars['Boolean']>;
  suggestedAmounts?: Maybe<Array<Maybe<Scalars['Float']>>>;
  suggestedAmountDescriptions?: Maybe<Array<Maybe<SuggestedAmountDescription>>>;
  supportedCurrencies?: Maybe<Array<Maybe<Scalars['String']>>>;
  paymentMethod?: Maybe<Scalars['String']>;
  donationAmount?: Maybe<DonationAmountDetails>;
  displayHideAmount?: Maybe<Scalars['Boolean']>;
};

export type DonationRequestUris = {
  successUri: Scalars['String'];
  failureUri: Scalars['String'];
  exitUri: Scalars['String'];
};

export type StartDonationInput = {
  causeRef?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  referralCode?: Maybe<Scalars['String']>;
  uris: DonationRequestUris;
  additionalData?: Maybe<Scalars['String']>;
  deepLinkParameters?: Maybe<DonationDeepLinkParameters>;
  externalRefs: Array<ExternalRef>;
  crowdfundingPageDetails?: Maybe<CrowdfundingPageDetails>;
};

export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
}

export type DiscoverPersistedPages = {
  __typename?: 'DiscoverPersistedPages';
  nodes: Array<Page>;
};

export type DiscoverItem = {
  __typename?: 'DiscoverItem';
  id: Scalars['Int'];
  position: Scalars['Int'];
  linkUrl: Scalars['String'];
  imageSrc: Scalars['String'];
  pageGuid: Scalars['String'];
  pageType: Scalars['String'];
  pageTitle: Scalars['String'];
  userImageSrc: Scalars['String'];
  username: Scalars['String'];
};

export type DonationSummary = {
  __typename?: 'DonationSummary';
  totalAmount?: Maybe<MonetaryAmount>;
  totalMatched: Array<DonationMatch>;
  onlineAmount?: Maybe<MonetaryAmount>;
  offlineAmount?: Maybe<MonetaryAmount>;
  textDonations?: Maybe<MonetaryAmount>;
  directDonationAmount?: Maybe<MonetaryAmount>;
  fundraiserRaisedAmount?: Maybe<MonetaryAmount>;
  donationCount?: Maybe<Scalars['Int']>;
  aggregatedDonationsCount?: Maybe<Scalars['Int']>;
  onlineDonationCount?: Maybe<Scalars['Int']>;
  offlineDonationCount?: Maybe<Scalars['Int']>;
  fundraiserDonationsCount?: Maybe<Scalars['Int']>;
};

export type DonationConnection = {
  __typename?: 'DonationConnection';
  edges: Array<DonationEdge>;
  nodes: Array<Donation>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type DonationEdge = {
  __typename?: 'DonationEdge';
  cursor: Scalars['String'];
  node: Donation;
  direct: Scalars['Boolean'];
};

export type Donation = {
  __typename?: 'Donation';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  creationDate: Scalars['DateTime'];
  displayName: Scalars['String'];
  amount?: Maybe<MonetaryAmount>;
  giftAidAmount?: Maybe<MonetaryAmount>;
  donationReference?: Maybe<Scalars['Int']>;
  avatar?: Maybe<Scalars['URL']>;
  message?: Maybe<Scalars['String']>;
  matches: Array<DonationMatch>;
  pageOwnerReaction?: Maybe<Reaction>;
  pageName?: Maybe<Scalars['String']>;
  beneficiary?: Maybe<Scalars['String']>;
};

export type DonationMatch = {
  __typename?: 'DonationMatch';
  type: DonationMatchType;
  amount: MonetaryAmount;
};

export type Reaction = {
  __typename?: 'Reaction';
  message: Scalars['String'];
};

export type DonorDonationSummary = {
  __typename?: 'DonorDonationSummary';
  totalAmount?: Maybe<MonetaryAmount>;
  totalGiftAidAmount?: Maybe<MonetaryAmount>;
};

export enum PageType {
  Crowdfunding = 'CROWDFUNDING',
  Fundraising = 'FUNDRAISING',
  Team = 'TEAM',
  Campaign = 'CAMPAIGN',
  Charity = 'CHARITY',
  Event = 'EVENT',
  Company = 'COMPANY',
  OnePage = 'ONE_PAGE',
  InMemory = 'IN_MEMORY',
}

export enum PageStatus {
  Hidden = 'HIDDEN',
  Active = 'ACTIVE',
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
  Offline = 'OFFLINE',
  PendingApproval = 'PENDING_APPROVAL',
  Inactive = 'INACTIVE',
  Scheduled = 'SCHEDULED',
  Draft = 'DRAFT',
}

export enum DonationMatchType {
  GiftAid = 'GIFT_AID',
  CompanyContribution = 'COMPANY_CONTRIBUTION',
}

export enum AccountConnectionStatus {
  Unfunded = 'UNFUNDED',
  Initialised = 'INITIALISED',
  Reminded = 'REMINDED',
  Frozen = 'FROZEN',
  ElevatedFrozen = 'ELEVATED_FROZEN',
  PseudoSuspended = 'PSEUDO_SUSPENDED',
  Deactivated = 'DEACTIVATED',
  Connected = 'CONNECTED',
  Verified = 'VERIFIED',
  PendingVerification = 'PENDING_VERIFICATION',
  ManualVerification = 'MANUAL_VERIFICATION',
}

export enum WithdrawalStatus {
  Processing = 'PROCESSING',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
}

export enum TimelineEntryType {
  Manual = 'MANUAL',
  Fitness = 'FITNESS',
}

export enum MeasurementSystem {
  Metric = 'METRIC',
  Imperial = 'IMPERIAL',
}

export enum DeleteStatus {
  Success = 'SUCCESS',
  Fail = 'FAIL',
}

export enum DistanceUnit {
  Metres = 'METRES',
  Feet = 'FEET',
}

export enum TimeUnit {
  Milliseconds = 'MILLISECONDS',
  Seconds = 'SECONDS',
}

export enum StepsUnit {
  Steps = 'STEPS',
}

export enum PageRelationshipType {
  RaisesMoneyFor = 'RAISES_MONEY_FOR',
  HasBeneficiary = 'HAS_BENEFICIARY',
  PromotesEvent = 'PROMOTES_EVENT',
  PromotedByCampaign = 'PROMOTED_BY_CAMPAIGN',
  ParticipatesIn = 'PARTICIPATES_IN',
}

export enum PageBeneficiaryType {
  Charity = 'CHARITY',
}

export enum PageTotalsDisplayOptions {
  DoNotDisplay = 'DO_NOT_DISPLAY',
  TimelineOnly = 'TIMELINE_ONLY',
}

export enum LivestreamMediaPlatform {
  Twitch = 'TWITCH',
  Youtube = 'YOUTUBE',
}

export enum VideoMediaPlatform {
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE',
}

export enum ProductType {
  Birthday = 'BIRTHDAY',
  Campaign = 'CAMPAIGN',
  Team = 'TEAM',
  SitebuilderFundraising = 'SITEBUILDER_FUNDRAISING',
  Fundraising = 'FUNDRAISING',
}

export enum Locale {
  /** Andorra = AD */
  Ad = 'AD',
  /** United Arab Emirates = AE */
  Ae = 'AE',
  /** Afghanistan = AF */
  Af = 'AF',
  /** Antigua And Barbuda = AG */
  Ag = 'AG',
  /** Anguilla = AI */
  Ai = 'AI',
  /** Albania = AL */
  Al = 'AL',
  /** Armenia = AM */
  Am = 'AM',
  /** Netherlands Antilles = AN */
  An = 'AN',
  /** Angola = AO */
  Ao = 'AO',
  /** Antarctica = AQ */
  Aq = 'AQ',
  /** Argentina = AR */
  Ar = 'AR',
  /** American Samoa = AS */
  As = 'AS',
  /** Austria = AT */
  At = 'AT',
  /** Australia = AU */
  Au = 'AU',
  /** Aruba = AW */
  Aw = 'AW',
  /** Aland Islands = AX */
  Ax = 'AX',
  /** Azerbaijan = AZ */
  Az = 'AZ',
  /** Bosnia And Herzegovina = BA */
  Ba = 'BA',
  /** Barbados = BB */
  Bb = 'BB',
  /** Bangladesh = BD */
  Bd = 'BD',
  /** Belgium = BE */
  Be = 'BE',
  /** Burkina Faso = BF */
  Bf = 'BF',
  /** Bulgaria = BG */
  Bg = 'BG',
  /** Bahrain = BH */
  Bh = 'BH',
  /** Burundi = BI */
  Bi = 'BI',
  /** Benin = BJ */
  Bj = 'BJ',
  /** Saint Barthélemy = BL */
  Bl = 'BL',
  /** Bermuda = BM */
  Bm = 'BM',
  /** Brunei = BN */
  Bn = 'BN',
  /** Bolivia = BO */
  Bo = 'BO',
  /** Caribbean Netherlands = BQ */
  Bq = 'BQ',
  /** Brazil = BR */
  Br = 'BR',
  /** Bahamas = BS */
  Bs = 'BS',
  /** Bhutan = BT */
  Bt = 'BT',
  /** Bouvet Island = BV */
  Bv = 'BV',
  /** Botswana = BW */
  Bw = 'BW',
  /** Belarus = BY */
  By = 'BY',
  /** Belize = BZ */
  Bz = 'BZ',
  /** Canada = CA */
  Ca = 'CA',
  /** Cocos (Keeling) Islands = CC */
  Cc = 'CC',
  /** Congo, The Democratic Republic Of The = CD */
  Cd = 'CD',
  /** Central African Republic = CF */
  Cf = 'CF',
  /** Congo = CG */
  Cg = 'CG',
  /** Switzerland = CH */
  Ch = 'CH',
  /** Côte d'Ivoire = CI */
  Ci = 'CI',
  /** Cook Islands = CK */
  Ck = 'CK',
  /** Chile = CL */
  Cl = 'CL',
  /** Republic of Cameroon = CM */
  Cm = 'CM',
  /** China = CN */
  Cn = 'CN',
  /** Colombia = CO */
  Co = 'CO',
  /** Costa Rica = CR */
  Cr = 'CR',
  /** Cuba = CU */
  Cu = 'CU',
  /** Cape Verde = CV */
  Cv = 'CV',
  /** Curaçao = CW */
  Cw = 'CW',
  /** Christmas Island = CX */
  Cx = 'CX',
  /** Cyprus = CY */
  Cy = 'CY',
  /** Czech Republic = CZ */
  Cz = 'CZ',
  /** Germany = DE */
  De = 'DE',
  /** Djibouti = DJ */
  Dj = 'DJ',
  /** Denmark = DK */
  Dk = 'DK',
  /** Dominica = DM */
  Dm = 'DM',
  /** Dominican Republic = DO */
  Do = 'DO',
  /** Algeria = DZ */
  Dz = 'DZ',
  /** Ecuador = EC */
  Ec = 'EC',
  /** Estonia = EE */
  Ee = 'EE',
  /** Egypt = EG */
  Eg = 'EG',
  /** Western Sahara = EH */
  Eh = 'EH',
  /** Eritrea = ER */
  Er = 'ER',
  /** Spain = ES */
  Es = 'ES',
  /** Ethiopia = ET */
  Et = 'ET',
  /** Finland = FI */
  Fi = 'FI',
  /** Fiji = FJ */
  Fj = 'FJ',
  /** Falkland Islands (Malvinas) = FK */
  Fk = 'FK',
  /** Micronesia, Federated States of = FM */
  Fm = 'FM',
  /** Faroe Islands = FO */
  Fo = 'FO',
  /** France = FR */
  Fr = 'FR',
  /** Gabon = GA */
  Ga = 'GA',
  /** United Kingdom = GB */
  Gb = 'GB',
  /** Grenada = GD */
  Gd = 'GD',
  /** Georgia = GE */
  Ge = 'GE',
  /** French Guiana = GF */
  Gf = 'GF',
  /** Guernsey = GG */
  Gg = 'GG',
  /** Ghana = GH */
  Gh = 'GH',
  /** Gibraltar = GI */
  Gi = 'GI',
  /** Greenland = GL */
  Gl = 'GL',
  /** Gambia = GM */
  Gm = 'GM',
  /** Guinea = GN */
  Gn = 'GN',
  /** Guadeloupe = GP */
  Gp = 'GP',
  /** Equatorial Guinea = GQ */
  Gq = 'GQ',
  /** Greece = GR */
  Gr = 'GR',
  /** South Georgia And The South Sandwich Islands = GS */
  Gs = 'GS',
  /** Guatemala = GT */
  Gt = 'GT',
  /** Guam = GU */
  Gu = 'GU',
  /** Guinea Bissau = GW */
  Gw = 'GW',
  /** Guyana = GY */
  Gy = 'GY',
  /** Hong Kong = HK */
  Hk = 'HK',
  /** Heard Island And Mcdonald Islands = HM */
  Hm = 'HM',
  /** Honduras = HN */
  Hn = 'HN',
  /** Croatia = HR */
  Hr = 'HR',
  /** Haiti = HT */
  Ht = 'HT',
  /** Hungary = HU */
  Hu = 'HU',
  /** Indonesia = ID */
  Id = 'ID',
  /** Ireland = IE */
  Ie = 'IE',
  /** Israel = IL */
  Il = 'IL',
  /** Isle Of Man = IM */
  Im = 'IM',
  /** India = IN */
  In = 'IN',
  /** British Indian Ocean Territory = IO */
  Io = 'IO',
  /** Iraq = IQ */
  Iq = 'IQ',
  /** Iran, Islamic Republic Of = IR */
  Ir = 'IR',
  /** Iceland = IS */
  Is = 'IS',
  /** Italy = IT */
  It = 'IT',
  /** Jersey = JE */
  Je = 'JE',
  /** Jamaica = JM */
  Jm = 'JM',
  /** Jordan = JO */
  Jo = 'JO',
  /** Japan = JP */
  Jp = 'JP',
  /** Kenya = KE */
  Ke = 'KE',
  /** Kyrgyzstan = KG */
  Kg = 'KG',
  /** Cambodia = KH */
  Kh = 'KH',
  /** Kiribati = KI */
  Ki = 'KI',
  /** Comoros = KM */
  Km = 'KM',
  /** Saint Kitts And Nevis = KN */
  Kn = 'KN',
  /** Korea, Democratic People's Republic Of = KP */
  Kp = 'KP',
  /** South Korea = KR */
  Kr = 'KR',
  /** Kuwait = KW */
  Kw = 'KW',
  /** Cayman Islands = KY */
  Ky = 'KY',
  /** Kazakhstan = KZ */
  Kz = 'KZ',
  /** Lao People's Democratic Republic = LA */
  La = 'LA',
  /** Lebanon = LB */
  Lb = 'LB',
  /** Saint Lucia = LC */
  Lc = 'LC',
  /** Liechtenstein = LI */
  Li = 'LI',
  /** Sri Lanka = LK */
  Lk = 'LK',
  /** Liberia = LR */
  Lr = 'LR',
  /** Lesotho = LS */
  Ls = 'LS',
  /** Lithuania = LT */
  Lt = 'LT',
  /** Luxembourg = LU */
  Lu = 'LU',
  /** Latvia = LV */
  Lv = 'LV',
  /** Libyan Arab Jamahiriya = LY */
  Ly = 'LY',
  /** Morocco = MA */
  Ma = 'MA',
  /** Monaco = MC */
  Mc = 'MC',
  /** Moldova, Republic of = MD */
  Md = 'MD',
  /** Montenegro = ME */
  Me = 'ME',
  /** Saint Martin = MF */
  Mf = 'MF',
  /** Madagascar = MG */
  Mg = 'MG',
  /** Marshall Islands, Republic of the = MH */
  Mh = 'MH',
  /** North Macedonia = MK */
  Mk = 'MK',
  /** Mali = ML */
  Ml = 'ML',
  /** Myanmar = MM */
  Mm = 'MM',
  /** Mongolia = MN */
  Mn = 'MN',
  /** Macao = MO */
  Mo = 'MO',
  /** Northern Mariana Islands = MP */
  Mp = 'MP',
  /** Martinique = MQ */
  Mq = 'MQ',
  /** Mauritania = MR */
  Mr = 'MR',
  /** Montserrat = MS */
  Ms = 'MS',
  /** Malta = MT */
  Mt = 'MT',
  /** Mauritius = MU */
  Mu = 'MU',
  /** Maldives = MV */
  Mv = 'MV',
  /** Malawi = MW */
  Mw = 'MW',
  /** Mexico = MX */
  Mx = 'MX',
  /** Malaysia = MY */
  My = 'MY',
  /** Mozambique = MZ */
  Mz = 'MZ',
  /** Namibia = NA */
  Na = 'NA',
  /** New Caledonia = NC */
  Nc = 'NC',
  /** Niger = NE */
  Ne = 'NE',
  /** Norfolk Island = NF */
  Nf = 'NF',
  /** Nigeria = NG */
  Ng = 'NG',
  /** Nicaragua = NI */
  Ni = 'NI',
  /** Netherlands = NL */
  Nl = 'NL',
  /** Norway = NO */
  No = 'NO',
  /** Nepal = NP */
  Np = 'NP',
  /** Nauru = NR */
  Nr = 'NR',
  /** Niue = NU */
  Nu = 'NU',
  /** New Zealand = NZ */
  Nz = 'NZ',
  /** Oman = OM */
  Om = 'OM',
  /** Panama = PA */
  Pa = 'PA',
  /** Peru = PE */
  Pe = 'PE',
  /** French Polynesia = PF */
  Pf = 'PF',
  /** Papua New Guinea = PG */
  Pg = 'PG',
  /** Philippines = PH */
  Ph = 'PH',
  /** Pakistan = PK */
  Pk = 'PK',
  /** Poland = PL */
  Pl = 'PL',
  /** Saint Pierre And Miquelon = PM */
  Pm = 'PM',
  /** Pitcairn = PN */
  Pn = 'PN',
  /** Puerto Rico = PR */
  Pr = 'PR',
  /** Palestinian Territory, Occupied = PS */
  Ps = 'PS',
  /** Portugal = PT */
  Pt = 'PT',
  /** Palau, Republic of = PW */
  Pw = 'PW',
  /** Paraguay = PY */
  Py = 'PY',
  /** Qatar = QA */
  Qa = 'QA',
  /** Reunion = RE */
  Re = 'RE',
  /** Romania = RO */
  Ro = 'RO',
  /** Serbia = RS */
  Rs = 'RS',
  /** Russia = RU */
  Ru = 'RU',
  /** Rwanda = RW */
  Rw = 'RW',
  /** Saudi Arabia = SA */
  Sa = 'SA',
  /** Solomon Islands = SB */
  Sb = 'SB',
  /** Seychelles = SC */
  Sc = 'SC',
  /** Sudan = SD */
  Sd = 'SD',
  /** Sweden = SE */
  Se = 'SE',
  /** Singapore = SG */
  Sg = 'SG',
  /** Saint Helena = SH */
  Sh = 'SH',
  /** Slovenia = SI */
  Si = 'SI',
  /** Svalbard And Jan Mayen = SJ */
  Sj = 'SJ',
  /** Slovakia = SK */
  Sk = 'SK',
  /** Sierra Leone = SL */
  Sl = 'SL',
  /** San Marino = SM */
  Sm = 'SM',
  /** Senegal = SN */
  Sn = 'SN',
  /** Somalia = SO */
  So = 'SO',
  /** Suriname = SR */
  Sr = 'SR',
  /** South Sudan = SS */
  Ss = 'SS',
  /** Sao Tome And Principe = ST */
  St = 'ST',
  /** El Salvador = SV */
  Sv = 'SV',
  /** Sint Maarten = SX */
  Sx = 'SX',
  /** Syria = SY */
  Sy = 'SY',
  /** Eswatini = SZ */
  Sz = 'SZ',
  /** Turks and Caicos Islands = TC */
  Tc = 'TC',
  /** Chad = TD */
  Td = 'TD',
  /** French Southern Territories = TF */
  Tf = 'TF',
  /** Togo = TG */
  Tg = 'TG',
  /** Thailand = TH */
  Th = 'TH',
  /** Tajikistan = TJ */
  Tj = 'TJ',
  /** Tokelau = TK */
  Tk = 'TK',
  /** Timor Leste = TL */
  Tl = 'TL',
  /** Turkmenistan = TM */
  Tm = 'TM',
  /** Tunisia = TN */
  Tn = 'TN',
  /** Tonga = TO */
  To = 'TO',
  /** Turkey = TR */
  Tr = 'TR',
  /** Trinidad and Tobago = TT */
  Tt = 'TT',
  /** Tuvalu = TV */
  Tv = 'TV',
  /** Taiwan = TW */
  Tw = 'TW',
  /** Tanzania, United Republic Of = TZ */
  Tz = 'TZ',
  /** Ukraine = UA */
  Ua = 'UA',
  /** Uganda = UG */
  Ug = 'UG',
  /** United States Minor Outlying Islands = UM */
  Um = 'UM',
  /** United States = US */
  Us = 'US',
  /** Uruguay = UY */
  Uy = 'UY',
  /** Uzbekistan = UZ */
  Uz = 'UZ',
  /** Holy See (Vatican City State) = VA */
  Va = 'VA',
  /** St. Vincent = VC */
  Vc = 'VC',
  /** Venezuela = VE */
  Ve = 'VE',
  /** Virgin Islands, British = VG */
  Vg = 'VG',
  /** Virgin Islands, United States = VI */
  Vi = 'VI',
  /** Vietnam = VN */
  Vn = 'VN',
  /** Vanuatu = VU */
  Vu = 'VU',
  /** Wallis And Futuna = WF */
  Wf = 'WF',
  /** Samoa = WS */
  Ws = 'WS',
  /** Kosovo = XK */
  Xk = 'XK',
  /** Yemen = YE */
  Ye = 'YE',
  /** Mayotte = YT */
  Yt = 'YT',
  /** South Africa = ZA */
  Za = 'ZA',
  /** Zambia = ZM */
  Zm = 'ZM',
  /** Zimbabwe = ZW */
  Zw = 'ZW',
}

export enum LineItemType {
  DonationCrowdfunding = 'DonationCrowdfunding',
  DonationCharityFrp = 'DonationCharityFRP',
  DonationCharityDirect = 'DonationCharityDirect',
  DonationCampaignDirect = 'DonationCampaignDirect',
  DonationCampaignFrp = 'DonationCampaignFRP',
}

export enum TransactingUserType {
  Guest = 'Guest',
  LoggedIn = 'LoggedIn',
}

export enum CardType {
  Mastercard = 'Mastercard',
  Visa = 'Visa',
  AmericanExpress = 'AmericanExpress',
  Unknown = 'Unknown',
}

export enum PointsScheme {
  AmexPayWithPoints = 'AmexPayWithPoints',
}

export enum AcceptedCurrencyCode {
  Gbp = 'GBP',
  Usd = 'USD',
  Aud = 'AUD',
  Cad = 'CAD',
  Eur = 'EUR',
  Nzd = 'NZD',
}

export enum TipScheme {
  Dpf1_2 = 'Dpf1_2',
  Dpf1_1 = 'Dpf1_1',
  TipJar2_3 = 'TipJar2_3',
  TipJar2_2 = 'TipJar2_2',
  TipJar2_1 = 'TipJar2_1',
  Disabled = 'Disabled',
}

export enum PaymentType {
  PaymentCard = 'PaymentCard',
  DirectDebit = 'DirectDebit',
  BraintreePayPal = 'BraintreePayPal',
  BraintreeApplePay = 'BraintreeApplePay',
  BraintreeGooglePay = 'BraintreeGooglePay',
  AmexPayWithBank = 'AmexPayWithBank',
  RecurringPaymentCard = 'RecurringPaymentCard',
  BraintreeVenmo = 'BraintreeVenmo',
}

export enum VoluntaryContributionConfigValueType {
  Amount = 'Amount',
  Percentage = 'Percentage',
}

export enum TransactionStatus {
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  Declined = 'Declined',
}

export enum EntityType {
  Charity = 'Charity',
  Corporate = 'Corporate',
  JustGiving = 'JustGiving',
  Fundraiser = 'Fundraiser',
}

export enum PaymentServiceProvider {
  Braintree = 'Braintree',
}

export enum DeviceType {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
}

export enum WalletPaymentType {
  BraintreePayPal = 'BraintreePayPal',
  BraintreeGooglePay = 'BraintreeGooglePay',
  BraintreeApplePay = 'BraintreeApplePay',
  BraintreeVenmo = 'BraintreeVenmo',
}

export type Event = Node & {
  __typename?: 'Event';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  visible: Scalars['Boolean'];
  activities?: Maybe<Array<FitnessApplicationActivityType>>;
  externalFitnessSources?: Maybe<Array<ExternalFitnessSources>>;
  allowManualActivities?: Maybe<Scalars['Boolean']>;
  fundraiserGoals?: Maybe<Array<Goal>>;
};

export type EventConnection = {
  __typename?: 'EventConnection';
  edges: Array<EventEdge>;
  nodes: Array<Event>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String'];
  node: Event;
};

export type CreateEventInput = {
  title: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  activities: Array<FitnessApplicationActivityType>;
  externalFitnessSources: Array<ExternalFitnessSources>;
  allowManualActivities: Scalars['Boolean'];
  fundraiserFitnessGoal: FitnessGoalInput;
  campaignId?: Maybe<Scalars['String']>;
};

export type ConnectFitnessInput = {
  code?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
};

export type TimelineEntry = Node & {
  __typename?: 'TimelineEntry';
  fitnessActivity?: Maybe<FitnessActivity>;
  refreshRequestedTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  media?: Maybe<Array<Media>>;
  type: TimelineEntryType;
  createdAt?: Maybe<Scalars['DateTime']>;
  publishingSource?: Maybe<PublishingSource>;
};

export type FitnessActivity = {
  __typename?: 'FitnessActivity';
  /** @deprecated Use `activityId` as it matches the property name of the model and `id` can be confused as a `Node.ID`. */
  id?: Maybe<Scalars['String']>;
  activityId?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  activityType?: Maybe<FitnessApplicationActivityType>;
  mapPolyline?: Maybe<Scalars['String']>;
  distance?: Maybe<Distance>;
  elevation?: Maybe<Distance>;
  duration?: Maybe<Duration>;
  steps?: Maybe<Scalars['Int']>;
};

export type FitnessActivityDistanceArgs = {
  measurementSystem?: Maybe<MeasurementSystem>;
};

export type FitnessActivityElevationArgs = {
  measurementSystem?: Maybe<MeasurementSystem>;
};

export type FitnessActivityDurationArgs = {
  unit?: Maybe<TimeUnit>;
};

export type Distance = {
  __typename?: 'Distance';
  unit: DistanceUnit;
  value: Scalars['FixedFloat'];
};

export type Duration = {
  __typename?: 'Duration';
  unit: TimeUnit;
  value: Scalars['FixedFloat'];
};

export type Steps = {
  __typename?: 'Steps';
  unit: StepsUnit;
  value: Scalars['Int'];
};

export type FitnessActivityInput = {
  title: Scalars['String'];
  activityType: FitnessApplicationActivityType;
  mapPolyline?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['FixedFloat']>;
  elevation?: Maybe<Scalars['FixedFloat']>;
  duration?: Maybe<Scalars['FixedFloat']>;
  steps?: Maybe<Scalars['Int']>;
};

export enum ExternalFitnessSources {
  StravaAuto = 'STRAVA_AUTO',
  StravaManual = 'STRAVA_MANUAL',
}

export enum PublishingSource {
  Manual = 'MANUAL',
  Strava = 'STRAVA',
  Fitbit = 'FITBIT',
}

export type Strava = {
  __typename?: 'Strava';
  isConnected?: Maybe<Scalars['Boolean']>;
};

export type Fitbit = {
  __typename?: 'Fitbit';
  isConnected?: Maybe<Scalars['Boolean']>;
};

export type Account = {
  __typename?: 'Account';
  startDate?: Maybe<Scalars['DateTime']>;
  connectionStatus: AccountConnectionStatus;
  timeRemaining?: Maybe<AccountConnectionTimeline>;
};

export type Funds = {
  __typename?: 'Funds';
  accounts?: Maybe<Array<Account>>;
  withdrawals?: Maybe<WithdrawalConnection>;
};

export type FundsInput = {
  type?: Maybe<PageType>;
  slug?: Maybe<Scalars['Slug']>;
};

export type Withdrawal = {
  __typename?: 'Withdrawal';
  gross: MonetaryAmount;
  net: MonetaryAmount;
  platformFee: MonetaryAmount;
  processingFee: MonetaryAmount;
  status: WithdrawalStatus;
  completionDate?: Maybe<Scalars['DateTime']>;
  requestDate: Scalars['DateTime'];
};

export type WithdrawalConnection = {
  __typename?: 'WithdrawalConnection';
  nodes?: Maybe<Array<Withdrawal>>;
  status?: Maybe<Scalars['String']>;
  availabilityDate?: Maybe<Scalars['DateTime']>;
  totalAvailable: MonetaryAmount;
  totalWithdrawn: MonetaryAmount;
};

export type AccountConnectionTimeline = {
  __typename?: 'AccountConnectionTimeline';
  next?: Maybe<TimeRemaining>;
  final?: Maybe<TimeRemaining>;
};

export type TimeRemaining = {
  __typename?: 'TimeRemaining';
  days?: Maybe<Scalars['Int']>;
};

export type CreateVideoStoryInput = {
  userName: Scalars['String'];
  pageTitle: Scalars['String'];
  pageStatement?: Maybe<Scalars['String']>;
  pageGuid: Scalars['ID'];
  donationTotal: Scalars['Float'];
  currency: Scalars['String'];
  fitness?: Maybe<FitnessTotalsInput>;
  imageUrls: Array<Scalars['String']>;
  charityLogoUrl: Scalars['String'];
};

export type FitnessTotalsInput = {
  total: Scalars['Float'];
  metric: Scalars['String'];
};

export type TimelineEntryInput = {
  test?: Maybe<Scalars['String']>;
};

export type VideoStory = {
  __typename?: 'VideoStory';
  status: Scalars['String'];
  videoUrl?: Maybe<Scalars['String']>;
};

export type Goal = FitnessGoal;

export type FitnessGoal = {
  __typename?: 'FitnessGoal';
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  activities?: Maybe<Array<FitnessApplicationActivityType>>;
  targetMetric?: Maybe<TargetMetric>;
  targetAmount?: Maybe<Scalars['Float']>;
  unitOfMeasure?: Maybe<UnitOfMeasure>;
};

export type FitnessGoalInput = {
  targetAmount?: Maybe<Scalars['Float']>;
  unitOfMeasure: UnitOfMeasure;
};

export enum TargetMetric {
  Distance = 'DISTANCE',
  Elevation = 'ELEVATION',
  Duration = 'DURATION',
}

export enum UnitOfMeasure {
  Metres = 'METRES',
  Kilometres = 'KILOMETRES',
  Feet = 'FEET',
  Miles = 'MILES',
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  FeetClimbed = 'FEET_CLIMBED',
  MetresClimbed = 'METRES_CLIMBED',
}

/** Marks an entity as being fetchable by its ID. */
export type Node = {
  id: Scalars['ID'];
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  id: Scalars['LeaderboardId'];
  definition?: Maybe<LeaderboardDefinition>;
  totals: Array<LeaderboardTotal>;
};

export type LeaderboardTotalsArgs = {
  limit?: Maybe<Scalars['Int']>;
};

export type LeaderboardDefinition = {
  __typename?: 'LeaderboardDefinition';
  segment: Scalars['String'];
  measurementDomain: Scalars['String'];
  measurementDomains: Array<Scalars['String']>;
  primaryUnit: Scalars['String'];
  tagDefinition: TagDefinition;
  conditions: Array<Tag>;
};

export type LeaderboardTotal = {
  __typename?: 'LeaderboardTotal';
  tagValue: Scalars['String'];
  tagValueAsNode?: Maybe<Node>;
  amounts: Array<TotalAmount>;
};

export type Lifecycle = {
  __typename?: 'Lifecycle';
  status?: Maybe<LifecycleStatus>;
  allowedActions?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedDate?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
};

export enum LifecycleStatus {
  Draft = 'DRAFT',
  Live = 'LIVE',
  Completed = 'COMPLETED',
  Cancelled = 'CANCELLED',
}

export type Livestream = {
  __typename?: 'Livestream';
  pageType?: Maybe<PageType>;
  mediaId: Scalars['String'];
  pageId: Scalars['String'];
  entries?: Maybe<Array<Maybe<LivestreamEntries>>>;
};

export type LivestreamMetaData = {
  __typename?: 'LivestreamMetaData';
  pageType?: Maybe<PageType>;
  mediaId: Scalars['String'];
  pageId: Scalars['String'];
  streamUserId: Scalars['String'];
  streamUrl: Scalars['String'];
  streamTitle: Scalars['String'];
  streamPreview: Scalars['String'];
  streamDescription: Scalars['String'];
  pageUrl: Scalars['String'];
  viewerCount: Scalars['Int'];
  isLive: Scalars['Boolean'];
};

export type LivestreamEntries = {
  __typename?: 'LivestreamEntries';
  mediaType?: Maybe<Scalars['String']>;
  streamId?: Maybe<Scalars['String']>;
  streamType?: Maybe<Scalars['String']>;
  positionId?: Maybe<Scalars['Int']>;
  isLive?: Maybe<Scalars['Boolean']>;
};

export type CreateLivestreamInput = {
  pageType: PageType;
  pageId: Scalars['String'];
  streamType: Scalars['String'];
  streamId: Scalars['String'];
};

export type DeleteLivestreamInput = {
  mediaId: Scalars['String'];
  pageId: Scalars['String'];
  positionId: Scalars['Int'];
};

export type UpdateLivestreamInput = {
  pageId: Scalars['String'];
  streamType: Scalars['String'];
  streamId: Scalars['String'];
  positionId: Scalars['Int'];
};

export type MediaConnection = {
  __typename?: 'MediaConnection';
  edges: Array<MediaEdge>;
  nodes: Array<Media>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type MediaEdge = {
  __typename?: 'MediaEdge';
  cursor: Scalars['String'];
  node: Media;
};

export type Media = ImageMedia | VideoMedia | LivestreamMedia;

export type ImageMedia = Node & {
  __typename?: 'ImageMedia';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['URL']>;
  caption?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
};

export type VideoMedia = Node & {
  __typename?: 'VideoMedia';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['URL']>;
  posterUrl?: Maybe<Scalars['URL']>;
  /** @deprecated Use `videoPlatform` with the type VideoMediaPlatform */
  platform?: Maybe<Scalars['String']>;
  videoPlatform?: Maybe<VideoMediaPlatform>;
  videoId?: Maybe<Scalars['String']>;
};

export type LivestreamMedia = Node & {
  __typename?: 'LivestreamMedia';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['URL']>;
  posterUrl?: Maybe<Scalars['URL']>;
  /** @deprecated Use `streamPlatform` with the type LivestreamMediaPlatform */
  platform?: Maybe<Scalars['String']>;
  streamPlatform?: Maybe<LivestreamMediaPlatform>;
  streamId?: Maybe<Scalars['String']>;
};

export type MediaCollectionInput = {
  imageMedia?: Maybe<Array<ImageMediaInput>>;
  videoMedia?: Maybe<Array<VideoMediaInput>>;
};

export type MediaItemInput = {
  imageMedia?: Maybe<ImageMediaInput>;
  videoMedia?: Maybe<VideoMediaInput>;
  livestreamMedia?: Maybe<LivestreamMediaInput>;
};

export type ImageMediaInput = {
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['URL']>;
  caption?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  isHero?: Maybe<Scalars['Boolean']>;
};

export type VideoMediaInput = {
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['URL']>;
  platform?: Maybe<VideoMediaPlatform>;
  videoPlatform?: Maybe<VideoMediaPlatform>;
  videoId?: Maybe<Scalars['ID']>;
  isHero?: Maybe<Scalars['Boolean']>;
};

export type LivestreamMediaInput = {
  id?: Maybe<Scalars['ID']>;
  platform?: Maybe<LivestreamMediaPlatform>;
  streamPlatform?: Maybe<LivestreamMediaPlatform>;
  streamId: Scalars['ID'];
  alt?: Maybe<Scalars['String']>;
  isHero?: Maybe<Scalars['Boolean']>;
};

export type DeleteMediaItemInput = {
  itemId: Scalars['ID'];
  pageId: Scalars['ID'];
  type: PageType;
};

export type DeleteMediaItemPayload = {
  __typename?: 'DeleteMediaItemPayload';
  itemId: Scalars['String'];
};

export type AddMediaItemInput = {
  pageId: Scalars['ID'];
  media: MediaItemInput;
  type: PageType;
};

export type AddMediaItemPayload = {
  __typename?: 'AddMediaItemPayload';
  itemId: Scalars['String'];
};

export type Meta = {
  __typename?: 'Meta';
  releaseVersion: Scalars['String'];
};

export type OfflineDonation = Node & {
  __typename?: 'OfflineDonation';
  id: Scalars['ID'];
  amount: Scalars['MonetaryValue'];
  currency: Scalars['CurrencyCode'];
  displayName?: Maybe<Scalars['String']>;
  legacyId: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  dateCreated: Scalars['DateTime'];
};

export type CreateOfflineDonationInput = {
  amount: Scalars['MonetaryValue'];
  currency: Scalars['CurrencyCode'];
  displayName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  pageId: Scalars['String'];
};

export type DeleteOfflineDonationInput = {
  pageId: Scalars['String'];
  offlineDonationId: Scalars['String'];
};

export type EditOfflineDonationInput = {
  offlineDonationId: Scalars['String'];
  amount: Scalars['MonetaryValue'];
  currency: Scalars['CurrencyCode'];
  displayName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  pageId: Scalars['String'];
};

export type OfflineDonationConnection = {
  __typename?: 'OfflineDonationConnection';
  edges: Array<OfflineDonationEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OfflineDonationEdge = {
  __typename?: 'OfflineDonationEdge';
  node: OfflineDonation;
};

export type Page = Node & {
  __typename?: 'Page';
  id: Scalars['ID'];
  legacyId: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  type: PageType;
  slug?: Maybe<Scalars['Slug']>;
  url: Scalars['URL'];
  avatar?: Maybe<Scalars['URL']>;
  logo?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  /** @deprecated Use storyWithType */
  story?: Maybe<Scalars['String']>;
  storyWithType?: Maybe<Story>;
  reason?: Maybe<Reason>;
  joinVerb?: Maybe<Scalars['String']>;
  joinUrl?: Maybe<Scalars['String']>;
  /** @deprecated Use `hero` as it has `imageTitle` so you can set an image Alt. */
  heroImage?: Maybe<Scalars['URL']>;
  /** @deprecated Deprecated Nov 2019 - `hero` has been replaced by `heroMedia`. This allows a media type to be set, and to provide consistency with the `mediaCollection` field */
  hero?: Maybe<Hero>;
  /** @deprecated Deprecated Mar 2021 - `heroMedia` has been replaced by `cover`. This follows the new naming conventions for OnePage. */
  heroMedia?: Maybe<Media>;
  cover?: Maybe<Media>;
  /** @deprecated Use `targetWithCurrency.value` this will evetually become `target.value` */
  target?: Maybe<Scalars['MonetaryValue']>;
  /** @deprecated Use `targetWithCurrency.currencyCode` this will evetually become `target.currencyCode` */
  currency?: Maybe<Scalars['String']>;
  targetWithCurrency?: Maybe<MonetaryAmount>;
  donationSummary?: Maybe<DonationSummary>;
  membershipPolicy?: Maybe<Scalars['String']>;
  status?: Maybe<PageStatus>;
  createDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  launchDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  updateDate?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Location>;
  owner?: Maybe<User>;
  categories?: Maybe<Array<Scalars['String']>>;
  branding?: Maybe<Branding>;
  relationships?: Maybe<PageRelationships>;
  donations?: Maybe<DonationConnection>;
  timeline?: Maybe<TimelineEntryConnection>;
  /** @deprecated Deprecated Mar 2021 - `mediaCollection` has been replaced by `gallery`, which has a more meaningful name and enforces valid pagination args to be passed. */
  mediaCollection?: Maybe<MediaConnection>;
  gallery?: Maybe<MediaConnection>;
  eventGivingGroupId?: Maybe<Scalars['Int']>;
  application?: Maybe<Application>;
  tags?: Maybe<Array<TagValue>>;
  redirectUrl?: Maybe<Scalars['String']>;
  livestream?: Maybe<Livestream>;
  startFundraisingUrl?: Maybe<Scalars['String']>;
  allowFundraising?: Maybe<Scalars['Boolean']>;
  totals?: Maybe<PageTotals>;
  charity?: Maybe<Charity>;
  supportsGiftAid?: Maybe<Scalars['Boolean']>;
  inMemory?: Maybe<InMemory>;
  /** @deprecated Lifecycle will be deleted in the next release. Please use status instead */
  lifecycle?: Maybe<Lifecycle>;
  offlineDonations?: Maybe<OfflineDonationConnection>;
  /** @deprecated Use occasion instead */
  birthday?: Maybe<Birthday>;
  occasion?: Maybe<Occasion>;
  product?: Maybe<Product>;
  fundraisingSettings?: Maybe<FundraisingSettings>;
  leaderboard?: Maybe<PageLeaderboardConnection>;
  isJGPro?: Maybe<Scalars['Boolean']>;
  customCodes?: Maybe<Array<Maybe<CustomCode>>>;
};

export type PageDonationsArgs = {
  direct?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageTimelineArgs = {
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  entryType?: Maybe<TimelineEntryType>;
};

export type PageMediaCollectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageGalleryArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageApplicationArgs = {
  name: Scalars['String'];
  type: ApplicationType;
};

export type PageOfflineDonationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageLeaderboardArgs = {
  type: PageLeaderboardType;
  first: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
};

export type CustomCode = {
  __typename?: 'CustomCode';
  value?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PageLeaderboardConnection = {
  __typename?: 'PageLeaderboardConnection';
  leaderboardId?: Maybe<Scalars['UUID']>;
  edges: Array<PageLeaderboardEdge>;
  nodes: Array<Page>;
  totalCount: Scalars['Int'];
  pageInfo: ForwardOnlyPageInfo;
};

export type PageLeaderboardEdge = {
  __typename?: 'PageLeaderboardEdge';
  node: Page;
  tagValue: Scalars['String'];
  amounts: Array<TotalAmount>;
};

export enum PageLeaderboardType {
  Fundraisers = 'FUNDRAISERS',
  Teams = 'TEAMS',
}

export type FundraisingSettings = {
  __typename?: 'FundraisingSettings';
  defaults: FundraisingDefaults;
  thankYouMessages: Array<Maybe<ThankYouMessage>>;
};

export type FundraisingDefaults = {
  __typename?: 'FundraisingDefaults';
  title?: Maybe<Scalars['String']>;
  story?: Maybe<Story>;
  targetAmount?: Maybe<MonetaryAmount>;
  cover?: Maybe<Media>;
};

export type Product = {
  __typename?: 'Product';
  name: Scalars['String'];
};

export type MonetaryAmountInput = {
  value: Scalars['MonetaryValue'];
  currencyCode: Scalars['CurrencyCode'];
};

export type PageWithId = {
  __typename?: 'PageWithId';
  id: Scalars['ID'];
  legacyId: Scalars['ID'];
};

export type UpdatePagePayload = {
  __typename?: 'UpdatePagePayload';
  page?: Maybe<PageWithId>;
};

export type UpdatePageInput = {
  id: Scalars['ID'];
  type: PageType;
  slug?: Maybe<Scalars['Slug']>;
  story?: Maybe<StoryInput>;
  target?: Maybe<MonetaryAmountInput>;
  title?: Maybe<Scalars['String']>;
  supportsGiftAid?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  image?: Maybe<UpdatePageCoverInput>;
  occasion?: Maybe<OccasionInput>;
  fundraisingSettings?: Maybe<FundraisingSettingsInput>;
};

export type UpdatePageAsStaffInput = {
  id: Scalars['ID'];
  type: PageType;
  slug?: Maybe<Scalars['Slug']>;
  story?: Maybe<StoryInput>;
  target?: Maybe<MonetaryAmountInput>;
  title?: Maybe<Scalars['String']>;
  supportsGiftAid?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  image?: Maybe<UpdatePageCoverInput>;
  occasion?: Maybe<OccasionInput>;
  status?: Maybe<PageStatus>;
};

export type UpdatePreferenceServiceInput = {
  consents?: Maybe<Array<Maybe<ConsentsInput>>>;
  collectionLocationId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transactionTypeId?: Maybe<Scalars['String']>;
};

export type ConsentsInput = {
  consentStatementId?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  consentGiven?: Maybe<Scalars['Boolean']>;
  consentStatementText?: Maybe<Scalars['String']>;
};

export type PreferenceServicePayload = {
  __typename?: 'PreferenceServicePayload';
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

/** Combines a monetary value with a currency code. */
export type MonetaryAmount = {
  __typename?: 'MonetaryAmount';
  value: Scalars['MonetaryValue'];
  currencyCode: Scalars['CurrencyCode'];
};

export type CanParticipateInInput = {
  /** ID of a team to filter by */
  teamId?: Maybe<Scalars['ID']>;
};

export type Location = {
  __typename?: 'Location';
  name?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type DonationPrompt = {
  __typename?: 'DonationPrompt';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Hero = {
  __typename?: 'Hero';
  imageUrl?: Maybe<Scalars['URL']>;
  imageTitle?: Maybe<Scalars['String']>;
};

export type Birthday = {
  __typename?: 'Birthday';
  age?: Maybe<Scalars['Int']>;
  celebrationDate?: Maybe<Scalars['DateTime']>;
};

export type Occasion = {
  __typename?: 'Occasion';
  type: OccasionType;
  date?: Maybe<Scalars['DateTime']>;
  names?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
};

export type InMemory = {
  __typename?: 'InMemory';
  firstNameOfDeceased: Scalars['String'];
  lastNameOfDeceased: Scalars['String'];
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  dateOfDeath?: Maybe<Scalars['DateTime']>;
};

export type LinkPageToCampaignInput = {
  pageSlug: Scalars['String'];
  campaignId: Scalars['String'];
};

export type BirthdayInput = {
  age?: Maybe<Scalars['Int']>;
  celebrationDate?: Maybe<Scalars['DateTime']>;
};

/** A collection of numeric totals captured from the Tags System. */
export type PageTotals = {
  __typename?: 'PageTotals';
  /** Specifies the list of totals to display. */
  displayOptions: PageTotalsDisplayOptions;
  /** Specifies the primary measurement type to display totals in. */
  primaryMeasurementType: Scalars['String'];
  /** A summary of fitness/activity amounts which are present on the page timeline. */
  timeline: Array<PageTotal>;
};

/** A single amount/metric. */
export type PageTotal = {
  __typename?: 'PageTotal';
  /** The description/id of the amount. */
  measurementDomain: Scalars['String'];
  /** Conversions in various units, for the amount. */
  amounts: Array<TotalAmount>;
};

export type CancelPageInput = {
  id: Scalars['ID'];
  type: PageType;
};

export type CreatePageV2Input = {
  product: ProductType;
  slug: Scalars['Slug'];
  title: Scalars['String'];
  storyWithType?: Maybe<StoryInput>;
  target?: Maybe<MonetaryAmountInput>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  beneficiaries: Array<PageBeneficiaryInput>;
  supportsGiftAid: Scalars['Boolean'];
  relationships: Array<PageRelationshipInput>;
  tags: Array<PageTagInput>;
  occasion?: Maybe<OccasionInput>;
  cover?: Maybe<MediaItemInput>;
  summary?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  fundraisingSettings?: Maybe<FundraisingSettingsInput>;
  redirectUrl?: Maybe<Scalars['String']>;
  customCodes?: Maybe<Array<CustomCodeInput>>;
};

export type CustomCodeInput = {
  value?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CreatePageMetadataInput = {
  isJGPro?: Maybe<Scalars['Boolean']>;
  ownerUserGroupGuid?: Maybe<Scalars['String']>;
};

export type FundraisingSettingsInput = {
  isEnabled?: Maybe<Scalars['Boolean']>;
  isBranded?: Maybe<Scalars['Boolean']>;
  isStartFundraisingUrlEnabled?: Maybe<Scalars['Boolean']>;
  startFundraisingUrl?: Maybe<Scalars['String']>;
  isFundraisingPageRedirectEnabled?: Maybe<Scalars['Boolean']>;
  fundraisingPageUrl?: Maybe<Scalars['String']>;
  hasDefaults?: Maybe<Scalars['Boolean']>;
  defaults?: Maybe<FundraisingSettingsDefaultsInput>;
  thankYouMessages?: Maybe<Array<ThankYouMessageInput>>;
};

export type ThankYouMessageInput = {
  message?: Maybe<Scalars['String']>;
  type: ThankYouMessageType;
};

export type ThankYouMessage = {
  __typename?: 'ThankYouMessage';
  message?: Maybe<Scalars['String']>;
  type: ThankYouMessageType;
};

export enum ThankYouMessageType {
  Donation = 'DONATION',
}

export type FundraisingSettingsDefaultsInput = {
  title?: Maybe<Scalars['String']>;
  story?: Maybe<Scalars['String']>;
  targetAmount?: Maybe<Scalars['Int']>;
  heroImage?: Maybe<MediaItemInput>;
};

export type OccasionInput = {
  type: OccasionType;
  date?: Maybe<Scalars['DateTime']>;
  names?: Maybe<Array<Scalars['String']>>;
  description?: Maybe<Scalars['String']>;
};

export enum OccasionType {
  Birthday = 'BIRTHDAY',
  Wedding = 'WEDDING',
  Other = 'OTHER',
}

export type PageRelationshipInput = {
  relatedEntityId: Scalars['String'];
  type: PageRelationshipType;
};

export type PageBeneficiaryInput = {
  id: Scalars['String'];
  type: PageBeneficiaryType;
};

export type PageTagInput = {
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  value: Scalars['String'];
  values?: Maybe<Array<Scalars['String']>>;
};

export type PageCelebrationInput = {
  type: Scalars['String'];
  date: Scalars['DateTime'];
};

export type RelatedPageInput = {
  id: Scalars['ID'];
  type: PageRelationshipType;
};

export type SetPageMediaInput = {
  type: PageType;
  id: Scalars['ID'];
  media?: Maybe<MediaCollectionInput>;
};

export type SetPageMediaPayload = {
  __typename?: 'SetPageMediaPayload';
  page: PageWithId;
};

export type UpdatePageCoverInput = {
  pageType: PageType;
  pageId: Scalars['String'];
  media: MediaItemInput;
};

export type UpdatePageCoverPayload = {
  __typename?: 'UpdatePageCoverPayload';
  cover?: Maybe<Media>;
};

export type UpdatePageGalleryInput = {
  pageType: PageType;
  pageId: Scalars['String'];
  media: MediaCollectionInput;
};

export type UpdatePageGalleryPayload = {
  __typename?: 'UpdatePageGalleryPayload';
  media: Array<Media>;
};

export type PageRelationshipsInput = {
  id: Scalars['ID'];
  beneficiaryIds?: Maybe<Array<Scalars['ID']>>;
  relatedPages?: Maybe<Array<RelatedPageInput>>;
};

export type AssignTagsToChildrenInput = {
  parentId: Scalars['UUID'];
  children?: Maybe<Array<ChildrenInput>>;
};

export type ChildrenInput = {
  pageId: Scalars['UUID'];
  HasTagsAssigned: Scalars['Boolean'];
};

export type CancelPagePayload = {
  __typename?: 'CancelPagePayload';
  page: PageWithId;
};

export type PageRelationshipsPayload = {
  __typename?: 'PageRelationshipsPayload';
  page: PageWithId;
};

export type SetPageLifecyclePayload = {
  __typename?: 'SetPageLifecyclePayload';
  page: PageWithId;
};

/** The connection type for Page. */
export type PageConnection = {
  __typename?: 'PageConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Page>>>;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type PageEdge = {
  __typename?: 'PageEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge. */
  node: Page;
};

export type PageCreatedCountSummaryItem = {
  __typename?: 'PageCreatedCountSummaryItem';
  pageCreatedDate: Scalars['DateTime'];
  pageCreatedCount: Scalars['Int'];
  pageCreatedWithTagsCount?: Maybe<Scalars['Int']>;
  pageCreatedWithoutTagsCount?: Maybe<Scalars['Int']>;
};

/** Pagination page information. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the first edge on the current page. */
  startCursor?: Maybe<Scalars['String']>;
  /** The cursor for the last edge on the current page. */
  endCursor?: Maybe<Scalars['String']>;
  /** `true` if it is possible to navigate to the next page. */
  hasNextPage: Scalars['Boolean'];
  /** `true` if it is possible to navigate to the previous page. */
  hasPreviousPage: Scalars['Boolean'];
};

/** Forward-only pagination page information. */
export type ForwardOnlyPageInfo = {
  __typename?: 'ForwardOnlyPageInfo';
  /** The cursor for the last edge on the current page. */
  endCursor?: Maybe<Scalars['String']>;
  /** `true` if it is possible to navigate to the next page. */
  hasNextPage: Scalars['Boolean'];
};

export type Reason = {
  __typename?: 'Reason';
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Use `description` the naming is more indicative of what it actually is */
  reason?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  reasonUrl?: Maybe<Scalars['String']>;
};

export type ReasonInput = {
  icon?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type PageRelationships = {
  __typename?: 'PageRelationships';
  beneficiaries: BeneficiaryConnection;
  parents: Array<PageRelationship>;
  members: PageRelationshipConnection;
  children: PageRelationshipConnection;
  teams: PageRelationshipConnection;
  events: EventConnection;
  campaigns: PageRelationshipConnection;
  companies: PageRelationshipConnection;
  config?: Maybe<PageRelationshipConfig>;
};

export type PageRelationshipsBeneficiariesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsMembersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsChildrenArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  tagsAssigned?: Maybe<Scalars['Boolean']>;
  createDateFrom?: Maybe<Scalars['String']>;
  createDateTo?: Maybe<Scalars['String']>;
  productName: Scalars['String'];
  limit?: Maybe<Scalars['Int']>;
  searchTerm?: Maybe<Scalars['String']>;
};

export type PageRelationshipsTeamsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsEventsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsCampaignsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationshipsCompaniesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type PageRelationship = {
  __typename?: 'PageRelationship';
  type: PageRelationshipType;
  page?: Maybe<Page>;
};

export type PageRelationshipConnection = {
  __typename?: 'PageRelationshipConnection';
  edges: Array<PageRelationshipEdge>;
  nodes: Array<Page>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type PageRelationshipConfig = {
  __typename?: 'PageRelationshipConfig';
  membersDisabled: Scalars['Boolean'];
};

export type PageRelationshipEdge = {
  __typename?: 'PageRelationshipEdge';
  cursor: Scalars['String'];
  node: Page;
};

export type BeneficiaryConnection = {
  __typename?: 'BeneficiaryConnection';
  edges: Array<BeneficiaryEdge>;
  nodes: Array<BeneficiaryItem>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type BeneficiaryEdge = {
  __typename?: 'BeneficiaryEdge';
  cursor: Scalars['String'];
  node: BeneficiaryItem;
};

export type BeneficiaryItem = Charity | User;

export type Story = {
  __typename?: 'Story';
  type: StoryType;
  content?: Maybe<Scalars['String']>;
};

export type StoryInput = {
  content: Scalars['String'];
  type: StoryType;
};

export enum StoryType {
  RichStoryV1Json = 'RICH_STORY_V1_JSON',
  Plaintext = 'PLAINTEXT',
  Html = 'HTML',
}

export type TagValue = {
  __typename?: 'TagValue';
  tagDefinition: TagDefinition;
  value: Scalars['String'];
  values?: Maybe<Array<Scalars['String']>>;
  aggregation: Array<AggregationRule>;
};

export type TagDefinition = {
  __typename?: 'TagDefinition';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type AggregationRule = {
  __typename?: 'AggregationRule';
  segment: Scalars['String'];
  measurementDomains: Array<Scalars['String']>;
  timeBox?: Maybe<TimeBox>;
};

export type TimeBox = {
  __typename?: 'TimeBox';
  notBefore?: Maybe<Scalars['DateTime']>;
  notAfter?: Maybe<Scalars['DateTime']>;
};

export type TotalAmount = {
  __typename?: 'TotalAmount';
  unit: Scalars['String'];
  value: Scalars['Float'];
};

export type Tag = {
  __typename?: 'Tag';
  tagDefinition: TagDefinition;
  /**
   * Stores the tag value as a single string or csv format for multiple .
   * Tags api accepts either value with valid string and undefined values or value undefined and values as valid array of non empty string.
   */
  value: Scalars['String'];
  /**
   * Values represents an array of assigned string items to the tags value. When assigned it stores a csv format of the array into value.
   * Tags api accepts either value with valid string and undefined values or value undefined and values as valid array of non empty string.
   */
  values?: Maybe<Array<Scalars['String']>>;
};

export type Tasks = {
  __typename?: 'Tasks';
  completed: Array<Maybe<Scalars['String']>>;
};

export type TaskInput = {
  type: PageType;
  id: Scalars['String'];
  key?: Maybe<Scalars['String']>;
};

export type JoinTeamInput = {
  /** ID of the team to join */
  teamId: Scalars['ID'];
  /** ID of a page */
  id: Scalars['ID'];
  /** Type of page */
  type: PageType;
};

export type JoinTeamPayload = {
  __typename?: 'JoinTeamPayload';
  /** The page that is joining */
  page?: Maybe<PageWithId>;
};

export type UnlinkTeamInput = {
  /** ID of the team to unlink */
  teamId: Scalars['ID'];
  /** ID of a page */
  id: Scalars['ID'];
  /** Captain ID of a team */
  captainId?: Maybe<Scalars['ID']>;
  /** Type of page */
  type: PageType;
};

export type UnlinkTeamPayload = {
  __typename?: 'UnlinkTeamPayload';
  /** The page that is unlinking */
  page?: Maybe<PageWithId>;
};

export type CreateTeamInput = {
  name: Scalars['String'];
  targetCurrency?: Maybe<Scalars['String']>;
  relatedPageId?: Maybe<Scalars['UUID']>;
  relatedPageType?: Maybe<PageType>;
  teamShortName?: Maybe<Scalars['String']>;
  teamTarget?: Maybe<Scalars['Int']>;
  story?: Maybe<StoryInput>;
  coverPhotoImageUrl?: Maybe<Scalars['String']>;
  campaignGuid?: Maybe<Scalars['UUID']>;
};

export type CreateTimelineEntryInput = {
  type: PageType;
  pageId: Scalars['ID'];
  pageSlug?: Maybe<Scalars['Slug']>;
  creatorGuid?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  media?: Maybe<MediaCollectionInput>;
  fitness?: Maybe<FitnessActivityInput>;
  steps?: Maybe<Scalars['Int']>;
};

export type DeleteTimelineEntryInput = {
  id: Scalars['ID'];
};

export type TimelineEntryConnection = {
  __typename?: 'TimelineEntryConnection';
  edges: Array<TimelineEntryEdge>;
  nodes: Array<TimelineEntry>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TimelineEntryEdge = {
  __typename?: 'TimelineEntryEdge';
  cursor: Scalars['String'];
  node: TimelineEntry;
};

export type RefreshTimelineEntryInput = {
  id: Scalars['ID'];
};

export type TagWithNode = {
  __typename?: 'TagWithNode';
  tagDefinition: TagDefinition;
  value: Scalars['String'];
  valueAsNode?: Maybe<Node>;
};

export type Total = {
  __typename?: 'Total';
  segment: Scalars['String'];
  segmentAsNode?: Maybe<Node>;
  tag: TagWithNode;
  measurementDomain: Scalars['String'];
  amounts: Array<TotalAmount>;
};

export type TrendingCharities = {
  __typename?: 'TrendingCharities';
  edges: Array<TrendingCharitiesEdge>;
  nodes: Array<Charity>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TrendingCharitiesEdge = {
  __typename?: 'TrendingCharitiesEdge';
  cursor: Scalars['String'];
  node: Charity;
};

export type User = Node & {
  __typename?: 'User';
  id: Scalars['ID'];
  legacyId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  thirdPartyApplications?: Maybe<ThirdPartyApplications>;
  /** Find an page by its login that the user has permission for. */
  page?: Maybe<Page>;
  /** A list of pages that the user owns. */
  pages?: Maybe<PageConnection>;
  /** @deprecated Used only to aggregate requests for GG.Profile.Web */
  asks?: Maybe<Array<Maybe<AsksItem>>>;
  donations?: Maybe<DonationConnection>;
  donationSummaries?: Maybe<Array<DonorDonationSummary>>;
  eligibleChildPages?: Maybe<PageConnection>;
};

export type UserPageArgs = {
  type: PageType;
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['Slug']>;
};

export type UserPagesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  canParticipateIn?: Maybe<CanParticipateInInput>;
  relationshipId?: Maybe<Scalars['ID']>;
  type?: Maybe<PageType>;
  status?: Maybe<PageStatus>;
  statuses?: Maybe<Array<PageStatus>>;
  productNames?: Maybe<Array<ProductType>>;
};

export type UserDonationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  filter?: Maybe<DateFilterInput>;
};

export type UserEligibleChildPagesArgs = {
  parentPageId: Scalars['UUID'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
};

export type DateFilterInput = {
  startDate: Scalars['String'];
  endDate: Scalars['String'];
};

export type UserInput = {
  name?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
};

export type AboutCampaignAndCharityQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
  withExternalUrl: Scalars['Boolean'];
  beneficiariesLimit: Scalars['Int'];
}>;

export type AboutCampaignAndCharityQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                nodes: Array<
                  | ({ __typename?: 'Charity' } & MakeOptional<
                      Pick<
                        Charity,
                        | 'id'
                        | 'legacyId'
                        | 'name'
                        | 'description'
                        | 'logo'
                        | 'registrationNumber'
                        | 'profilePageUrl'
                        | 'countryCode'
                        | 'externalUrl'
                      >,
                      'externalUrl'
                    >)
                  | { __typename?: 'User' }
                >;
              };
            parents: Array<
              { __typename?: 'PageRelationship' } & Pick<
                PageRelationship,
                'type'
              > & {
                  page?: Maybe<
                    { __typename?: 'Page' } & Pick<
                      Page,
                      'id' | 'title' | 'url' | 'logo' | 'summary' | 'type'
                    > & {
                        branding?: Maybe<
                          { __typename?: 'Branding' } & Pick<Branding, 'logo'>
                        >;
                        product?: Maybe<
                          { __typename?: 'Product' } & Pick<Product, 'name'>
                        >;
                      }
                  >;
                }
            >;
          }
        >;
      }
  >;
};

export type CauseMiniFragment = { __typename?: 'Page' } & Pick<Page, 'id'> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<
                  Charity,
                  | 'impactStatement'
                  | 'id'
                  | 'legacyId'
                  | 'logo'
                  | 'name'
                  | 'profilePageUrl'
                  | 'registrationNumber'
                  | 'slug'
                  | 'countryCode'
                >)
              | { __typename?: 'User' }
            >;
          };
        parents: Array<
          { __typename?: 'PageRelationship' } & Pick<
            PageRelationship,
            'type'
          > & {
              page?: Maybe<
                { __typename?: 'Page' } & Pick<
                  Page,
                  'id' | 'url' | 'logo' | 'title' | 'summary' | 'type'
                > & {
                    branding?: Maybe<
                      { __typename?: 'Branding' } & Pick<Branding, 'logo'>
                    >;
                    product?: Maybe<
                      { __typename?: 'Product' } & Pick<Product, 'name'>
                    >;
                  }
              >;
            }
        >;
      }
    >;
  };

export type AboutTeamFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>>;
};

export type AdminTabsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'legacyId'
>;

export type CharityRegDetailsFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
        nodes: Array<
          | ({ __typename?: 'Charity' } & Pick<
              Charity,
              'id' | 'registrationNumber'
            >)
          | { __typename?: 'User' }
        >;
      };
    }
  >;
};

export type EndDateFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'endDate'
>;

export type DonationSummaryFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id'
> & {
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        totalMatched: Array<
          { __typename?: 'DonationMatch' } & Pick<DonationMatch, 'type'> & {
              amount: { __typename?: 'MonetaryAmount' } & Pick<
                MonetaryAmount,
                'value' | 'currencyCode'
              >;
            }
        >;
        onlineAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        offlineAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        directDonationAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        fundraiserRaisedAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
        textDonations?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'value' | 'currencyCode'
          >
        >;
      }
    >;
  };

export type EncourageDonateOwnerFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>>;
};

export type InactivityModalEventDetailsFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      events: { __typename?: 'EventConnection' } & Pick<
        EventConnection,
        'totalCount'
      > & {
          nodes: Array<
            { __typename?: 'Event' } & Pick<
              Event,
              'id' | 'startDate' | 'endDate' | 'visible'
            >
          >;
        };
    }
  >;
};

export type EncourageShareOwnerFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>>;
};

export type EventDetailsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'joinUrl'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        events: { __typename?: 'EventConnection' } & Pick<
          EventConnection,
          'totalCount'
        > & {
            nodes: Array<
              { __typename?: 'Event' } & Pick<
                Event,
                'id' | 'title' | 'startDate' | 'endDate' | 'visible'
              >
            >;
          };
      }
    >;
  };

export type PageFitnessSettingsQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
  application: Scalars['String'];
}>;

export type PageFitnessSettingsQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        application?: Maybe<
          { __typename?: 'FitnessApplication' } & {
            settings?: Maybe<
              { __typename?: 'FitnessApplicationSettings' } & Pick<
                FitnessApplicationSettings,
                | 'measurementSystem'
                | 'subscribedActivities'
                | 'showPhotos'
                | 'showDuration'
                | 'showDistance'
                | 'showElevation'
                | 'showMap'
                | 'showTotaliser'
              >
            >;
          }
        >;
        totals?: Maybe<
          { __typename?: 'PageTotals' } & Pick<
            PageTotals,
            'displayOptions' | 'primaryMeasurementType'
          > & {
              timeline: Array<
                { __typename?: 'PageTotal' } & Pick<
                  PageTotal,
                  'measurementDomain'
                > & {
                    amounts: Array<
                      { __typename?: 'TotalAmount' } & Pick<
                        TotalAmount,
                        'unit' | 'value'
                      >
                    >;
                  }
              >;
            }
        >;
      }
  >;
};

export type UserFitnessConnectionStateQueryVariables = Exact<{
  [key: string]: never;
}>;

export type UserFitnessConnectionStateQuery = { __typename?: 'Query' } & {
  viewer?: Maybe<
    { __typename?: 'User' } & {
      thirdPartyApplications?: Maybe<
        { __typename?: 'ThirdPartyApplications' } & {
          strava?: Maybe<
            { __typename?: 'Strava' } & Pick<Strava, 'isConnected'>
          >;
          fitbit?: Maybe<
            { __typename?: 'Fitbit' } & Pick<Fitbit, 'isConnected'>
          >;
        }
      >;
    }
  >;
};

export type LeaderboardFundraisersListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type LeaderboardFundraisersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'allowFundraising'> & {
        fundraisers?: Maybe<
          { __typename?: 'PageLeaderboardConnection' } & Pick<
            PageLeaderboardConnection,
            'totalCount'
          > & {
              edges: Array<
                { __typename?: 'PageLeaderboardEdge' } & {
                  node: { __typename?: 'Page' } & Pick<
                    Page,
                    'id' | 'slug' | 'status'
                  > & {
                      owner?: Maybe<
                        { __typename?: 'User' } & Pick<
                          User,
                          'id' | 'avatar' | 'name'
                        >
                      >;
                      donations?: Maybe<
                        { __typename?: 'DonationConnection' } & Pick<
                          DonationConnection,
                          'totalCount'
                        >
                      >;
                      donationSummary?: Maybe<
                        { __typename?: 'DonationSummary' } & {
                          totalAmount?: Maybe<
                            { __typename?: 'MonetaryAmount' } & Pick<
                              MonetaryAmount,
                              'value' | 'currencyCode'
                            >
                          >;
                        }
                      >;
                      targetWithCurrency?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value'
                        >
                      >;
                    };
                }
              >;
              pageInfo: { __typename?: 'ForwardOnlyPageInfo' } & Pick<
                ForwardOnlyPageInfo,
                'endCursor' | 'hasNextPage'
              >;
            }
        >;
      }
  >;
};

export type LegacyFundraisersListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type LegacyFundraisersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            config?: Maybe<
              { __typename?: 'PageRelationshipConfig' } & Pick<
                PageRelationshipConfig,
                'membersDisabled'
              >
            >;
            members: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                edges: Array<
                  { __typename?: 'PageRelationshipEdge' } & {
                    node: { __typename?: 'Page' } & Pick<
                      Page,
                      'id' | 'slug' | 'status'
                    > & {
                        owner?: Maybe<
                          { __typename?: 'User' } & Pick<
                            User,
                            'id' | 'avatar' | 'name'
                          >
                        >;
                        donations?: Maybe<
                          { __typename?: 'DonationConnection' } & Pick<
                            DonationConnection,
                            'totalCount'
                          >
                        >;
                        donationSummary?: Maybe<
                          { __typename?: 'DonationSummary' } & {
                            totalAmount?: Maybe<
                              { __typename?: 'MonetaryAmount' } & Pick<
                                MonetaryAmount,
                                'value' | 'currencyCode'
                              >
                            >;
                          }
                        >;
                        targetWithCurrency?: Maybe<
                          { __typename?: 'MonetaryAmount' } & Pick<
                            MonetaryAmount,
                            'value'
                          >
                        >;
                      };
                  }
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'endCursor'
                >;
              };
          }
        >;
      }
  >;
};

export type InMemoryCtaFragment = { __typename?: 'Page' } & {
  inMemory?: Maybe<
    { __typename?: 'InMemory' } & Pick<
      InMemory,
      'firstNameOfDeceased' | 'lastNameOfDeceased'
    >
  >;
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
        nodes: Array<
          | ({ __typename?: 'Charity' } & Pick<Charity, 'id' | 'name'>)
          | { __typename?: 'User' }
        >;
      };
    }
  >;
};

export type InMemoryCharitiesListQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
}>;

export type InMemoryCharitiesListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'slug'> & {
        inMemory?: Maybe<
          { __typename?: 'InMemory' } & Pick<InMemory, 'firstNameOfDeceased'>
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                edges: Array<
                  { __typename?: 'BeneficiaryEdge' } & {
                    node:
                      | ({ __typename?: 'Charity' } & Pick<
                          Charity,
                          | 'id'
                          | 'name'
                          | 'description'
                          | 'logo'
                          | 'registrationNumber'
                          | 'profilePageUrl'
                        >)
                      | { __typename?: 'User' };
                  }
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'startCursor' | 'endCursor'
                >;
              };
          }
        >;
      }
  >;
};

export type InMemoryFundraisersListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type InMemoryFundraisersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'slug'> & {
        inMemory?: Maybe<
          { __typename?: 'InMemory' } & Pick<InMemory, 'firstNameOfDeceased'>
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            members: { __typename?: 'PageRelationshipConnection' } & {
              edges: Array<
                { __typename?: 'PageRelationshipEdge' } & {
                  node: { __typename?: 'Page' } & Pick<
                    Page,
                    'id' | 'slug' | 'title'
                  > & {
                      cover?: Maybe<
                        | ({ __typename?: 'ImageMedia' } & Pick<
                            ImageMedia,
                            'url'
                          >)
                        | { __typename?: 'VideoMedia' }
                        | { __typename?: 'LivestreamMedia' }
                      >;
                      owner?: Maybe<
                        { __typename?: 'User' } & Pick<User, 'avatar' | 'name'>
                      >;
                      donations?: Maybe<
                        { __typename?: 'DonationConnection' } & Pick<
                          DonationConnection,
                          'totalCount'
                        >
                      >;
                      donationSummary?: Maybe<
                        { __typename?: 'DonationSummary' } & {
                          totalAmount?: Maybe<
                            { __typename?: 'MonetaryAmount' } & Pick<
                              MonetaryAmount,
                              'value' | 'currencyCode'
                            >
                          >;
                        }
                      >;
                      targetWithCurrency?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value'
                        >
                      >;
                    };
                }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'hasNextPage' | 'endCursor'
              >;
            };
          }
        >;
      }
  >;
};

export type InMemorySupportersListQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type InMemorySupportersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        donations?: Maybe<
          { __typename?: 'DonationConnection' } & Pick<
            DonationConnection,
            'totalCount'
          > & {
              edges: Array<
                { __typename?: 'DonationEdge' } & {
                  node: { __typename?: 'Donation' } & Pick<
                    Donation,
                    | 'id'
                    | 'legacyId'
                    | 'creationDate'
                    | 'displayName'
                    | 'avatar'
                    | 'message'
                  > & {
                      amount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                      giftAidAmount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                    };
                }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'hasNextPage' | 'endCursor'
              >;
            }
        >;
      }
  >;
};

export type InMemoryTotalFragment = { __typename?: 'Page' } & {
  inMemory?: Maybe<
    { __typename?: 'InMemory' } & Pick<
      InMemory,
      | 'firstNameOfDeceased'
      | 'lastNameOfDeceased'
      | 'dateOfBirth'
      | 'dateOfDeath'
    >
  >;
  donationSummary?: Maybe<
    { __typename?: 'DonationSummary' } & {
      totalAmount?: Maybe<
        { __typename?: 'MonetaryAmount' } & Pick<
          MonetaryAmount,
          'currencyCode' | 'value'
        >
      >;
    }
  >;
};

export type LeaderboardMemberListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type LeaderboardMemberListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'legacyId' | 'allowFundraising' | 'membershipPolicy'
    > & {
        fundraisers?: Maybe<
          { __typename?: 'PageLeaderboardConnection' } & Pick<
            PageLeaderboardConnection,
            'totalCount'
          > & {
              edges: Array<
                { __typename?: 'PageLeaderboardEdge' } & {
                  node: { __typename?: 'Page' } & Pick<
                    Page,
                    'title' | 'status' | 'legacyId' | 'id' | 'url' | 'slug'
                  > & {
                      owner?: Maybe<
                        { __typename?: 'User' } & Pick<
                          User,
                          'id' | 'avatar' | 'name'
                        >
                      >;
                      donations?: Maybe<
                        { __typename?: 'DonationConnection' } & Pick<
                          DonationConnection,
                          'totalCount'
                        >
                      >;
                      donationSummary?: Maybe<
                        { __typename?: 'DonationSummary' } & {
                          totalAmount?: Maybe<
                            { __typename?: 'MonetaryAmount' } & Pick<
                              MonetaryAmount,
                              'value' | 'currencyCode'
                            >
                          >;
                        }
                      >;
                      targetWithCurrency?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value'
                        >
                      >;
                    };
                }
              >;
              pageInfo: { __typename?: 'ForwardOnlyPageInfo' } & Pick<
                ForwardOnlyPageInfo,
                'endCursor' | 'hasNextPage'
              >;
            }
        >;
      }
  >;
};

export type MembersListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type MembersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'legacyId' | 'membershipPolicy'
    > & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            members: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'endCursor'
                >;
                nodes: Array<
                  { __typename?: 'Page' } & Pick<
                    Page,
                    'url' | 'id' | 'legacyId' | 'slug' | 'title' | 'status'
                  > & {
                      owner?: Maybe<
                        { __typename?: 'User' } & Pick<
                          User,
                          'id' | 'name' | 'avatar'
                        >
                      >;
                      targetWithCurrency?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value'
                        >
                      >;
                      donationSummary?: Maybe<
                        { __typename?: 'DonationSummary' } & {
                          totalAmount?: Maybe<
                            { __typename?: 'MonetaryAmount' } & Pick<
                              MonetaryAmount,
                              'value' | 'currencyCode'
                            >
                          >;
                        }
                      >;
                    }
                >;
              };
          }
        >;
      }
  >;
};

export type LeaderboardMembersMiniFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'legacyId' | 'membershipPolicy'
> & {
    fundraisers?: Maybe<
      { __typename?: 'PageLeaderboardConnection' } & Pick<
        PageLeaderboardConnection,
        'totalCount'
      > & {
          edges: Array<
            { __typename?: 'PageLeaderboardEdge' } & {
              node: { __typename?: 'Page' } & Pick<
                Page,
                'title' | 'status' | 'legacyId' | 'id' | 'url' | 'slug'
              > & {
                  owner?: Maybe<
                    { __typename?: 'User' } & Pick<
                      User,
                      'id' | 'avatar' | 'name'
                    >
                  >;
                  donations?: Maybe<
                    { __typename?: 'DonationConnection' } & Pick<
                      DonationConnection,
                      'totalCount'
                    >
                  >;
                  donationSummary?: Maybe<
                    { __typename?: 'DonationSummary' } & {
                      totalAmount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                    }
                  >;
                  targetWithCurrency?: Maybe<
                    { __typename?: 'MonetaryAmount' } & Pick<
                      MonetaryAmount,
                      'value'
                    >
                  >;
                };
            }
          >;
          pageInfo: { __typename?: 'ForwardOnlyPageInfo' } & Pick<
            ForwardOnlyPageInfo,
            'endCursor' | 'hasNextPage'
          >;
        }
    >;
  };

export type MembersMiniFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'legacyId' | 'membershipPolicy'
> & {
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        members: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        > & {
            nodes: Array<
              { __typename?: 'Page' } & Pick<Page, 'id'> & {
                  owner?: Maybe<
                    { __typename?: 'User' } & Pick<User, 'id' | 'avatar'>
                  >;
                }
            >;
          };
      }
    >;
  };

export type PageOwnerAvatarQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type PageOwnerAvatarQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'logo'> & {
        owner?: Maybe<
          { __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>
        >;
      }
  >;
};

export type QualarooLoaderDocumentQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type QualarooLoaderDocumentQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'status' | 'createDate' | 'endDate' | 'currency'
    > & {
        owner?: Maybe<
          { __typename?: 'User' } & Pick<
            User,
            'id' | 'name' | 'legacyId' | 'avatar'
          >
        >;
        donationSummary?: Maybe<
          { __typename?: 'DonationSummary' } & Pick<
            DonationSummary,
            'donationCount'
          > & {
              offlineAmount?: Maybe<
                { __typename?: 'MonetaryAmount' } & Pick<
                  MonetaryAmount,
                  'value'
                >
              >;
              totalAmount?: Maybe<
                { __typename?: 'MonetaryAmount' } & Pick<
                  MonetaryAmount,
                  'value'
                >
              >;
            }
        >;
        cover?: Maybe<
          | ({ __typename?: 'ImageMedia' } & Pick<ImageMedia, 'id' | 'url'>)
          | { __typename?: 'VideoMedia' }
          | { __typename?: 'LivestreamMedia' }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            events: { __typename?: 'EventConnection' } & {
              nodes: Array<
                { __typename?: 'Event' } & Pick<
                  Event,
                  'id' | 'legacyId' | 'title' | 'startDate'
                >
              >;
            };
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
              nodes: Array<
                | ({ __typename?: 'Charity' } & Pick<
                    Charity,
                    'id' | 'legacyId'
                  >)
                | { __typename?: 'User' }
              >;
            };
            parents: Array<
              { __typename?: 'PageRelationship' } & Pick<
                PageRelationship,
                'type'
              > & {
                  page?: Maybe<
                    { __typename?: 'Page' } & Pick<
                      Page,
                      'id' | 'legacyId' | 'type'
                    > & {
                        product?: Maybe<
                          { __typename?: 'Product' } & Pick<Product, 'name'>
                        >;
                      }
                  >;
                }
            >;
          }
        >;
        targetWithCurrency?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
        donations?: Maybe<
          { __typename?: 'DonationConnection' } & {
            nodes: Array<
              { __typename?: 'Donation' } & Pick<
                Donation,
                'id' | 'creationDate'
              >
            >;
          }
        >;
        timeline?: Maybe<
          { __typename?: 'TimelineEntryConnection' } & Pick<
            TimelineEntryConnection,
            'totalCount'
          >
        >;
        gallery?: Maybe<
          { __typename?: 'MediaConnection' } & Pick<
            MediaConnection,
            'totalCount'
          >
        >;
      }
  >;
};

export type ReasonFragment = { __typename?: 'Page' } & {
  occasion?: Maybe<
    { __typename?: 'Occasion' } & Pick<
      Occasion,
      'type' | 'date' | 'names' | 'description'
    >
  >;
  reason?: Maybe<
    { __typename?: 'Reason' } & Pick<Reason, 'icon' | 'reason' | 'reasonUrl'>
  >;
};

export type StickySummaryFragment = { __typename?: 'Page' } & {
  owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'avatar'>>;
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
        PageRelationshipConnection,
        'totalCount'
      > & {
          nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'id' | 'title'>>;
        };
    }
  >;
};

export type StoryFragment = { __typename?: 'Page' } & Pick<Page, 'id'> & {
    storyWithType?: Maybe<
      { __typename?: 'Story' } & Pick<Story, 'type' | 'content'>
    >;
  };

export type SuccessMessageFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id'
> & {
    targetWithCurrency?: Maybe<
      { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'currencyCode'>
    >;
  };

export type SupportersListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
}>;

export type SupportersListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'> & {
        donationSummary?: Maybe<
          { __typename?: 'DonationSummary' } & Pick<
            DonationSummary,
            'onlineDonationCount' | 'donationCount'
          >
        >;
        donations?: Maybe<
          { __typename?: 'DonationConnection' } & Pick<
            DonationConnection,
            'totalCount'
          > & {
              edges: Array<
                { __typename?: 'DonationEdge' } & {
                  node: { __typename?: 'Donation' } & Pick<
                    Donation,
                    | 'id'
                    | 'legacyId'
                    | 'creationDate'
                    | 'displayName'
                    | 'avatar'
                    | 'message'
                  > & {
                      amount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                      giftAidAmount?: Maybe<
                        { __typename?: 'MonetaryAmount' } & Pick<
                          MonetaryAmount,
                          'value' | 'currencyCode'
                        >
                      >;
                    };
                }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'hasNextPage' | 'endCursor'
              >;
            }
        >;
      }
  >;
};

export type TeamAndCompanyFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      parents: Array<
        { __typename?: 'PageRelationship' } & Pick<PageRelationship, 'type'> & {
            page?: Maybe<
              { __typename?: 'Page' } & Pick<
                Page,
                'id' | 'title' | 'url' | 'status' | 'type'
              > & {
                  cover?: Maybe<
                    | ({ __typename?: 'ImageMedia' } & Pick<
                        ImageMedia,
                        'id' | 'url' | 'alt'
                      >)
                    | ({ __typename?: 'VideoMedia' } & Pick<VideoMedia, 'id'>)
                    | ({ __typename?: 'LivestreamMedia' } & Pick<
                        LivestreamMedia,
                        'id'
                      >)
                  >;
                  product?: Maybe<
                    { __typename?: 'Product' } & Pick<Product, 'name'>
                  >;
                }
            >;
          }
      >;
      companies: { __typename?: 'PageRelationshipConnection' } & {
        nodes: Array<
          { __typename?: 'Page' } & Pick<Page, 'id' | 'title' | 'url' | 'logo'>
        >;
      };
    }
  >;
};

export type TeamDetailsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'legacyId' | 'type'
> & {
    targetWithCurrency?: Maybe<
      { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'currencyCode'>
    >;
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        parents: Array<
          { __typename?: 'PageRelationship' } & Pick<
            PageRelationship,
            'type'
          > & {
              page?: Maybe<
                { __typename?: 'Page' } & Pick<
                  Page,
                  'id' | 'legacyId' | 'title' | 'url' | 'status' | 'type'
                > & {
                    product?: Maybe<
                      { __typename?: 'Product' } & Pick<Product, 'name'>
                    >;
                  }
              >;
            }
        >;
      }
    >;
  };

export type TeamsListQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type TeamsListQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            teams: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                edges: Array<
                  { __typename?: 'PageRelationshipEdge' } & {
                    node: { __typename?: 'Page' } & Pick<
                      Page,
                      'id' | 'slug' | 'title' | 'status'
                    > & {
                        owner?: Maybe<
                          { __typename?: 'User' } & Pick<User, 'id' | 'avatar'>
                        >;
                        donationSummary?: Maybe<
                          { __typename?: 'DonationSummary' } & {
                            totalAmount?: Maybe<
                              { __typename?: 'MonetaryAmount' } & Pick<
                                MonetaryAmount,
                                'currencyCode' | 'value'
                              >
                            >;
                            totalMatched: Array<
                              { __typename?: 'DonationMatch' } & Pick<
                                DonationMatch,
                                'type'
                              > & {
                                  amount: {
                                    __typename?: 'MonetaryAmount';
                                  } & Pick<
                                    MonetaryAmount,
                                    'currencyCode' | 'value'
                                  >;
                                }
                            >;
                          }
                        >;
                        targetWithCurrency?: Maybe<
                          { __typename?: 'MonetaryAmount' } & Pick<
                            MonetaryAmount,
                            'value'
                          >
                        >;
                        donations?: Maybe<
                          { __typename?: 'DonationConnection' } & Pick<
                            DonationConnection,
                            'totalCount'
                          >
                        >;
                      };
                  }
                >;
                pageInfo: { __typename?: 'PageInfo' } & Pick<
                  PageInfo,
                  'hasNextPage' | 'endCursor'
                >;
              };
          }
        >;
      }
  >;
};

export type ShareModalFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'title'
> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name'>>;
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<Charity, 'id' | 'name'>)
              | { __typename?: 'User' }
            >;
          };
      }
    >;
  };

export type GetStravaMeasurementSystemQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type GetStravaMeasurementSystemQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id'> & {
        application?: Maybe<
          { __typename?: 'FitnessApplication' } & {
            settings?: Maybe<
              { __typename?: 'FitnessApplicationSettings' } & Pick<
                FitnessApplicationSettings,
                'measurementSystem'
              >
            >;
          }
        >;
      }
  >;
};

export type TotaliserWrapperFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id'
> & {
    targetWithCurrency?: Maybe<
      { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
    >;
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
      }
    >;
    branding?: Maybe<
      { __typename?: 'Branding' } & Pick<Branding, 'primaryColor'>
    >;
    reason?: Maybe<{ __typename?: 'Reason' } & Pick<Reason, 'icon'>>;
  };

export type TotalsFragment = { __typename?: 'Page' } & Pick<Page, 'type'> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name'>>;
    targetWithCurrency?: Maybe<
      { __typename?: 'MonetaryAmount' } & Pick<
        MonetaryAmount,
        'currencyCode' | 'value'
      >
    >;
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & Pick<
        DonationSummary,
        'aggregatedDonationsCount'
      > & {
          totalAmount?: Maybe<
            { __typename?: 'MonetaryAmount' } & Pick<
              MonetaryAmount,
              'currencyCode' | 'value'
            >
          >;
        }
    >;
    donations?: Maybe<
      { __typename?: 'DonationConnection' } & Pick<
        DonationConnection,
        'totalCount'
      > & {
          nodes: Array<
            { __typename?: 'Donation' } & Pick<Donation, 'id' | 'creationDate'>
          >;
        }
    >;
  };

export type CheckListDataQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type CheckListDataQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'legacyId' | 'slug' | 'title' | 'subtitle' | 'summary'
    > & {
        owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'name'>>;
        donations?: Maybe<
          { __typename?: 'DonationConnection' } & Pick<
            DonationConnection,
            'totalCount'
          > & {
              nodes: Array<
                { __typename?: 'Donation' } & Pick<Donation, 'displayName'>
              >;
            }
        >;
        gallery?: Maybe<
          { __typename?: 'MediaConnection' } & {
            nodes: Array<
              | ({ __typename?: 'ImageMedia' } & Pick<
                  ImageMedia,
                  'id' | 'url' | 'caption'
                >)
              | { __typename?: 'VideoMedia' }
              | { __typename?: 'LivestreamMedia' }
            >;
          }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            config?: Maybe<
              { __typename?: 'PageRelationshipConfig' } & Pick<
                PageRelationshipConfig,
                'membersDisabled'
              >
            >;
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                nodes: Array<
                  | ({ __typename?: 'Charity' } & Pick<
                      Charity,
                      | 'id'
                      | 'legacyId'
                      | 'name'
                      | 'countryCode'
                      | 'profilePageUrl'
                      | 'logo'
                    >)
                  | { __typename?: 'User' }
                >;
              };
            campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'>
                >;
              };
          }
        >;
        timeline?: Maybe<
          { __typename?: 'TimelineEntryConnection' } & Pick<
            TimelineEntryConnection,
            'totalCount'
          > & {
              nodes: Array<
                { __typename?: 'TimelineEntry' } & Pick<
                  TimelineEntry,
                  | 'id'
                  | 'legacyId'
                  | 'message'
                  | 'type'
                  | 'createdAt'
                  | 'refreshRequestedTime'
                  | 'publishingSource'
                > & {
                    media?: Maybe<
                      Array<
                        | ({ __typename?: 'ImageMedia' } & Pick<
                            ImageMedia,
                            'id' | 'url' | 'legacyId'
                          >)
                        | { __typename?: 'VideoMedia' }
                        | { __typename?: 'LivestreamMedia' }
                      >
                    >;
                  }
              >;
            }
        >;
        totals?: Maybe<
          { __typename?: 'PageTotals' } & Pick<
            PageTotals,
            'displayOptions' | 'primaryMeasurementType'
          > & {
              timeline: Array<
                { __typename?: 'PageTotal' } & Pick<
                  PageTotal,
                  'measurementDomain'
                > & {
                    amounts: Array<
                      { __typename?: 'TotalAmount' } & Pick<
                        TotalAmount,
                        'value' | 'unit'
                      >
                    >;
                  }
              >;
            }
        >;
        cover?: Maybe<
          | ({ __typename?: 'ImageMedia' } & Pick<
              ImageMedia,
              'id' | 'url' | 'alt' | 'caption'
            >)
          | { __typename?: 'VideoMedia' }
          | ({ __typename?: 'LivestreamMedia' } & Pick<
              LivestreamMedia,
              'id' | 'url' | 'platform' | 'streamId'
            >)
        >;
        livestream?: Maybe<
          { __typename?: 'Livestream' } & {
            entries?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'LivestreamEntries' } & Pick<
                    LivestreamEntries,
                    'streamId' | 'streamType'
                  >
                >
              >
            >;
          }
        >;
        donationSummary?: Maybe<
          { __typename?: 'DonationSummary' } & {
            totalAmount?: Maybe<
              { __typename?: 'MonetaryAmount' } & Pick<
                MonetaryAmount,
                'currencyCode' | 'value'
              >
            >;
          }
        >;
        application?: Maybe<
          { __typename?: 'FitnessApplication' } & {
            settings?: Maybe<
              { __typename?: 'FitnessApplicationSettings' } & Pick<
                FitnessApplicationSettings,
                'measurementSystem' | 'showTotaliser'
              >
            >;
          }
        >;
      }
  >;
};

export type WeDidItFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'endDate'
> & {
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<
            MonetaryAmount,
            'currencyCode' | 'value'
          >
        >;
      }
    >;
    donations?: Maybe<
      { __typename?: 'DonationConnection' } & Pick<
        DonationConnection,
        'totalCount'
      >
    >;
  };

export type ActivityTotalsFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id'
> & {
    totals?: Maybe<
      { __typename?: 'PageTotals' } & Pick<
        PageTotals,
        'displayOptions' | 'primaryMeasurementType'
      > & {
          timeline: Array<
            { __typename?: 'PageTotal' } & Pick<
              PageTotal,
              'measurementDomain'
            > & {
                amounts: Array<
                  { __typename?: 'TotalAmount' } & Pick<
                    TotalAmount,
                    'unit' | 'value'
                  >
                >;
              }
          >;
        }
    >;
  };

export type MediaCollectionFragment = { __typename?: 'Page' } & {
  gallery?: Maybe<
    { __typename?: 'MediaConnection' } & {
      nodes: Array<
        | ({ __typename?: 'ImageMedia' } & Pick<ImageMedia, 'id' | 'url'>)
        | { __typename?: 'VideoMedia' }
        | { __typename?: 'LivestreamMedia' }
      >;
    }
  >;
};

export type UpdateFitnessSettingsMutationVariables = Exact<{
  input: FitnessApplicationSettingsInput;
}>;

export type UpdateFitnessSettingsMutation = { __typename?: 'Mutation' } & {
  setFitnessApplicationSettings?: Maybe<
    { __typename?: 'FitnessApplicationSettings' } & Pick<
      FitnessApplicationSettings,
      | 'measurementSystem'
      | 'subscribedActivities'
      | 'showDistance'
      | 'showDuration'
      | 'showElevation'
      | 'showPhotos'
      | 'showMap'
      | 'showTotaliser'
    >
  >;
};

export type CreateTimelineEntryMutationVariables = Exact<{
  input: CreateTimelineEntryInput;
  measurementSystem?: Maybe<MeasurementSystem>;
}>;

export type CreateTimelineEntryMutation = { __typename?: 'Mutation' } & {
  createTimelineEntry?: Maybe<
    { __typename?: 'TimelineEntry' } & Pick<
      TimelineEntry,
      'id' | 'legacyId' | 'message' | 'type' | 'createdAt' | 'publishingSource'
    > & {
        media?: Maybe<
          Array<
            | ({ __typename?: 'ImageMedia' } & Pick<
                ImageMedia,
                'id' | 'url' | 'legacyId'
              >)
            | ({ __typename?: 'VideoMedia' } & Pick<VideoMedia, 'id'>)
            | ({ __typename?: 'LivestreamMedia' } & Pick<LivestreamMedia, 'id'>)
          >
        >;
        fitnessActivity?: Maybe<
          { __typename?: 'FitnessActivity' } & Pick<
            FitnessActivity,
            'id' | 'activityId' | 'title' | 'activityType' | 'mapPolyline'
          > & {
              distance?: Maybe<
                { __typename?: 'Distance' } & Pick<Distance, 'unit' | 'value'>
              >;
              elevation?: Maybe<
                { __typename?: 'Distance' } & Pick<Distance, 'unit' | 'value'>
              >;
              duration?: Maybe<
                { __typename?: 'Duration' } & Pick<Duration, 'unit' | 'value'>
              >;
            }
        >;
      }
  >;
};

export type DeleteTimelineEntryMutationVariables = Exact<{
  input: DeleteTimelineEntryInput;
}>;

export type DeleteTimelineEntryMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'deleteTimelineEntry'
>;

export type ListTimelineEntriesQueryVariables = Exact<{
  after?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  type: PageType;
  slug: Scalars['Slug'];
  measurementSystem?: Maybe<MeasurementSystem>;
}>;

export type ListTimelineEntriesQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'> & {
        owner?: Maybe<
          { __typename?: 'User' } & Pick<User, 'id' | 'name' | 'avatar'>
        >;
        timeline?: Maybe<
          { __typename?: 'TimelineEntryConnection' } & Pick<
            TimelineEntryConnection,
            'totalCount'
          > & {
              nodes: Array<
                { __typename?: 'TimelineEntry' } & Pick<
                  TimelineEntry,
                  | 'id'
                  | 'legacyId'
                  | 'message'
                  | 'type'
                  | 'createdAt'
                  | 'refreshRequestedTime'
                  | 'publishingSource'
                > & {
                    media?: Maybe<
                      Array<
                        | ({ __typename?: 'ImageMedia' } & Pick<
                            ImageMedia,
                            'id' | 'url' | 'legacyId'
                          >)
                        | ({ __typename?: 'VideoMedia' } & Pick<
                            VideoMedia,
                            'id'
                          >)
                        | ({ __typename?: 'LivestreamMedia' } & Pick<
                            LivestreamMedia,
                            'id'
                          >)
                      >
                    >;
                    fitnessActivity?: Maybe<
                      { __typename?: 'FitnessActivity' } & Pick<
                        FitnessActivity,
                        | 'activityId'
                        | 'title'
                        | 'activityType'
                        | 'mapPolyline'
                        | 'steps'
                      > & {
                          distance?: Maybe<
                            { __typename?: 'Distance' } & Pick<
                              Distance,
                              'unit' | 'value'
                            >
                          >;
                          elevation?: Maybe<
                            { __typename?: 'Distance' } & Pick<
                              Distance,
                              'unit' | 'value'
                            >
                          >;
                          duration?: Maybe<
                            { __typename?: 'Duration' } & Pick<
                              Duration,
                              'unit' | 'value'
                            >
                          >;
                        }
                    >;
                  }
              >;
              pageInfo: { __typename?: 'PageInfo' } & Pick<
                PageInfo,
                'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
              >;
            }
        >;
      }
  >;
};

export type RefreshTimelineEntryMutationVariables = Exact<{
  input: RefreshTimelineEntryInput;
}>;

export type RefreshTimelineEntryMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'refreshTimelineEntry'
>;

export type IsCharityAdminFragment = { __typename?: 'Page' } & {
  relationships?: Maybe<
    { __typename?: 'PageRelationships' } & {
      beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
        nodes: Array<
          | ({ __typename?: 'Charity' } & Pick<Charity, 'id' | 'legacyId'>)
          | { __typename?: 'User' }
        >;
      };
    }
  >;
};

export type IsPageOwnerFragment = { __typename?: 'Page' } & Pick<
  Page,
  'legacyId'
> & {
    owner?: Maybe<
      { __typename?: 'User' } & Pick<User, 'id' | 'legacyId' | 'name'>
    >;
  };

export type PageIdFragment = { __typename?: 'Page' } & Pick<Page, 'id'>;

export type FirstToDonateEnrolmentFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id'
> & {
    targetWithCurrency?: Maybe<
      { __typename?: 'MonetaryAmount' } & Pick<
        MonetaryAmount,
        'currencyCode' | 'value'
      >
    >;
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
      }
    >;
  };

export type CreateVideoStoryMutationVariables = Exact<{
  input: CreateVideoStoryInput;
}>;

export type CreateVideoStoryMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'createVideoStory'
>;

export type GetVideoQueryVariables = Exact<{
  legacyId: Scalars['ID'];
}>;

export type GetVideoQuery = { __typename?: 'Query' } & {
  getVideoStory: { __typename?: 'VideoStory' } & Pick<
    VideoStory,
    'status' | 'videoUrl'
  >;
};

export type ConnectFitbitMutationVariables = Exact<{
  input: ConnectFitnessInput;
}>;

export type ConnectFitbitMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'connectFitbit'
>;

export type ConnectFitnessMutationVariables = Exact<{
  input: ConnectFitnessInput;
}>;

export type ConnectFitnessMutation = { __typename?: 'Mutation' } & Pick<
  Mutation,
  'connectFitness'
>;

export type GetPageBySlugQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type GetPageBySlugQuery = { __typename?: 'Query' } & {
  page?: Maybe<{ __typename?: 'Page' } & Pick<Page, 'id' | 'redirectUrl'>>;
};

export type FundraisingPageFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'title' | 'eventGivingGroupId'
> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name'>>;
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<Charity, 'id' | 'name'>)
              | { __typename?: 'User' }
            >;
          };
        companies: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        >;
        teams: { __typename?: 'PageRelationshipConnection' } & {
          nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'id' | 'status'>>;
        };
        campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        > & {
            nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'id' | 'slug'>>;
          };
      }
    >;
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
      }
    >;
  };

export type OnePageFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'title'
> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name'>>;
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<Charity, 'id' | 'name'>)
              | { __typename?: 'User' }
            >;
          };
        parents: Array<
          { __typename?: 'PageRelationship' } & Pick<
            PageRelationship,
            'type'
          > & {
              page?: Maybe<
                { __typename?: 'Page' } & Pick<
                  Page,
                  'id' | 'slug' | 'title' | 'type'
                > & {
                    product?: Maybe<
                      { __typename?: 'Product' } & Pick<Product, 'name'>
                    >;
                  }
              >;
            }
        >;
      }
    >;
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
      }
    >;
  };

export type SiteBuilderFrpFragment = { __typename?: 'Page' } & Pick<
  Page,
  'id' | 'title' | 'eventGivingGroupId'
> & {
    owner?: Maybe<{ __typename?: 'User' } & Pick<User, 'id' | 'name'>>;
    relationships?: Maybe<
      { __typename?: 'PageRelationships' } & {
        beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
          BeneficiaryConnection,
          'totalCount'
        > & {
            nodes: Array<
              | ({ __typename?: 'Charity' } & Pick<Charity, 'id' | 'name'>)
              | { __typename?: 'User' }
            >;
          };
        companies: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        >;
        teams: { __typename?: 'PageRelationshipConnection' } & {
          nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'id' | 'status'>>;
        };
        campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
          PageRelationshipConnection,
          'totalCount'
        > & {
            nodes: Array<{ __typename?: 'Page' } & Pick<Page, 'id' | 'slug'>>;
          };
      }
    >;
    donationSummary?: Maybe<
      { __typename?: 'DonationSummary' } & {
        totalAmount?: Maybe<
          { __typename?: 'MonetaryAmount' } & Pick<MonetaryAmount, 'value'>
        >;
      }
    >;
  };

export type BasePageDataQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
  preview?: Maybe<Scalars['Preview']>;
  includeEvent?: Maybe<Scalars['Boolean']>;
}>;

export type BasePageDataQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      | 'id'
      | 'status'
      | 'legacyId'
      | 'title'
      | 'summary'
      | 'logo'
      | 'type'
      | 'url'
      | 'redirectUrl'
      | 'startFundraisingUrl'
      | 'joinUrl'
    > & {
        cover?: Maybe<
          | ({ __typename?: 'ImageMedia' } & Pick<
              ImageMedia,
              'id' | 'url' | 'alt' | 'caption'
            >)
          | { __typename?: 'VideoMedia' }
          | ({ __typename?: 'LivestreamMedia' } & Pick<
              LivestreamMedia,
              'id' | 'url' | 'platform' | 'streamId'
            >)
        >;
        hero?: Maybe<
          { __typename?: 'Hero' } & Pick<Hero, 'imageUrl' | 'imageTitle'>
        >;
        livestream?: Maybe<
          { __typename?: 'Livestream' } & {
            entries?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'LivestreamEntries' } & Pick<
                    LivestreamEntries,
                    'streamId' | 'streamType'
                  >
                >
              >
            >;
          }
        >;
        gallery?: Maybe<
          { __typename?: 'MediaConnection' } & {
            nodes: Array<
              | ({ __typename?: 'ImageMedia' } & Pick<
                  ImageMedia,
                  'id' | 'url' | 'caption'
                >)
              | { __typename?: 'VideoMedia' }
              | { __typename?: 'LivestreamMedia' }
            >;
          }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            config?: Maybe<
              { __typename?: 'PageRelationshipConfig' } & Pick<
                PageRelationshipConfig,
                'membersDisabled'
              >
            >;
            events: { __typename?: 'EventConnection' } & Pick<
              EventConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Event' } & Pick<
                    Event,
                    'id' | 'title' | 'startDate' | 'endDate' | 'visible'
                  >
                >;
              };
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & Pick<
              BeneficiaryConnection,
              'totalCount'
            > & {
                nodes: Array<
                  | ({ __typename?: 'Charity' } & Pick<
                      Charity,
                      | 'id'
                      | 'legacyId'
                      | 'name'
                      | 'countryCode'
                      | 'profilePageUrl'
                    >)
                  | { __typename?: 'User' }
                >;
              };
            campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Page' } & Pick<
                    Page,
                    'id' | 'legacyId' | 'isJGPro'
                  >
                >;
              };
          }
        >;
        owner?: Maybe<
          { __typename?: 'User' } & Pick<
            User,
            'id' | 'name' | 'legacyId' | 'avatar'
          >
        >;
        occasion?: Maybe<
          { __typename?: 'Occasion' } & Pick<
            Occasion,
            'type' | 'date' | 'names' | 'description'
          >
        >;
        reason?: Maybe<
          { __typename?: 'Reason' } & Pick<
            Reason,
            'icon' | 'reason' | 'reasonUrl'
          >
        >;
        branding?: Maybe<
          { __typename?: 'Branding' } & Pick<
            Branding,
            | 'primaryColor'
            | 'backgroundColor'
            | 'backgroundImage'
            | 'logo'
            | 'headerImage'
          >
        >;
      }
  >;
};

export type DonateDataQueryVariables = Exact<{
  type: PageType;
  slug: Scalars['Slug'];
}>;

export type DonateDataQuery = { __typename?: 'Query' } & {
  page?: Maybe<
    { __typename?: 'Page' } & Pick<
      Page,
      'id' | 'status' | 'eventGivingGroupId' | 'legacyId' | 'title' | 'slug'
    > & {
        product?: Maybe<{ __typename?: 'Product' } & Pick<Product, 'name'>>;
        livestream?: Maybe<
          { __typename?: 'Livestream' } & {
            entries?: Maybe<
              Array<
                Maybe<
                  { __typename?: 'LivestreamEntries' } & Pick<
                    LivestreamEntries,
                    'streamId' | 'streamType'
                  >
                >
              >
            >;
          }
        >;
        cover?: Maybe<
          | ({ __typename: 'ImageMedia' } & Pick<ImageMedia, 'url'>)
          | { __typename?: 'VideoMedia' }
          | { __typename?: 'LivestreamMedia' }
        >;
        owner?: Maybe<
          { __typename?: 'User' } & Pick<
            User,
            'id' | 'name' | 'avatar' | 'legacyId'
          >
        >;
        branding?: Maybe<
          { __typename?: 'Branding' } & Pick<
            Branding,
            'primaryColor' | 'headerImage'
          >
        >;
        donationSummary?: Maybe<
          { __typename?: 'DonationSummary' } & {
            totalAmount?: Maybe<
              { __typename?: 'MonetaryAmount' } & Pick<
                MonetaryAmount,
                'currencyCode'
              >
            >;
          }
        >;
        relationships?: Maybe<
          { __typename?: 'PageRelationships' } & {
            parents: Array<
              { __typename?: 'PageRelationship' } & Pick<
                PageRelationship,
                'type'
              > & {
                  page?: Maybe<
                    { __typename?: 'Page' } & Pick<
                      Page,
                      | 'id'
                      | 'legacyId'
                      | 'title'
                      | 'url'
                      | 'logo'
                      | 'summary'
                      | 'type'
                    > & {
                        branding?: Maybe<
                          { __typename?: 'Branding' } & Pick<Branding, 'logo'>
                        >;
                        product?: Maybe<
                          { __typename?: 'Product' } & Pick<Product, 'name'>
                        >;
                      }
                  >;
                }
            >;
            beneficiaries: { __typename?: 'BeneficiaryConnection' } & {
              nodes: Array<
                | ({ __typename: 'Charity' } & Pick<
                    Charity,
                    | 'id'
                    | 'legacyId'
                    | 'name'
                    | 'logo'
                    | 'causeId'
                    | 'legacyCharityId'
                    | 'profilePageUrl'
                    | 'displayCurrency'
                    | 'thankYouMessage'
                    | 'countryCode'
                  > & {
                      donationPrompts?: Maybe<
                        Array<
                          { __typename?: 'DonationPrompt' } & Pick<
                            DonationPrompt,
                            'amount' | 'description' | 'type'
                          >
                        >
                      >;
                    })
                | { __typename?: 'User' }
              >;
            };
            campaigns: { __typename?: 'PageRelationshipConnection' } & Pick<
              PageRelationshipConnection,
              'totalCount'
            > & {
                nodes: Array<
                  { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'>
                >;
              };
            teams: { __typename?: 'PageRelationshipConnection' } & {
              nodes: Array<
                { __typename?: 'Page' } & Pick<Page, 'id' | 'legacyId'>
              >;
            };
            events: { __typename?: 'EventConnection' } & {
              nodes: Array<
                { __typename?: 'Event' } & Pick<Event, 'id' | 'legacyId'>
              >;
            };
          }
        >;
      }
  >;
};

export type StartCheckoutSessionMutationVariables = Exact<{
  input: StartDonationInput;
}>;

export type StartCheckoutSessionMutation = { __typename?: 'Mutation' } & {
  startCheckoutSession?: Maybe<
    { __typename?: 'StartSessionResult' } & Pick<
      StartSessionResult,
      'id' | 'createdInCheckoutApi'
    >
  >;
};

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> =
  | LegacyStitchingResolver<TResult, TParent, TContext, TArgs>
  | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {}
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {}
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  ApplicationType: ApplicationType;
  Application: ResolversTypes['FitnessApplication'];
  FitnessApplicationActivityType: FitnessApplicationActivityType;
  FitnessApplicationSettings: ResolverTypeWrapper<FitnessApplicationSettings>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  FitnessApplication: ResolverTypeWrapper<FitnessApplication>;
  String: ResolverTypeWrapper<Scalars['String']>;
  FitnessApplicationSettingsInput: FitnessApplicationSettingsInput;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Mutation: ResolverTypeWrapper<{}>;
  ThirdPartyApplications: ResolverTypeWrapper<ThirdPartyApplications>;
  AsksItem: ResolverTypeWrapper<AsksItem>;
  Query: ResolverTypeWrapper<{}>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  AvailableSlugs: ResolverTypeWrapper<AvailableSlugs>;
  Branding: ResolverTypeWrapper<Branding>;
  CauseByCauseRefInput: CauseByCauseRefInput;
  CauseBySourceRefInput: CauseBySourceRefInput;
  Cause: ResolverTypeWrapper<Cause>;
  CauseTip: ResolverTypeWrapper<CauseTip>;
  CauseBbms: ResolverTypeWrapper<CauseBbms>;
  CauseGiftAid: ResolverTypeWrapper<CauseGiftAid>;
  TipJarConfiguration: ResolverTypeWrapper<TipJarConfiguration>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  TipJarValueType: TipJarValueType;
  PaymentMethod: ResolverTypeWrapper<PaymentMethod>;
  AlternativePaymentMethod: AlternativePaymentMethod;
  MarketCode: MarketCode;
  Charity: ResolverTypeWrapper<Charity>;
  CheckoutInput: CheckoutInput;
  TransactionStatusInput: TransactionStatusInput;
  PaymentCardCardPointsBalanceInput: PaymentCardCardPointsBalanceInput;
  PaymentCardPointsBalance: ResolverTypeWrapper<PaymentCardPointsBalance>;
  CheckoutInitialise3DSResponse: ResolverTypeWrapper<
    CheckoutInitialise3DsResponse
  >;
  Checkout3DSNonceBillingAddress: ResolverTypeWrapper<
    Checkout3DsNonceBillingAddress
  >;
  Checkout3DSNonceResponse: ResolverTypeWrapper<Checkout3DsNonceResponse>;
  VerifyCheckoutWalletInput: VerifyCheckoutWalletInput;
  CheckoutWalletVerification: ResolverTypeWrapper<CheckoutWalletVerification>;
  VerifyCheckout3DSInput: VerifyCheckout3DsInput;
  Checkout3DSVerification: ResolverTypeWrapper<Checkout3DsVerification>;
  InitialiseCheckoutPayWithBankTransferAmountInput: InitialiseCheckoutPayWithBankTransferAmountInput;
  InitialiseCheckoutPayWithBankTransferInput: InitialiseCheckoutPayWithBankTransferInput;
  CheckoutPayWithBankTransferInitData: ResolverTypeWrapper<
    CheckoutPayWithBankTransferInitData
  >;
  CheckoutPayWithBankTransferKey: ResolverTypeWrapper<
    CheckoutPayWithBankTransferKey
  >;
  InitialiseCheckout3DSInput: InitialiseCheckout3DsInput;
  Checkout3dsInitialiseCallInput: Checkout3dsInitialiseCallInput;
  Checkout3DSNonceCallInput: Checkout3DsNonceCallInput;
  Checkout3DSData: ResolverTypeWrapper<Checkout3DsData>;
  InitialiseCheckoutWalletTokenInput: InitialiseCheckoutWalletTokenInput;
  CheckoutWalletToken: ResolverTypeWrapper<CheckoutWalletToken>;
  ConfirmCheckoutInput: ConfirmCheckoutInput;
  PreferencesInput: PreferencesInput;
  ConsentInput: ConsentInput;
  DonorDetailsInput: DonorDetailsInput;
  SessionInformationInput: SessionInformationInput;
  UpdateCheckoutApplyPointsInput: UpdateCheckoutApplyPointsInput;
  UpdateCheckoutSelectedCardInput: UpdateCheckoutSelectedCardInput;
  UpdateCheckoutRemoveCardInput: UpdateCheckoutRemoveCardInput;
  UpdateCheckoutPaymentTypeInput: UpdateCheckoutPaymentTypeInput;
  UpdateCheckoutPersonalisationInput: UpdateCheckoutPersonalisationInput;
  UpdateCheckoutGiftAidDeclarationInput: UpdateCheckoutGiftAidDeclarationInput;
  GiftAidDetailsInput: GiftAidDetailsInput;
  AddressInput: AddressInput;
  UpdateCheckoutOrderAmountInput: UpdateCheckoutOrderAmountInput;
  DirectDebitInput: DirectDebitInput;
  Checkout: ResolverTypeWrapper<Checkout>;
  TransactingUser: ResolverTypeWrapper<TransactingUser>;
  PaymentCard: ResolverTypeWrapper<PaymentCard>;
  Address: ResolverTypeWrapper<Address>;
  PaymentCardPoints: ResolverTypeWrapper<PaymentCardPoints>;
  CustomAttributes: ResolverTypeWrapper<CustomAttributes>;
  Transaction: ResolverTypeWrapper<Transaction>;
  GiftAid: ResolverTypeWrapper<GiftAid>;
  TaxPayerDetails: ResolverTypeWrapper<TaxPayerDetails>;
  Order: ResolverTypeWrapper<Order>;
  SupportedCurrencies: ResolverTypeWrapper<SupportedCurrencies>;
  CurrencyDefaults: ResolverTypeWrapper<CurrencyDefaults>;
  SuggestedAmount: ResolverTypeWrapper<SuggestedAmount>;
  LineItem: ResolverTypeWrapper<
    Omit<LineItem, 'details'> & {
      details?: Maybe<ResolversTypes['LineItemDetails']>;
    }
  >;
  LineItemDetails:
    | ResolversTypes['DonationItemDetails']
    | ResolversTypes['ProductItemDetails'];
  DonationItemDetails: ResolverTypeWrapper<DonationItemDetails>;
  ProductItemDetails: ResolverTypeWrapper<ProductItemDetails>;
  DonationCause: ResolverTypeWrapper<DonationCause>;
  Fees: ResolverTypeWrapper<Fees>;
  VoluntaryContributionConfig: ResolverTypeWrapper<VoluntaryContributionConfig>;
  SupportedFeatures: ResolverTypeWrapper<SupportedFeatures>;
  Payment: ResolverTypeWrapper<
    Omit<Payment, 'details'> & {
      details?: Maybe<ResolversTypes['PaymentDetails']>;
    }
  >;
  PaymentDetails: ResolversTypes['PaymentCard'] | ResolversTypes['DirectDebit'];
  DirectDebit: ResolverTypeWrapper<DirectDebit>;
  DonationPublicReadModel: ResolverTypeWrapper<DonationPublicReadModel>;
  StartSessionResult: ResolverTypeWrapper<StartSessionResult>;
  SuggestedAmountDescription: SuggestedAmountDescription;
  ExternalRef: ExternalRef;
  DonationAmountDetails: DonationAmountDetails;
  CrowdfundingPageOwner: CrowdfundingPageOwner;
  CrowdfundingPageDetails: CrowdfundingPageDetails;
  DonationDeepLinkParameters: DonationDeepLinkParameters;
  DonationRequestUris: DonationRequestUris;
  StartDonationInput: StartDonationInput;
  CacheControlScope: CacheControlScope;
  DiscoverPersistedPages: ResolverTypeWrapper<DiscoverPersistedPages>;
  DiscoverItem: ResolverTypeWrapper<DiscoverItem>;
  DonationSummary: ResolverTypeWrapper<DonationSummary>;
  DonationConnection: ResolverTypeWrapper<DonationConnection>;
  DonationEdge: ResolverTypeWrapper<DonationEdge>;
  Donation: ResolverTypeWrapper<Donation>;
  DonationMatch: ResolverTypeWrapper<DonationMatch>;
  Reaction: ResolverTypeWrapper<Reaction>;
  DonorDonationSummary: ResolverTypeWrapper<DonorDonationSummary>;
  PageType: PageType;
  PageStatus: PageStatus;
  DonationMatchType: DonationMatchType;
  AccountConnectionStatus: AccountConnectionStatus;
  WithdrawalStatus: WithdrawalStatus;
  TimelineEntryType: TimelineEntryType;
  MeasurementSystem: MeasurementSystem;
  DeleteStatus: DeleteStatus;
  DistanceUnit: DistanceUnit;
  TimeUnit: TimeUnit;
  StepsUnit: StepsUnit;
  PageRelationshipType: PageRelationshipType;
  PageBeneficiaryType: PageBeneficiaryType;
  PageTotalsDisplayOptions: PageTotalsDisplayOptions;
  LivestreamMediaPlatform: LivestreamMediaPlatform;
  VideoMediaPlatform: VideoMediaPlatform;
  ProductType: ProductType;
  Locale: Locale;
  LineItemType: LineItemType;
  TransactingUserType: TransactingUserType;
  CardType: CardType;
  PointsScheme: PointsScheme;
  AcceptedCurrencyCode: AcceptedCurrencyCode;
  TipScheme: TipScheme;
  PaymentType: PaymentType;
  VoluntaryContributionConfigValueType: VoluntaryContributionConfigValueType;
  TransactionStatus: TransactionStatus;
  EntityType: EntityType;
  PaymentServiceProvider: PaymentServiceProvider;
  DeviceType: DeviceType;
  WalletPaymentType: WalletPaymentType;
  Event: ResolverTypeWrapper<
    Omit<Event, 'fundraiserGoals'> & {
      fundraiserGoals?: Maybe<Array<ResolversTypes['Goal']>>;
    }
  >;
  EventConnection: ResolverTypeWrapper<EventConnection>;
  EventEdge: ResolverTypeWrapper<EventEdge>;
  CreateEventInput: CreateEventInput;
  ConnectFitnessInput: ConnectFitnessInput;
  TimelineEntry: ResolverTypeWrapper<
    Omit<TimelineEntry, 'media'> & {
      media?: Maybe<Array<ResolversTypes['Media']>>;
    }
  >;
  FitnessActivity: ResolverTypeWrapper<FitnessActivity>;
  Distance: ResolverTypeWrapper<Distance>;
  Duration: ResolverTypeWrapper<Duration>;
  Steps: ResolverTypeWrapper<Steps>;
  FitnessActivityInput: FitnessActivityInput;
  ExternalFitnessSources: ExternalFitnessSources;
  PublishingSource: PublishingSource;
  Strava: ResolverTypeWrapper<Strava>;
  Fitbit: ResolverTypeWrapper<Fitbit>;
  Account: ResolverTypeWrapper<Account>;
  Funds: ResolverTypeWrapper<Funds>;
  FundsInput: FundsInput;
  Withdrawal: ResolverTypeWrapper<Withdrawal>;
  WithdrawalConnection: ResolverTypeWrapper<WithdrawalConnection>;
  AccountConnectionTimeline: ResolverTypeWrapper<AccountConnectionTimeline>;
  TimeRemaining: ResolverTypeWrapper<TimeRemaining>;
  CreateVideoStoryInput: CreateVideoStoryInput;
  FitnessTotalsInput: FitnessTotalsInput;
  TimelineEntryInput: TimelineEntryInput;
  VideoStory: ResolverTypeWrapper<VideoStory>;
  Goal: ResolversTypes['FitnessGoal'];
  FitnessGoal: ResolverTypeWrapper<FitnessGoal>;
  FitnessGoalInput: FitnessGoalInput;
  TargetMetric: TargetMetric;
  UnitOfMeasure: UnitOfMeasure;
  Node:
    | ResolversTypes['Charity']
    | ResolversTypes['Checkout']
    | ResolversTypes['Event']
    | ResolversTypes['TimelineEntry']
    | ResolversTypes['ImageMedia']
    | ResolversTypes['VideoMedia']
    | ResolversTypes['LivestreamMedia']
    | ResolversTypes['OfflineDonation']
    | ResolversTypes['Page']
    | ResolversTypes['User'];
  Leaderboard: ResolverTypeWrapper<Leaderboard>;
  LeaderboardDefinition: ResolverTypeWrapper<LeaderboardDefinition>;
  LeaderboardTotal: ResolverTypeWrapper<LeaderboardTotal>;
  Lifecycle: ResolverTypeWrapper<Lifecycle>;
  LifecycleStatus: LifecycleStatus;
  Livestream: ResolverTypeWrapper<Livestream>;
  LivestreamMetaData: ResolverTypeWrapper<LivestreamMetaData>;
  LivestreamEntries: ResolverTypeWrapper<LivestreamEntries>;
  CreateLivestreamInput: CreateLivestreamInput;
  DeleteLivestreamInput: DeleteLivestreamInput;
  UpdateLivestreamInput: UpdateLivestreamInput;
  MediaConnection: ResolverTypeWrapper<
    Omit<MediaConnection, 'nodes'> & { nodes: Array<ResolversTypes['Media']> }
  >;
  MediaEdge: ResolverTypeWrapper<
    Omit<MediaEdge, 'node'> & { node: ResolversTypes['Media'] }
  >;
  Media:
    | ResolversTypes['ImageMedia']
    | ResolversTypes['VideoMedia']
    | ResolversTypes['LivestreamMedia'];
  ImageMedia: ResolverTypeWrapper<ImageMedia>;
  VideoMedia: ResolverTypeWrapper<VideoMedia>;
  LivestreamMedia: ResolverTypeWrapper<LivestreamMedia>;
  MediaCollectionInput: MediaCollectionInput;
  MediaItemInput: MediaItemInput;
  ImageMediaInput: ImageMediaInput;
  VideoMediaInput: VideoMediaInput;
  LivestreamMediaInput: LivestreamMediaInput;
  DeleteMediaItemInput: DeleteMediaItemInput;
  DeleteMediaItemPayload: ResolverTypeWrapper<DeleteMediaItemPayload>;
  AddMediaItemInput: AddMediaItemInput;
  AddMediaItemPayload: ResolverTypeWrapper<AddMediaItemPayload>;
  Meta: ResolverTypeWrapper<Meta>;
  OfflineDonation: ResolverTypeWrapper<OfflineDonation>;
  CreateOfflineDonationInput: CreateOfflineDonationInput;
  DeleteOfflineDonationInput: DeleteOfflineDonationInput;
  EditOfflineDonationInput: EditOfflineDonationInput;
  OfflineDonationConnection: ResolverTypeWrapper<OfflineDonationConnection>;
  OfflineDonationEdge: ResolverTypeWrapper<OfflineDonationEdge>;
  Page: ResolverTypeWrapper<
    Omit<Page, 'heroMedia' | 'cover' | 'application'> & {
      heroMedia?: Maybe<ResolversTypes['Media']>;
      cover?: Maybe<ResolversTypes['Media']>;
      application?: Maybe<ResolversTypes['Application']>;
    }
  >;
  CustomCode: ResolverTypeWrapper<CustomCode>;
  PageLeaderboardConnection: ResolverTypeWrapper<PageLeaderboardConnection>;
  PageLeaderboardEdge: ResolverTypeWrapper<PageLeaderboardEdge>;
  PageLeaderboardType: PageLeaderboardType;
  FundraisingSettings: ResolverTypeWrapper<FundraisingSettings>;
  FundraisingDefaults: ResolverTypeWrapper<
    Omit<FundraisingDefaults, 'cover'> & {
      cover?: Maybe<ResolversTypes['Media']>;
    }
  >;
  Product: ResolverTypeWrapper<Product>;
  MonetaryAmountInput: MonetaryAmountInput;
  PageWithId: ResolverTypeWrapper<PageWithId>;
  UpdatePagePayload: ResolverTypeWrapper<UpdatePagePayload>;
  UpdatePageInput: UpdatePageInput;
  UpdatePageAsStaffInput: UpdatePageAsStaffInput;
  UpdatePreferenceServiceInput: UpdatePreferenceServiceInput;
  ConsentsInput: ConsentsInput;
  PreferenceServicePayload: ResolverTypeWrapper<PreferenceServicePayload>;
  MonetaryAmount: ResolverTypeWrapper<MonetaryAmount>;
  CanParticipateInInput: CanParticipateInInput;
  Location: ResolverTypeWrapper<Location>;
  DonationPrompt: ResolverTypeWrapper<DonationPrompt>;
  Hero: ResolverTypeWrapper<Hero>;
  Birthday: ResolverTypeWrapper<Birthday>;
  Occasion: ResolverTypeWrapper<Occasion>;
  InMemory: ResolverTypeWrapper<InMemory>;
  LinkPageToCampaignInput: LinkPageToCampaignInput;
  BirthdayInput: BirthdayInput;
  PageTotals: ResolverTypeWrapper<PageTotals>;
  PageTotal: ResolverTypeWrapper<PageTotal>;
  CancelPageInput: CancelPageInput;
  CreatePageV2Input: CreatePageV2Input;
  CustomCodeInput: CustomCodeInput;
  CreatePageMetadataInput: CreatePageMetadataInput;
  FundraisingSettingsInput: FundraisingSettingsInput;
  ThankYouMessageInput: ThankYouMessageInput;
  ThankYouMessage: ResolverTypeWrapper<ThankYouMessage>;
  ThankYouMessageType: ThankYouMessageType;
  FundraisingSettingsDefaultsInput: FundraisingSettingsDefaultsInput;
  OccasionInput: OccasionInput;
  OccasionType: OccasionType;
  PageRelationshipInput: PageRelationshipInput;
  PageBeneficiaryInput: PageBeneficiaryInput;
  PageTagInput: PageTagInput;
  PageCelebrationInput: PageCelebrationInput;
  RelatedPageInput: RelatedPageInput;
  SetPageMediaInput: SetPageMediaInput;
  SetPageMediaPayload: ResolverTypeWrapper<SetPageMediaPayload>;
  UpdatePageCoverInput: UpdatePageCoverInput;
  UpdatePageCoverPayload: ResolverTypeWrapper<
    Omit<UpdatePageCoverPayload, 'cover'> & {
      cover?: Maybe<ResolversTypes['Media']>;
    }
  >;
  UpdatePageGalleryInput: UpdatePageGalleryInput;
  UpdatePageGalleryPayload: ResolverTypeWrapper<
    Omit<UpdatePageGalleryPayload, 'media'> & {
      media: Array<ResolversTypes['Media']>;
    }
  >;
  PageRelationshipsInput: PageRelationshipsInput;
  AssignTagsToChildrenInput: AssignTagsToChildrenInput;
  ChildrenInput: ChildrenInput;
  CancelPagePayload: ResolverTypeWrapper<CancelPagePayload>;
  PageRelationshipsPayload: ResolverTypeWrapper<PageRelationshipsPayload>;
  SetPageLifecyclePayload: ResolverTypeWrapper<SetPageLifecyclePayload>;
  PageConnection: ResolverTypeWrapper<PageConnection>;
  PageEdge: ResolverTypeWrapper<PageEdge>;
  PageCreatedCountSummaryItem: ResolverTypeWrapper<PageCreatedCountSummaryItem>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  ForwardOnlyPageInfo: ResolverTypeWrapper<ForwardOnlyPageInfo>;
  Reason: ResolverTypeWrapper<Reason>;
  ReasonInput: ReasonInput;
  PageRelationships: ResolverTypeWrapper<PageRelationships>;
  PageRelationship: ResolverTypeWrapper<PageRelationship>;
  PageRelationshipConnection: ResolverTypeWrapper<PageRelationshipConnection>;
  PageRelationshipConfig: ResolverTypeWrapper<PageRelationshipConfig>;
  PageRelationshipEdge: ResolverTypeWrapper<PageRelationshipEdge>;
  BeneficiaryConnection: ResolverTypeWrapper<
    Omit<BeneficiaryConnection, 'nodes'> & {
      nodes: Array<ResolversTypes['BeneficiaryItem']>;
    }
  >;
  BeneficiaryEdge: ResolverTypeWrapper<
    Omit<BeneficiaryEdge, 'node'> & { node: ResolversTypes['BeneficiaryItem'] }
  >;
  BeneficiaryItem: ResolversTypes['Charity'] | ResolversTypes['User'];
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  URL: ResolverTypeWrapper<Scalars['URL']>;
  MonetaryValue: ResolverTypeWrapper<Scalars['MonetaryValue']>;
  CurrencyCode: ResolverTypeWrapper<Scalars['CurrencyCode']>;
  Slug: ResolverTypeWrapper<Scalars['Slug']>;
  Preview: ResolverTypeWrapper<Scalars['Preview']>;
  LeaderboardId: ResolverTypeWrapper<Scalars['LeaderboardId']>;
  FixedFloat: ResolverTypeWrapper<Scalars['FixedFloat']>;
  UUID: ResolverTypeWrapper<Scalars['UUID']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  Story: ResolverTypeWrapper<Story>;
  StoryInput: StoryInput;
  StoryType: StoryType;
  TagValue: ResolverTypeWrapper<TagValue>;
  TagDefinition: ResolverTypeWrapper<TagDefinition>;
  AggregationRule: ResolverTypeWrapper<AggregationRule>;
  TimeBox: ResolverTypeWrapper<TimeBox>;
  TotalAmount: ResolverTypeWrapper<TotalAmount>;
  Tag: ResolverTypeWrapper<Tag>;
  Tasks: ResolverTypeWrapper<Tasks>;
  TaskInput: TaskInput;
  JoinTeamInput: JoinTeamInput;
  JoinTeamPayload: ResolverTypeWrapper<JoinTeamPayload>;
  UnlinkTeamInput: UnlinkTeamInput;
  UnlinkTeamPayload: ResolverTypeWrapper<UnlinkTeamPayload>;
  CreateTeamInput: CreateTeamInput;
  CreateTimelineEntryInput: CreateTimelineEntryInput;
  DeleteTimelineEntryInput: DeleteTimelineEntryInput;
  TimelineEntryConnection: ResolverTypeWrapper<TimelineEntryConnection>;
  TimelineEntryEdge: ResolverTypeWrapper<TimelineEntryEdge>;
  RefreshTimelineEntryInput: RefreshTimelineEntryInput;
  TagWithNode: ResolverTypeWrapper<TagWithNode>;
  Total: ResolverTypeWrapper<Total>;
  TrendingCharities: ResolverTypeWrapper<TrendingCharities>;
  TrendingCharitiesEdge: ResolverTypeWrapper<TrendingCharitiesEdge>;
  User: ResolverTypeWrapper<User>;
  DateFilterInput: DateFilterInput;
  UserInput: UserInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Application: ResolversParentTypes['FitnessApplication'];
  FitnessApplicationSettings: FitnessApplicationSettings;
  Boolean: Scalars['Boolean'];
  FitnessApplication: FitnessApplication;
  String: Scalars['String'];
  FitnessApplicationSettingsInput: FitnessApplicationSettingsInput;
  ID: Scalars['ID'];
  Mutation: {};
  ThirdPartyApplications: ThirdPartyApplications;
  AsksItem: AsksItem;
  Query: {};
  Int: Scalars['Int'];
  AvailableSlugs: AvailableSlugs;
  Branding: Branding;
  CauseByCauseRefInput: CauseByCauseRefInput;
  CauseBySourceRefInput: CauseBySourceRefInput;
  Cause: Cause;
  CauseTip: CauseTip;
  CauseBbms: CauseBbms;
  CauseGiftAid: CauseGiftAid;
  TipJarConfiguration: TipJarConfiguration;
  Float: Scalars['Float'];
  PaymentMethod: PaymentMethod;
  Charity: Charity;
  CheckoutInput: CheckoutInput;
  TransactionStatusInput: TransactionStatusInput;
  PaymentCardCardPointsBalanceInput: PaymentCardCardPointsBalanceInput;
  PaymentCardPointsBalance: PaymentCardPointsBalance;
  CheckoutInitialise3DSResponse: CheckoutInitialise3DsResponse;
  Checkout3DSNonceBillingAddress: Checkout3DsNonceBillingAddress;
  Checkout3DSNonceResponse: Checkout3DsNonceResponse;
  VerifyCheckoutWalletInput: VerifyCheckoutWalletInput;
  CheckoutWalletVerification: CheckoutWalletVerification;
  VerifyCheckout3DSInput: VerifyCheckout3DsInput;
  Checkout3DSVerification: Checkout3DsVerification;
  InitialiseCheckoutPayWithBankTransferAmountInput: InitialiseCheckoutPayWithBankTransferAmountInput;
  InitialiseCheckoutPayWithBankTransferInput: InitialiseCheckoutPayWithBankTransferInput;
  CheckoutPayWithBankTransferInitData: CheckoutPayWithBankTransferInitData;
  CheckoutPayWithBankTransferKey: CheckoutPayWithBankTransferKey;
  InitialiseCheckout3DSInput: InitialiseCheckout3DsInput;
  Checkout3dsInitialiseCallInput: Checkout3dsInitialiseCallInput;
  Checkout3DSNonceCallInput: Checkout3DsNonceCallInput;
  Checkout3DSData: Checkout3DsData;
  InitialiseCheckoutWalletTokenInput: InitialiseCheckoutWalletTokenInput;
  CheckoutWalletToken: CheckoutWalletToken;
  ConfirmCheckoutInput: ConfirmCheckoutInput;
  PreferencesInput: PreferencesInput;
  ConsentInput: ConsentInput;
  DonorDetailsInput: DonorDetailsInput;
  SessionInformationInput: SessionInformationInput;
  UpdateCheckoutApplyPointsInput: UpdateCheckoutApplyPointsInput;
  UpdateCheckoutSelectedCardInput: UpdateCheckoutSelectedCardInput;
  UpdateCheckoutRemoveCardInput: UpdateCheckoutRemoveCardInput;
  UpdateCheckoutPaymentTypeInput: UpdateCheckoutPaymentTypeInput;
  UpdateCheckoutPersonalisationInput: UpdateCheckoutPersonalisationInput;
  UpdateCheckoutGiftAidDeclarationInput: UpdateCheckoutGiftAidDeclarationInput;
  GiftAidDetailsInput: GiftAidDetailsInput;
  AddressInput: AddressInput;
  UpdateCheckoutOrderAmountInput: UpdateCheckoutOrderAmountInput;
  DirectDebitInput: DirectDebitInput;
  Checkout: Checkout;
  TransactingUser: TransactingUser;
  PaymentCard: PaymentCard;
  Address: Address;
  PaymentCardPoints: PaymentCardPoints;
  CustomAttributes: CustomAttributes;
  Transaction: Transaction;
  GiftAid: GiftAid;
  TaxPayerDetails: TaxPayerDetails;
  Order: Order;
  SupportedCurrencies: SupportedCurrencies;
  CurrencyDefaults: CurrencyDefaults;
  SuggestedAmount: SuggestedAmount;
  LineItem: Omit<LineItem, 'details'> & {
    details?: Maybe<ResolversParentTypes['LineItemDetails']>;
  };
  LineItemDetails:
    | ResolversParentTypes['DonationItemDetails']
    | ResolversParentTypes['ProductItemDetails'];
  DonationItemDetails: DonationItemDetails;
  ProductItemDetails: ProductItemDetails;
  DonationCause: DonationCause;
  Fees: Fees;
  VoluntaryContributionConfig: VoluntaryContributionConfig;
  SupportedFeatures: SupportedFeatures;
  Payment: Omit<Payment, 'details'> & {
    details?: Maybe<ResolversParentTypes['PaymentDetails']>;
  };
  PaymentDetails:
    | ResolversParentTypes['PaymentCard']
    | ResolversParentTypes['DirectDebit'];
  DirectDebit: DirectDebit;
  DonationPublicReadModel: DonationPublicReadModel;
  StartSessionResult: StartSessionResult;
  SuggestedAmountDescription: SuggestedAmountDescription;
  ExternalRef: ExternalRef;
  DonationAmountDetails: DonationAmountDetails;
  CrowdfundingPageOwner: CrowdfundingPageOwner;
  CrowdfundingPageDetails: CrowdfundingPageDetails;
  DonationDeepLinkParameters: DonationDeepLinkParameters;
  DonationRequestUris: DonationRequestUris;
  StartDonationInput: StartDonationInput;
  DiscoverPersistedPages: DiscoverPersistedPages;
  DiscoverItem: DiscoverItem;
  DonationSummary: DonationSummary;
  DonationConnection: DonationConnection;
  DonationEdge: DonationEdge;
  Donation: Donation;
  DonationMatch: DonationMatch;
  Reaction: Reaction;
  DonorDonationSummary: DonorDonationSummary;
  Event: Omit<Event, 'fundraiserGoals'> & {
    fundraiserGoals?: Maybe<Array<ResolversParentTypes['Goal']>>;
  };
  EventConnection: EventConnection;
  EventEdge: EventEdge;
  CreateEventInput: CreateEventInput;
  ConnectFitnessInput: ConnectFitnessInput;
  TimelineEntry: Omit<TimelineEntry, 'media'> & {
    media?: Maybe<Array<ResolversParentTypes['Media']>>;
  };
  FitnessActivity: FitnessActivity;
  Distance: Distance;
  Duration: Duration;
  Steps: Steps;
  FitnessActivityInput: FitnessActivityInput;
  Strava: Strava;
  Fitbit: Fitbit;
  Account: Account;
  Funds: Funds;
  FundsInput: FundsInput;
  Withdrawal: Withdrawal;
  WithdrawalConnection: WithdrawalConnection;
  AccountConnectionTimeline: AccountConnectionTimeline;
  TimeRemaining: TimeRemaining;
  CreateVideoStoryInput: CreateVideoStoryInput;
  FitnessTotalsInput: FitnessTotalsInput;
  TimelineEntryInput: TimelineEntryInput;
  VideoStory: VideoStory;
  Goal: ResolversParentTypes['FitnessGoal'];
  FitnessGoal: FitnessGoal;
  FitnessGoalInput: FitnessGoalInput;
  Node:
    | ResolversParentTypes['Charity']
    | ResolversParentTypes['Checkout']
    | ResolversParentTypes['Event']
    | ResolversParentTypes['TimelineEntry']
    | ResolversParentTypes['ImageMedia']
    | ResolversParentTypes['VideoMedia']
    | ResolversParentTypes['LivestreamMedia']
    | ResolversParentTypes['OfflineDonation']
    | ResolversParentTypes['Page']
    | ResolversParentTypes['User'];
  Leaderboard: Leaderboard;
  LeaderboardDefinition: LeaderboardDefinition;
  LeaderboardTotal: LeaderboardTotal;
  Lifecycle: Lifecycle;
  Livestream: Livestream;
  LivestreamMetaData: LivestreamMetaData;
  LivestreamEntries: LivestreamEntries;
  CreateLivestreamInput: CreateLivestreamInput;
  DeleteLivestreamInput: DeleteLivestreamInput;
  UpdateLivestreamInput: UpdateLivestreamInput;
  MediaConnection: Omit<MediaConnection, 'nodes'> & {
    nodes: Array<ResolversParentTypes['Media']>;
  };
  MediaEdge: Omit<MediaEdge, 'node'> & { node: ResolversParentTypes['Media'] };
  Media:
    | ResolversParentTypes['ImageMedia']
    | ResolversParentTypes['VideoMedia']
    | ResolversParentTypes['LivestreamMedia'];
  ImageMedia: ImageMedia;
  VideoMedia: VideoMedia;
  LivestreamMedia: LivestreamMedia;
  MediaCollectionInput: MediaCollectionInput;
  MediaItemInput: MediaItemInput;
  ImageMediaInput: ImageMediaInput;
  VideoMediaInput: VideoMediaInput;
  LivestreamMediaInput: LivestreamMediaInput;
  DeleteMediaItemInput: DeleteMediaItemInput;
  DeleteMediaItemPayload: DeleteMediaItemPayload;
  AddMediaItemInput: AddMediaItemInput;
  AddMediaItemPayload: AddMediaItemPayload;
  Meta: Meta;
  OfflineDonation: OfflineDonation;
  CreateOfflineDonationInput: CreateOfflineDonationInput;
  DeleteOfflineDonationInput: DeleteOfflineDonationInput;
  EditOfflineDonationInput: EditOfflineDonationInput;
  OfflineDonationConnection: OfflineDonationConnection;
  OfflineDonationEdge: OfflineDonationEdge;
  Page: Omit<Page, 'heroMedia' | 'cover' | 'application'> & {
    heroMedia?: Maybe<ResolversParentTypes['Media']>;
    cover?: Maybe<ResolversParentTypes['Media']>;
    application?: Maybe<ResolversParentTypes['Application']>;
  };
  CustomCode: CustomCode;
  PageLeaderboardConnection: PageLeaderboardConnection;
  PageLeaderboardEdge: PageLeaderboardEdge;
  FundraisingSettings: FundraisingSettings;
  FundraisingDefaults: Omit<FundraisingDefaults, 'cover'> & {
    cover?: Maybe<ResolversParentTypes['Media']>;
  };
  Product: Product;
  MonetaryAmountInput: MonetaryAmountInput;
  PageWithId: PageWithId;
  UpdatePagePayload: UpdatePagePayload;
  UpdatePageInput: UpdatePageInput;
  UpdatePageAsStaffInput: UpdatePageAsStaffInput;
  UpdatePreferenceServiceInput: UpdatePreferenceServiceInput;
  ConsentsInput: ConsentsInput;
  PreferenceServicePayload: PreferenceServicePayload;
  MonetaryAmount: MonetaryAmount;
  CanParticipateInInput: CanParticipateInInput;
  Location: Location;
  DonationPrompt: DonationPrompt;
  Hero: Hero;
  Birthday: Birthday;
  Occasion: Occasion;
  InMemory: InMemory;
  LinkPageToCampaignInput: LinkPageToCampaignInput;
  BirthdayInput: BirthdayInput;
  PageTotals: PageTotals;
  PageTotal: PageTotal;
  CancelPageInput: CancelPageInput;
  CreatePageV2Input: CreatePageV2Input;
  CustomCodeInput: CustomCodeInput;
  CreatePageMetadataInput: CreatePageMetadataInput;
  FundraisingSettingsInput: FundraisingSettingsInput;
  ThankYouMessageInput: ThankYouMessageInput;
  ThankYouMessage: ThankYouMessage;
  FundraisingSettingsDefaultsInput: FundraisingSettingsDefaultsInput;
  OccasionInput: OccasionInput;
  PageRelationshipInput: PageRelationshipInput;
  PageBeneficiaryInput: PageBeneficiaryInput;
  PageTagInput: PageTagInput;
  PageCelebrationInput: PageCelebrationInput;
  RelatedPageInput: RelatedPageInput;
  SetPageMediaInput: SetPageMediaInput;
  SetPageMediaPayload: SetPageMediaPayload;
  UpdatePageCoverInput: UpdatePageCoverInput;
  UpdatePageCoverPayload: Omit<UpdatePageCoverPayload, 'cover'> & {
    cover?: Maybe<ResolversParentTypes['Media']>;
  };
  UpdatePageGalleryInput: UpdatePageGalleryInput;
  UpdatePageGalleryPayload: Omit<UpdatePageGalleryPayload, 'media'> & {
    media: Array<ResolversParentTypes['Media']>;
  };
  PageRelationshipsInput: PageRelationshipsInput;
  AssignTagsToChildrenInput: AssignTagsToChildrenInput;
  ChildrenInput: ChildrenInput;
  CancelPagePayload: CancelPagePayload;
  PageRelationshipsPayload: PageRelationshipsPayload;
  SetPageLifecyclePayload: SetPageLifecyclePayload;
  PageConnection: PageConnection;
  PageEdge: PageEdge;
  PageCreatedCountSummaryItem: PageCreatedCountSummaryItem;
  PageInfo: PageInfo;
  ForwardOnlyPageInfo: ForwardOnlyPageInfo;
  Reason: Reason;
  ReasonInput: ReasonInput;
  PageRelationships: PageRelationships;
  PageRelationship: PageRelationship;
  PageRelationshipConnection: PageRelationshipConnection;
  PageRelationshipConfig: PageRelationshipConfig;
  PageRelationshipEdge: PageRelationshipEdge;
  BeneficiaryConnection: Omit<BeneficiaryConnection, 'nodes'> & {
    nodes: Array<ResolversParentTypes['BeneficiaryItem']>;
  };
  BeneficiaryEdge: Omit<BeneficiaryEdge, 'node'> & {
    node: ResolversParentTypes['BeneficiaryItem'];
  };
  BeneficiaryItem:
    | ResolversParentTypes['Charity']
    | ResolversParentTypes['User'];
  DateTime: Scalars['DateTime'];
  URL: Scalars['URL'];
  MonetaryValue: Scalars['MonetaryValue'];
  CurrencyCode: Scalars['CurrencyCode'];
  Slug: Scalars['Slug'];
  Preview: Scalars['Preview'];
  LeaderboardId: Scalars['LeaderboardId'];
  FixedFloat: Scalars['FixedFloat'];
  UUID: Scalars['UUID'];
  JSON: Scalars['JSON'];
  Story: Story;
  StoryInput: StoryInput;
  TagValue: TagValue;
  TagDefinition: TagDefinition;
  AggregationRule: AggregationRule;
  TimeBox: TimeBox;
  TotalAmount: TotalAmount;
  Tag: Tag;
  Tasks: Tasks;
  TaskInput: TaskInput;
  JoinTeamInput: JoinTeamInput;
  JoinTeamPayload: JoinTeamPayload;
  UnlinkTeamInput: UnlinkTeamInput;
  UnlinkTeamPayload: UnlinkTeamPayload;
  CreateTeamInput: CreateTeamInput;
  CreateTimelineEntryInput: CreateTimelineEntryInput;
  DeleteTimelineEntryInput: DeleteTimelineEntryInput;
  TimelineEntryConnection: TimelineEntryConnection;
  TimelineEntryEdge: TimelineEntryEdge;
  RefreshTimelineEntryInput: RefreshTimelineEntryInput;
  TagWithNode: TagWithNode;
  Total: Total;
  TrendingCharities: TrendingCharities;
  TrendingCharitiesEdge: TrendingCharitiesEdge;
  User: User;
  DateFilterInput: DateFilterInput;
  UserInput: UserInput;
};

export type ComplexityDirectiveArgs = {
  value: Scalars['Int'];
  multipliers?: Maybe<Array<Scalars['String']>>;
};

export type ComplexityDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = ComplexityDirectiveArgs
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type CacheControlDirectiveArgs = {
  maxAge?: Maybe<Scalars['Int']>;
  scope?: Maybe<CacheControlScope>;
};

export type CacheControlDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = CacheControlDirectiveArgs
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ApplicationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Application'] = ResolversParentTypes['Application']
> = {
  __resolveType: TypeResolveFn<'FitnessApplication', ParentType, ContextType>;
};

export type FitnessApplicationSettingsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FitnessApplicationSettings'] = ResolversParentTypes['FitnessApplicationSettings']
> = {
  measurementSystem?: Resolver<
    Maybe<ResolversTypes['MeasurementSystem']>,
    ParentType,
    ContextType
  >;
  subscribedActivities?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['FitnessApplicationActivityType']>>>,
    ParentType,
    ContextType
  >;
  showDistance?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  showDuration?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  showElevation?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  showPhotos?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  showMap?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  showTotaliser?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitnessApplicationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FitnessApplication'] = ResolversParentTypes['FitnessApplication']
> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settings?: Resolver<
    Maybe<ResolversTypes['FitnessApplicationSettings']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']
> = {
  saveFitnessApplicationSettings?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationSaveFitnessApplicationSettingsArgs, 'input'>
  >;
  setFitnessApplicationSettings?: Resolver<
    Maybe<ResolversTypes['FitnessApplicationSettings']>,
    ParentType,
    ContextType,
    RequireFields<MutationSetFitnessApplicationSettingsArgs, 'input'>
  >;
  updateCheckoutPersonalisation?: Resolver<
    Maybe<ResolversTypes['Checkout']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCheckoutPersonalisationArgs, 'input'>
  >;
  updateCheckoutGiftAidDeclaration?: Resolver<
    Maybe<ResolversTypes['Checkout']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCheckoutGiftAidDeclarationArgs, 'input'>
  >;
  updateCheckoutOrderAmount?: Resolver<
    Maybe<ResolversTypes['Checkout']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCheckoutOrderAmountArgs, 'input'>
  >;
  updateCheckoutSelectedCard?: Resolver<
    Maybe<ResolversTypes['Checkout']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCheckoutSelectedCardArgs, 'input'>
  >;
  updateCheckoutRemoveCard?: Resolver<
    Maybe<ResolversTypes['Checkout']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCheckoutRemoveCardArgs, 'input'>
  >;
  confirmCheckout?: Resolver<
    Maybe<ResolversTypes['Checkout']>,
    ParentType,
    ContextType,
    RequireFields<MutationConfirmCheckoutArgs, 'input'>
  >;
  updateCheckoutApplyPoints?: Resolver<
    Maybe<ResolversTypes['Checkout']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCheckoutApplyPointsArgs, 'input'>
  >;
  updateCheckoutPaymentType?: Resolver<
    Maybe<ResolversTypes['Checkout']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateCheckoutPaymentTypeArgs, 'input'>
  >;
  initialiseCheckoutWalletToken?: Resolver<
    Maybe<ResolversTypes['CheckoutWalletToken']>,
    ParentType,
    ContextType,
    RequireFields<MutationInitialiseCheckoutWalletTokenArgs, 'input'>
  >;
  initialiseCheckout3DS?: Resolver<
    Maybe<ResolversTypes['Checkout3DSData']>,
    ParentType,
    ContextType,
    RequireFields<MutationInitialiseCheckout3DsArgs, 'input'>
  >;
  checkout3dsInitialise?: Resolver<
    Maybe<ResolversTypes['CheckoutInitialise3DSResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckout3dsInitialiseArgs, 'input'>
  >;
  checkout3dsNonce?: Resolver<
    Maybe<ResolversTypes['Checkout3DSNonceResponse']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckout3dsNonceArgs, 'input'>
  >;
  verifyCheckout3DS?: Resolver<
    Maybe<ResolversTypes['Checkout3DSVerification']>,
    ParentType,
    ContextType,
    RequireFields<MutationVerifyCheckout3DsArgs, 'input'>
  >;
  verifyCheckoutWallet?: Resolver<
    Maybe<ResolversTypes['CheckoutWalletVerification']>,
    ParentType,
    ContextType,
    RequireFields<MutationVerifyCheckoutWalletArgs, 'input'>
  >;
  initialiseCheckoutPayWithBankTransfer?: Resolver<
    Maybe<ResolversTypes['CheckoutPayWithBankTransferInitData']>,
    ParentType,
    ContextType,
    RequireFields<MutationInitialiseCheckoutPayWithBankTransferArgs, 'input'>
  >;
  startCheckoutSession?: Resolver<
    Maybe<ResolversTypes['StartSessionResult']>,
    ParentType,
    ContextType,
    RequireFields<MutationStartCheckoutSessionArgs, 'input'>
  >;
  thankDonor?: Resolver<
    Maybe<ResolversTypes['Donation']>,
    ParentType,
    ContextType,
    RequireFields<MutationThankDonorArgs, 'donorId' | 'pageId' | 'message'>
  >;
  createEvent?: Resolver<
    Maybe<ResolversTypes['Event']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateEventArgs, 'input'>
  >;
  connectFitness?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationConnectFitnessArgs, 'input'>
  >;
  connectFitbit?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationConnectFitbitArgs, 'input'>
  >;
  disconnectFitness?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  disconnectFitbit?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  createVideoStory?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType,
    RequireFields<MutationCreateVideoStoryArgs, 'input'>
  >;
  createLivestreamEntry?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateLivestreamEntryArgs, 'input'>
  >;
  deleteLivestreamEntry?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteLivestreamEntryArgs, 'input'>
  >;
  updateLivestreamEntry?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateLivestreamEntryArgs, 'input'>
  >;
  addOfflineDonation?: Resolver<
    Maybe<ResolversTypes['OfflineDonation']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddOfflineDonationArgs, 'input'>
  >;
  deleteOfflineDonation?: Resolver<
    ResolversTypes['ID'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteOfflineDonationArgs, 'input'>
  >;
  editOfflineDonation?: Resolver<
    Maybe<ResolversTypes['OfflineDonation']>,
    ParentType,
    ContextType,
    RequireFields<MutationEditOfflineDonationArgs, 'input'>
  >;
  updatePage?: Resolver<
    Maybe<ResolversTypes['UpdatePagePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePageArgs, 'input'>
  >;
  updatePageAsStaff?: Resolver<
    Maybe<ResolversTypes['UpdatePagePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePageAsStaffArgs, 'input'>
  >;
  updatePreferenceService?: Resolver<
    Maybe<ResolversTypes['PreferenceServicePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePreferenceServiceArgs, 'input'>
  >;
  addMediaItem?: Resolver<
    Maybe<ResolversTypes['AddMediaItemPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddMediaItemArgs, 'input'>
  >;
  assignTagsToChildren?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationAssignTagsToChildrenArgs, 'input'>
  >;
  deleteMediaItem?: Resolver<
    Maybe<ResolversTypes['DeleteMediaItemPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteMediaItemArgs, 'input'>
  >;
  cancelPage?: Resolver<
    Maybe<ResolversTypes['CancelPagePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCancelPageArgs, 'input'>
  >;
  setPageMedia?: Resolver<
    Maybe<ResolversTypes['SetPageMediaPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationSetPageMediaArgs, 'input'>
  >;
  createPageV2?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreatePageV2Args, 'input'>
  >;
  addPageRelationships?: Resolver<
    Maybe<ResolversTypes['PageRelationshipsPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddPageRelationshipsArgs, 'input'>
  >;
  deletePageRelationships?: Resolver<
    Maybe<ResolversTypes['PageRelationshipsPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeletePageRelationshipsArgs, 'input'>
  >;
  updatePageCover?: Resolver<
    Maybe<ResolversTypes['UpdatePageCoverPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePageCoverArgs, 'input'>
  >;
  updatePageGallery?: Resolver<
    Maybe<ResolversTypes['UpdatePageGalleryPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdatePageGalleryArgs, 'input'>
  >;
  linkPageToCampaign?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationLinkPageToCampaignArgs, 'input'>
  >;
  completeTask?: Resolver<
    Maybe<ResolversTypes['Tasks']>,
    ParentType,
    ContextType,
    RequireFields<MutationCompleteTaskArgs, never>
  >;
  createTeam?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTeamArgs, 'input'>
  >;
  joinTeam?: Resolver<
    Maybe<ResolversTypes['JoinTeamPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationJoinTeamArgs, 'input'>
  >;
  unlinkTeam?: Resolver<
    Maybe<ResolversTypes['UnlinkTeamPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUnlinkTeamArgs, 'input'>
  >;
  createTimelineEntry?: Resolver<
    Maybe<ResolversTypes['TimelineEntry']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateTimelineEntryArgs, 'input'>
  >;
  deleteTimelineEntry?: Resolver<
    ResolversTypes['ID'],
    ParentType,
    ContextType,
    RequireFields<MutationDeleteTimelineEntryArgs, 'input'>
  >;
  refreshTimelineEntry?: Resolver<
    ResolversTypes['ID'],
    ParentType,
    ContextType,
    RequireFields<MutationRefreshTimelineEntryArgs, 'input'>
  >;
};

export type ThirdPartyApplicationsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ThirdPartyApplications'] = ResolversParentTypes['ThirdPartyApplications']
> = {
  strava?: Resolver<Maybe<ResolversTypes['Strava']>, ParentType, ContextType>;
  fitbit?: Resolver<Maybe<ResolversTypes['Fitbit']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AsksItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AsksItem'] = ResolversParentTypes['AsksItem']
> = {
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  imageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  amountRaised?: Resolver<
    Maybe<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  target?: Resolver<
    Maybe<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  hasTarget?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  currency?: Resolver<
    Maybe<ResolversTypes['CurrencyCode']>,
    ParentType,
    ContextType
  >;
  isYimby?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  progress?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  yimbyPitchFor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  yimbyPitchBecause?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  beneficiaryName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  askStatus?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  editUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']
> = {
  availableSlugs?: Resolver<
    Maybe<ResolversTypes['AvailableSlugs']>,
    ParentType,
    ContextType,
    RequireFields<QueryAvailableSlugsArgs, 'slug'>
  >;
  getCauseByCauseRef?: Resolver<
    Maybe<ResolversTypes['Cause']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetCauseByCauseRefArgs, 'input'>
  >;
  getCauseBySourceRef?: Resolver<
    Maybe<ResolversTypes['Cause']>,
    ParentType,
    ContextType,
    RequireFields<QueryGetCauseBySourceRefArgs, 'input'>
  >;
  charity?: Resolver<
    Maybe<ResolversTypes['Charity']>,
    ParentType,
    ContextType,
    RequireFields<QueryCharityArgs, 'charityId'>
  >;
  charityByExternalId?: Resolver<
    Maybe<ResolversTypes['Charity']>,
    ParentType,
    ContextType,
    RequireFields<QueryCharityByExternalIdArgs, 'externalId'>
  >;
  checkout?: Resolver<
    Maybe<ResolversTypes['Checkout']>,
    ParentType,
    ContextType,
    RequireFields<QueryCheckoutArgs, 'input'>
  >;
  transactionStatus?: Resolver<
    Maybe<ResolversTypes['TransactionStatus']>,
    ParentType,
    ContextType,
    RequireFields<QueryTransactionStatusArgs, 'input'>
  >;
  paymentCardPointsBalance?: Resolver<
    Maybe<ResolversTypes['PaymentCardPointsBalance']>,
    ParentType,
    ContextType,
    RequireFields<QueryPaymentCardPointsBalanceArgs, 'input'>
  >;
  discoverPersistedPages?: Resolver<
    Maybe<ResolversTypes['DiscoverPersistedPages']>,
    ParentType,
    ContextType
  >;
  funds?: Resolver<
    Maybe<ResolversTypes['Funds']>,
    ParentType,
    ContextType,
    RequireFields<QueryFundsArgs, 'input'>
  >;
  getVideoStory?: Resolver<
    ResolversTypes['VideoStory'],
    ParentType,
    ContextType,
    RequireFields<QueryGetVideoStoryArgs, 'legacyId'>
  >;
  leaderboard?: Resolver<
    ResolversTypes['Leaderboard'],
    ParentType,
    ContextType,
    RequireFields<QueryLeaderboardArgs, 'id'>
  >;
  livestream?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType,
    RequireFields<QueryLivestreamArgs, 'legacyId'>
  >;
  livestreamByType?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LivestreamMetaData']>>>,
    ParentType,
    ContextType,
    RequireFields<QueryLivestreamByTypeArgs, 'streamType' | 'isLive'>
  >;
  meta?: Resolver<ResolversTypes['Meta'], ParentType, ContextType>;
  page?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType,
    RequireFields<QueryPageArgs, 'type'>
  >;
  pageById?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType,
    RequireFields<QueryPageByIdArgs, 'type' | 'id'>
  >;
  pageCreatedCountSummary?: Resolver<
    Array<ResolversTypes['PageCreatedCountSummaryItem']>,
    ParentType,
    ContextType,
    RequireFields<QueryPageCreatedCountSummaryArgs, 'pageId' | 'month' | 'year'>
  >;
  node?: Resolver<
    Maybe<ResolversTypes['Node']>,
    ParentType,
    ContextType,
    RequireFields<QueryNodeArgs, 'id'>
  >;
  viewer?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  tagValues?: Resolver<
    Array<ResolversTypes['TagValue']>,
    ParentType,
    ContextType,
    RequireFields<QueryTagValuesArgs, 'assignee'>
  >;
  tasks?: Resolver<
    Maybe<ResolversTypes['Tasks']>,
    ParentType,
    ContextType,
    RequireFields<QueryTasksArgs, 'input'>
  >;
  totals?: Resolver<
    Array<ResolversTypes['Total']>,
    ParentType,
    ContextType,
    RequireFields<QueryTotalsArgs, 'segment' | 'tagDefinitionId' | 'tagValue'>
  >;
  trendingCharities?: Resolver<
    Maybe<ResolversTypes['TrendingCharities']>,
    ParentType,
    ContextType
  >;
};

export type AvailableSlugsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AvailableSlugs'] = ResolversParentTypes['AvailableSlugs']
> = {
  slugs?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Slug']>>>,
    ParentType,
    ContextType
  >;
  isAvailable?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BrandingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Branding'] = ResolversParentTypes['Branding']
> = {
  id?: Resolver<Maybe<ResolversTypes['UUID']>, ParentType, ContextType>;
  backgroundColor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  backgroundImage?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  headerImage?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  primaryColor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CauseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Cause'] = ResolversParentTypes['Cause']
> = {
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sourceRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  causeRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  beneficiaryRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tip?: Resolver<ResolversTypes['CauseTip'], ParentType, ContextType>;
  marketCode?: Resolver<ResolversTypes['MarketCode'], ParentType, ContextType>;
  settlementCurrency?: Resolver<
    ResolversTypes['AcceptedCurrencyCode'],
    ParentType,
    ContextType
  >;
  bbms?: Resolver<Maybe<ResolversTypes['CauseBbms']>, ParentType, ContextType>;
  supportsGuest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  giftAid?: Resolver<ResolversTypes['CauseGiftAid'], ParentType, ContextType>;
  paymentMethods?: Resolver<
    Array<ResolversTypes['PaymentMethod']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CauseTipResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CauseTip'] = ResolversParentTypes['CauseTip']
> = {
  tipScheme?: Resolver<ResolversTypes['TipScheme'], ParentType, ContextType>;
  tipJarConfiguration?: Resolver<
    Maybe<Array<ResolversTypes['TipJarConfiguration']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CauseBbmsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CauseBbms'] = ResolversParentTypes['CauseBbms']
> = {
  merchantAccountId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CauseGiftAidResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CauseGiftAid'] = ResolversParentTypes['CauseGiftAid']
> = {
  supported?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  externalProviderEnabled?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TipJarConfigurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TipJarConfiguration'] = ResolversParentTypes['TipJarConfiguration']
> = {
  from?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isToInfinity?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  valueType?: Resolver<
    ResolversTypes['TipJarValueType'],
    ParentType,
    ContextType
  >;
  values?: Resolver<
    Maybe<Array<ResolversTypes['Int']>>,
    ParentType,
    ContextType
  >;
  defaultValue?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentMethodResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PaymentMethod'] = ResolversParentTypes['PaymentMethod']
> = {
  currency?: Resolver<ResolversTypes['CurrencyCode'], ParentType, ContextType>;
  card?: Resolver<
    Maybe<Array<ResolversTypes['CardType']>>,
    ParentType,
    ContextType
  >;
  supportsRecurringCard?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  alternative?: Resolver<
    Maybe<Array<ResolversTypes['AlternativePaymentMethod']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CharityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Charity'] = ResolversParentTypes['Charity']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  registrationNumber?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes['Slug'], ParentType, ContextType>;
  profilePageUrl?: Resolver<
    Maybe<ResolversTypes['URL']>,
    ParentType,
    ContextType
  >;
  logo?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  impactStatement?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  causeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  externalUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  targetWithCurrency?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  pageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  legacyCharityId?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  displayCurrency?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  donationPrompts?: Resolver<
    Maybe<Array<ResolversTypes['DonationPrompt']>>,
    ParentType,
    ContextType
  >;
  countryCode?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  thankYouMessage?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  landingPage?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType
  >;
  externalId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  beneficiaryId?: Resolver<
    Maybe<ResolversTypes['UUID']>,
    ParentType,
    ContextType
  >;
  supportsGiftAid?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentCardPointsBalanceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PaymentCardPointsBalance'] = ResolversParentTypes['PaymentCardPointsBalance']
> = {
  checkoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  paymentCardId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalPoints?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  conversionRate?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  isEligible?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutInitialise3DsResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckoutInitialise3DSResponse'] = ResolversParentTypes['CheckoutInitialise3DSResponse']
> = {
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  clientTokenUnavailable?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout3DsNonceBillingAddressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Checkout3DSNonceBillingAddress'] = ResolversParentTypes['Checkout3DSNonceBillingAddress']
> = {
  addressLine1?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  addressLine2?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  townCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countyStateRegion?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  udprn?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  billingAddressId?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout3DsNonceResponseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Checkout3DSNonceResponse'] = ResolversParentTypes['Checkout3DSNonceResponse']
> = {
  exemptionRequested?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  paymentCardId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nonce?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bin?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  emailAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  billingAddress?: Resolver<
    ResolversTypes['Checkout3DSNonceBillingAddress'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutWalletVerificationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckoutWalletVerification'] = ResolversParentTypes['CheckoutWalletVerification']
> = {
  isSuccessful?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout3DsVerificationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Checkout3DSVerification'] = ResolversParentTypes['Checkout3DSVerification']
> = {
  isSuccessful?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutPayWithBankTransferInitDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckoutPayWithBankTransferInitData'] = ResolversParentTypes['CheckoutPayWithBankTransferInitData']
> = {
  custom_data_encryption?: Resolver<
    ResolversTypes['CheckoutPayWithBankTransferKey'],
    ParentType,
    ContextType
  >;
  button_type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country_code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  locale?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  merchant_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  order_details?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  request_id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutPayWithBankTransferKeyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckoutPayWithBankTransferKey'] = ResolversParentTypes['CheckoutPayWithBankTransferKey']
> = {
  public_key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  public_key_version?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Checkout3DsDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Checkout3DSData'] = ResolversParentTypes['Checkout3DSData']
> = {
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nonce?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exemptionRequested?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  postalCode?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  clientTokenUnavailable?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutWalletTokenResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CheckoutWalletToken'] = ResolversParentTypes['CheckoutWalletToken']
> = {
  token?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CheckoutResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Checkout'] = ResolversParentTypes['Checkout']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  checkoutId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  userLocale?: Resolver<
    Maybe<ResolversTypes['Locale']>,
    ParentType,
    ContextType
  >;
  transactingUser?: Resolver<
    Maybe<ResolversTypes['TransactingUser']>,
    ParentType,
    ContextType
  >;
  additionalData?: Resolver<ResolversTypes['JSON'], ParentType, ContextType>;
  customAttributes?: Resolver<
    Maybe<ResolversTypes['CustomAttributes']>,
    ParentType,
    ContextType
  >;
  transaction?: Resolver<
    Maybe<ResolversTypes['Transaction']>,
    ParentType,
    ContextType
  >;
  giftAid?: Resolver<Maybe<ResolversTypes['GiftAid']>, ParentType, ContextType>;
  order?: Resolver<Maybe<ResolversTypes['Order']>, ParentType, ContextType>;
  payment?: Resolver<Maybe<ResolversTypes['Payment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactingUserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TransactingUser'] = ResolversParentTypes['TransactingUser']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  transactingUserId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<
    Maybe<ResolversTypes['TransactingUserType']>,
    ParentType,
    ContextType
  >;
  savedCards?: Resolver<
    Array<ResolversTypes['PaymentCard']>,
    ParentType,
    ContextType
  >;
  lastUsedPaymentType?: Resolver<
    Maybe<ResolversTypes['PaymentType']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentCardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PaymentCard'] = ResolversParentTypes['PaymentCard']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  paymentCardId?: Resolver<
    Maybe<ResolversTypes['ID']>,
    ParentType,
    ContextType
  >;
  nameOnCard?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastFourDigits?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiryMonth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expiryYear?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  saved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  disabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  cardCountryCode?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  cardType?: Resolver<ResolversTypes['CardType'], ParentType, ContextType>;
  billingAddress?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  requires3DS?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  points?: Resolver<
    Maybe<ResolversTypes['PaymentCardPoints']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  line1?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  line2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  townCity?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countyStateRegion?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  postalCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentCardPointsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PaymentCardPoints'] = ResolversParentTypes['PaymentCardPoints']
> = {
  appliedPoints?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  totalPoints?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  conversionRate?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomAttributesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CustomAttributes'] = ResolversParentTypes['CustomAttributes']
> = {
  currency?: Resolver<
    ResolversTypes['AcceptedCurrencyCode'],
    ParentType,
    ContextType
  >;
  tipScheme?: Resolver<
    Maybe<ResolversTypes['TipScheme']>,
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  skipGiftAid?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  skipMessage?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  suggestedPaymentType?: Resolver<
    Maybe<ResolversTypes['PaymentType']>,
    ParentType,
    ContextType
  >;
  successUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  redirectOnSuccess?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TransactionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Transaction'] = ResolversParentTypes['Transaction']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  transactionId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  reference?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  isComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startedTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GiftAidResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['GiftAid'] = ResolversParentTypes['GiftAid']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  taxPayerDetails?: Resolver<
    Maybe<ResolversTypes['TaxPayerDetails']>,
    ParentType,
    ContextType
  >;
  ratePercent?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  isClaimed?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isExternalGiftAidProviderEnabled?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  isMatchedInExternalGiftAidProvider?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TaxPayerDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TaxPayerDetails'] = ResolversParentTypes['TaxPayerDetails']
> = {
  firstName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  selectionHash?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrderResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Order'] = ResolversParentTypes['Order']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  supportedCurrencies?: Resolver<
    ResolversTypes['SupportedCurrencies'],
    ParentType,
    ContextType
  >;
  currency?: Resolver<
    Maybe<ResolversTypes['AcceptedCurrencyCode']>,
    ParentType,
    ContextType
  >;
  appliedTipScheme?: Resolver<
    Maybe<ResolversTypes['TipScheme']>,
    ParentType,
    ContextType
  >;
  lineItems?: Resolver<
    Array<ResolversTypes['LineItem']>,
    ParentType,
    ContextType
  >;
  tipAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  totalAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  fees?: Resolver<Maybe<ResolversTypes['Fees']>, ParentType, ContextType>;
  voluntaryContributionConfig?: Resolver<
    Maybe<Array<ResolversTypes['VoluntaryContributionConfig']>>,
    ParentType,
    ContextType
  >;
  requiresFullBillingAddress?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  supportedFeatures?: Resolver<
    Maybe<ResolversTypes['SupportedFeatures']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportedCurrenciesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportedCurrencies'] = ResolversParentTypes['SupportedCurrencies']
> = {
  GBP?: Resolver<
    Maybe<ResolversTypes['CurrencyDefaults']>,
    ParentType,
    ContextType
  >;
  USD?: Resolver<
    Maybe<ResolversTypes['CurrencyDefaults']>,
    ParentType,
    ContextType
  >;
  AUD?: Resolver<
    Maybe<ResolversTypes['CurrencyDefaults']>,
    ParentType,
    ContextType
  >;
  CAD?: Resolver<
    Maybe<ResolversTypes['CurrencyDefaults']>,
    ParentType,
    ContextType
  >;
  EUR?: Resolver<
    Maybe<ResolversTypes['CurrencyDefaults']>,
    ParentType,
    ContextType
  >;
  NZD?: Resolver<
    Maybe<ResolversTypes['CurrencyDefaults']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CurrencyDefaultsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CurrencyDefaults'] = ResolversParentTypes['CurrencyDefaults']
> = {
  supportedPaymentTypes?: Resolver<
    Array<ResolversTypes['PaymentType']>,
    ParentType,
    ContextType
  >;
  supportedCardTypes?: Resolver<
    Array<ResolversTypes['CardType']>,
    ParentType,
    ContextType
  >;
  supportedPointsSchemes?: Resolver<
    Array<ResolversTypes['PointsScheme']>,
    ParentType,
    ContextType
  >;
  suggestedAmounts?: Resolver<
    Array<ResolversTypes['SuggestedAmount']>,
    ParentType,
    ContextType
  >;
  default?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  minimum?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  maximum?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SuggestedAmountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SuggestedAmount'] = ResolversParentTypes['SuggestedAmount']
> = {
  value?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LineItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LineItem'] = ResolversParentTypes['LineItem']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lineItemId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<
    Maybe<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LineItemType'], ParentType, ContextType>;
  details?: Resolver<
    Maybe<ResolversTypes['LineItemDetails']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LineItemDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LineItemDetails'] = ResolversParentTypes['LineItemDetails']
> = {
  __resolveType: TypeResolveFn<
    'DonationItemDetails' | 'ProductItemDetails',
    ParentType,
    ContextType
  >;
};

export type DonationItemDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationItemDetails'] = ResolversParentTypes['DonationItemDetails']
> = {
  cause?: Resolver<
    Maybe<ResolversTypes['DonationCause']>,
    ParentType,
    ContextType
  >;
  page?: Resolver<Maybe<ResolversTypes['Page']>, ParentType, ContextType>;
  isAmountPrivate?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  isRecurring?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  recurrenceDayOfMonth?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  recurrenceNextPaymentDate?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  displayName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  isAnonymous?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductItemDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ProductItemDetails'] = ResolversParentTypes['ProductItemDetails']
> = {
  quantity?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationCauseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationCause'] = ResolversParentTypes['DonationCause']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  causeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  sourceRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  marketCode?: Resolver<ResolversTypes['Locale'], ParentType, ContextType>;
  tipScheme?: Resolver<
    Maybe<ResolversTypes['TipScheme']>,
    ParentType,
    ContextType
  >;
  supportsGiftAid?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  isBbms?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  displayHideAmountOption?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  supportsRecurringPayments?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  sourceUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  supportsGuest?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  voluntaryContributionConfig?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['VoluntaryContributionConfig']>>>,
    ParentType,
    ContextType
  >;
  isExternalGiftAidProviderEnabled?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Fees'] = ResolversParentTypes['Fees']
> = {
  platformFeePercentage?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  processingFeePercentage?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoluntaryContributionConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VoluntaryContributionConfig'] = ResolversParentTypes['VoluntaryContributionConfig']
> = {
  from?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  valueType?: Resolver<
    ResolversTypes['VoluntaryContributionConfigValueType'],
    ParentType,
    ContextType
  >;
  values?: Resolver<
    Array<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  defaultValue?: Resolver<
    ResolversTypes['MonetaryValue'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportedFeaturesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SupportedFeatures'] = ResolversParentTypes['SupportedFeatures']
> = {
  guest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  giftAid?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Payment'] = ResolversParentTypes['Payment']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['PaymentType'], ParentType, ContextType>;
  details?: Resolver<
    Maybe<ResolversTypes['PaymentDetails']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaymentDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PaymentDetails'] = ResolversParentTypes['PaymentDetails']
> = {
  __resolveType: TypeResolveFn<
    'PaymentCard' | 'DirectDebit',
    ParentType,
    ContextType
  >;
};

export type DirectDebitResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DirectDebit'] = ResolversParentTypes['DirectDebit']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  accountHolderName?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  sortCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dayOfMonth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nextPaymentDate?: Resolver<
    ResolversTypes['DateTime'],
    ParentType,
    ContextType
  >;
  mandateReference?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  cancelWhenCauseExpires?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationPublicReadModelResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationPublicReadModel'] = ResolversParentTypes['DonationPublicReadModel']
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StartSessionResultResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['StartSessionResult'] = ResolversParentTypes['StartSessionResult']
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdInCheckoutApi?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscoverPersistedPagesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DiscoverPersistedPages'] = ResolversParentTypes['DiscoverPersistedPages']
> = {
  nodes?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiscoverItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DiscoverItem'] = ResolversParentTypes['DiscoverItem']
> = {
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  linkUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  imageSrc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageGuid?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userImageSrc?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationSummary'] = ResolversParentTypes['DonationSummary']
> = {
  totalAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  totalMatched?: Resolver<
    Array<ResolversTypes['DonationMatch']>,
    ParentType,
    ContextType
  >;
  onlineAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  offlineAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  textDonations?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  directDonationAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  fundraiserRaisedAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  donationCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  aggregatedDonationsCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  onlineDonationCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  offlineDonationCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  fundraiserDonationsCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationConnection'] = ResolversParentTypes['DonationConnection']
> = {
  edges?: Resolver<
    Array<ResolversTypes['DonationEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes['Donation']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationEdge'] = ResolversParentTypes['DonationEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Donation'], ParentType, ContextType>;
  direct?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Donation'] = ResolversParentTypes['Donation']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  creationDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  giftAidAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  donationReference?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  avatar?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matches?: Resolver<
    Array<ResolversTypes['DonationMatch']>,
    ParentType,
    ContextType
  >;
  pageOwnerReaction?: Resolver<
    Maybe<ResolversTypes['Reaction']>,
    ParentType,
    ContextType
  >;
  pageName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  beneficiary?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationMatchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationMatch'] = ResolversParentTypes['DonationMatch']
> = {
  type?: Resolver<ResolversTypes['DonationMatchType'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReactionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Reaction'] = ResolversParentTypes['Reaction']
> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonorDonationSummaryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonorDonationSummary'] = ResolversParentTypes['DonorDonationSummary']
> = {
  totalAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  totalGiftAidAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Event'] = ResolversParentTypes['Event']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  endDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  visible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  activities?: Resolver<
    Maybe<Array<ResolversTypes['FitnessApplicationActivityType']>>,
    ParentType,
    ContextType
  >;
  externalFitnessSources?: Resolver<
    Maybe<Array<ResolversTypes['ExternalFitnessSources']>>,
    ParentType,
    ContextType
  >;
  allowManualActivities?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  fundraiserGoals?: Resolver<
    Maybe<Array<ResolversTypes['Goal']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventConnection'] = ResolversParentTypes['EventConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['EventEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Event']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EventEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EventEdge'] = ResolversParentTypes['EventEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Event'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimelineEntryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimelineEntry'] = ResolversParentTypes['TimelineEntry']
> = {
  fitnessActivity?: Resolver<
    Maybe<ResolversTypes['FitnessActivity']>,
    ParentType,
    ContextType
  >;
  refreshRequestedTime?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  media?: Resolver<
    Maybe<Array<ResolversTypes['Media']>>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['TimelineEntryType'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  publishingSource?: Resolver<
    Maybe<ResolversTypes['PublishingSource']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitnessActivityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FitnessActivity'] = ResolversParentTypes['FitnessActivity']
> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  activityType?: Resolver<
    Maybe<ResolversTypes['FitnessApplicationActivityType']>,
    ParentType,
    ContextType
  >;
  mapPolyline?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  distance?: Resolver<
    Maybe<ResolversTypes['Distance']>,
    ParentType,
    ContextType,
    RequireFields<FitnessActivityDistanceArgs, 'measurementSystem'>
  >;
  elevation?: Resolver<
    Maybe<ResolversTypes['Distance']>,
    ParentType,
    ContextType,
    RequireFields<FitnessActivityElevationArgs, 'measurementSystem'>
  >;
  duration?: Resolver<
    Maybe<ResolversTypes['Duration']>,
    ParentType,
    ContextType,
    RequireFields<FitnessActivityDurationArgs, 'unit'>
  >;
  steps?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DistanceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Distance'] = ResolversParentTypes['Distance']
> = {
  unit?: Resolver<ResolversTypes['DistanceUnit'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['FixedFloat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Duration'] = ResolversParentTypes['Duration']
> = {
  unit?: Resolver<ResolversTypes['TimeUnit'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['FixedFloat'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StepsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Steps'] = ResolversParentTypes['Steps']
> = {
  unit?: Resolver<ResolversTypes['StepsUnit'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StravaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Strava'] = ResolversParentTypes['Strava']
> = {
  isConnected?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FitbitResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Fitbit'] = ResolversParentTypes['Fitbit']
> = {
  isConnected?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Account'] = ResolversParentTypes['Account']
> = {
  startDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  connectionStatus?: Resolver<
    ResolversTypes['AccountConnectionStatus'],
    ParentType,
    ContextType
  >;
  timeRemaining?: Resolver<
    Maybe<ResolversTypes['AccountConnectionTimeline']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Funds'] = ResolversParentTypes['Funds']
> = {
  accounts?: Resolver<
    Maybe<Array<ResolversTypes['Account']>>,
    ParentType,
    ContextType
  >;
  withdrawals?: Resolver<
    Maybe<ResolversTypes['WithdrawalConnection']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Withdrawal'] = ResolversParentTypes['Withdrawal']
> = {
  gross?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  net?: Resolver<ResolversTypes['MonetaryAmount'], ParentType, ContextType>;
  platformFee?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  processingFee?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  status?: Resolver<
    ResolversTypes['WithdrawalStatus'],
    ParentType,
    ContextType
  >;
  completionDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  requestDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WithdrawalConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WithdrawalConnection'] = ResolversParentTypes['WithdrawalConnection']
> = {
  nodes?: Resolver<
    Maybe<Array<ResolversTypes['Withdrawal']>>,
    ParentType,
    ContextType
  >;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  availabilityDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  totalAvailable?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  totalWithdrawn?: Resolver<
    ResolversTypes['MonetaryAmount'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AccountConnectionTimelineResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AccountConnectionTimeline'] = ResolversParentTypes['AccountConnectionTimeline']
> = {
  next?: Resolver<
    Maybe<ResolversTypes['TimeRemaining']>,
    ParentType,
    ContextType
  >;
  final?: Resolver<
    Maybe<ResolversTypes['TimeRemaining']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeRemainingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimeRemaining'] = ResolversParentTypes['TimeRemaining']
> = {
  days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoStoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VideoStory'] = ResolversParentTypes['VideoStory']
> = {
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  videoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GoalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Goal'] = ResolversParentTypes['Goal']
> = {
  __resolveType: TypeResolveFn<'FitnessGoal', ParentType, ContextType>;
};

export type FitnessGoalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FitnessGoal'] = ResolversParentTypes['FitnessGoal']
> = {
  startDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  endDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  activities?: Resolver<
    Maybe<Array<ResolversTypes['FitnessApplicationActivityType']>>,
    ParentType,
    ContextType
  >;
  targetMetric?: Resolver<
    Maybe<ResolversTypes['TargetMetric']>,
    ParentType,
    ContextType
  >;
  targetAmount?: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  unitOfMeasure?: Resolver<
    Maybe<ResolversTypes['UnitOfMeasure']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']
> = {
  __resolveType: TypeResolveFn<
    | 'Charity'
    | 'Checkout'
    | 'Event'
    | 'TimelineEntry'
    | 'ImageMedia'
    | 'VideoMedia'
    | 'LivestreamMedia'
    | 'OfflineDonation'
    | 'Page'
    | 'User',
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type LeaderboardResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Leaderboard'] = ResolversParentTypes['Leaderboard']
> = {
  id?: Resolver<ResolversTypes['LeaderboardId'], ParentType, ContextType>;
  definition?: Resolver<
    Maybe<ResolversTypes['LeaderboardDefinition']>,
    ParentType,
    ContextType
  >;
  totals?: Resolver<
    Array<ResolversTypes['LeaderboardTotal']>,
    ParentType,
    ContextType,
    RequireFields<LeaderboardTotalsArgs, 'limit'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderboardDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LeaderboardDefinition'] = ResolversParentTypes['LeaderboardDefinition']
> = {
  segment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  measurementDomain?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  measurementDomains?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  primaryUnit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tagDefinition?: Resolver<
    ResolversTypes['TagDefinition'],
    ParentType,
    ContextType
  >;
  conditions?: Resolver<Array<ResolversTypes['Tag']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LeaderboardTotalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LeaderboardTotal'] = ResolversParentTypes['LeaderboardTotal']
> = {
  tagValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tagValueAsNode?: Resolver<
    Maybe<ResolversTypes['Node']>,
    ParentType,
    ContextType
  >;
  amounts?: Resolver<
    Array<ResolversTypes['TotalAmount']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LifecycleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Lifecycle'] = ResolversParentTypes['Lifecycle']
> = {
  status?: Resolver<
    Maybe<ResolversTypes['LifecycleStatus']>,
    ParentType,
    ContextType
  >;
  allowedActions?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  updatedDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  expiryDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivestreamResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Livestream'] = ResolversParentTypes['Livestream']
> = {
  pageType?: Resolver<
    Maybe<ResolversTypes['PageType']>,
    ParentType,
    ContextType
  >;
  mediaId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  entries?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LivestreamEntries']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivestreamMetaDataResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LivestreamMetaData'] = ResolversParentTypes['LivestreamMetaData']
> = {
  pageType?: Resolver<
    Maybe<ResolversTypes['PageType']>,
    ParentType,
    ContextType
  >;
  mediaId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamPreview?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  streamDescription?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  pageUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewerCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isLive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivestreamEntriesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LivestreamEntries'] = ResolversParentTypes['LivestreamEntries']
> = {
  mediaType?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  streamId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamType?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  positionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isLive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MediaConnection'] = ResolversParentTypes['MediaConnection']
> = {
  edges?: Resolver<Array<ResolversTypes['MediaEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MediaEdge'] = ResolversParentTypes['MediaEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Media'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MediaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Media'] = ResolversParentTypes['Media']
> = {
  __resolveType: TypeResolveFn<
    'ImageMedia' | 'VideoMedia' | 'LivestreamMedia',
    ParentType,
    ContextType
  >;
};

export type ImageMediaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ImageMedia'] = ResolversParentTypes['ImageMedia']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  caption?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoMediaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['VideoMedia'] = ResolversParentTypes['VideoMedia']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  posterUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  videoPlatform?: Resolver<
    Maybe<ResolversTypes['VideoMediaPlatform']>,
    ParentType,
    ContextType
  >;
  videoId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivestreamMediaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LivestreamMedia'] = ResolversParentTypes['LivestreamMedia']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  posterUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  streamPlatform?: Resolver<
    Maybe<ResolversTypes['LivestreamMediaPlatform']>,
    ParentType,
    ContextType
  >;
  streamId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteMediaItemPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DeleteMediaItemPayload'] = ResolversParentTypes['DeleteMediaItemPayload']
> = {
  itemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AddMediaItemPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AddMediaItemPayload'] = ResolversParentTypes['AddMediaItemPayload']
> = {
  itemId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MetaResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Meta'] = ResolversParentTypes['Meta']
> = {
  releaseVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfflineDonationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OfflineDonation'] = ResolversParentTypes['OfflineDonation']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyCode'], ParentType, ContextType>;
  displayName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateCreated?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfflineDonationConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OfflineDonationConnection'] = ResolversParentTypes['OfflineDonationConnection']
> = {
  edges?: Resolver<
    Array<ResolversTypes['OfflineDonationEdge']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OfflineDonationEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OfflineDonationEdge'] = ResolversParentTypes['OfflineDonationEdge']
> = {
  node?: Resolver<ResolversTypes['OfflineDonation'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Page'] = ResolversParentTypes['Page']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  externalId?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['PageType'], ParentType, ContextType>;
  slug?: Resolver<Maybe<ResolversTypes['Slug']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subtitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  story?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  storyWithType?: Resolver<
    Maybe<ResolversTypes['Story']>,
    ParentType,
    ContextType
  >;
  reason?: Resolver<Maybe<ResolversTypes['Reason']>, ParentType, ContextType>;
  joinVerb?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  joinUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  heroImage?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  hero?: Resolver<Maybe<ResolversTypes['Hero']>, ParentType, ContextType>;
  heroMedia?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  cover?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  target?: Resolver<
    Maybe<ResolversTypes['MonetaryValue']>,
    ParentType,
    ContextType
  >;
  currency?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetWithCurrency?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  donationSummary?: Resolver<
    Maybe<ResolversTypes['DonationSummary']>,
    ParentType,
    ContextType
  >;
  membershipPolicy?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  status?: Resolver<
    Maybe<ResolversTypes['PageStatus']>,
    ParentType,
    ContextType
  >;
  createDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  startDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  launchDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  endDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updateDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  location?: Resolver<
    Maybe<ResolversTypes['Location']>,
    ParentType,
    ContextType
  >;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  categories?: Resolver<
    Maybe<Array<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >;
  branding?: Resolver<
    Maybe<ResolversTypes['Branding']>,
    ParentType,
    ContextType
  >;
  relationships?: Resolver<
    Maybe<ResolversTypes['PageRelationships']>,
    ParentType,
    ContextType
  >;
  donations?: Resolver<
    Maybe<ResolversTypes['DonationConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageDonationsArgs, never>
  >;
  timeline?: Resolver<
    Maybe<ResolversTypes['TimelineEntryConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageTimelineArgs, never>
  >;
  mediaCollection?: Resolver<
    Maybe<ResolversTypes['MediaConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageMediaCollectionArgs, never>
  >;
  gallery?: Resolver<
    Maybe<ResolversTypes['MediaConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageGalleryArgs, never>
  >;
  eventGivingGroupId?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  application?: Resolver<
    Maybe<ResolversTypes['Application']>,
    ParentType,
    ContextType,
    RequireFields<PageApplicationArgs, 'name' | 'type'>
  >;
  tags?: Resolver<
    Maybe<Array<ResolversTypes['TagValue']>>,
    ParentType,
    ContextType
  >;
  redirectUrl?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  livestream?: Resolver<
    Maybe<ResolversTypes['Livestream']>,
    ParentType,
    ContextType
  >;
  startFundraisingUrl?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  allowFundraising?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  totals?: Resolver<
    Maybe<ResolversTypes['PageTotals']>,
    ParentType,
    ContextType
  >;
  charity?: Resolver<Maybe<ResolversTypes['Charity']>, ParentType, ContextType>;
  supportsGiftAid?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  inMemory?: Resolver<
    Maybe<ResolversTypes['InMemory']>,
    ParentType,
    ContextType
  >;
  lifecycle?: Resolver<
    Maybe<ResolversTypes['Lifecycle']>,
    ParentType,
    ContextType
  >;
  offlineDonations?: Resolver<
    Maybe<ResolversTypes['OfflineDonationConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageOfflineDonationsArgs, never>
  >;
  birthday?: Resolver<
    Maybe<ResolversTypes['Birthday']>,
    ParentType,
    ContextType
  >;
  occasion?: Resolver<
    Maybe<ResolversTypes['Occasion']>,
    ParentType,
    ContextType
  >;
  product?: Resolver<Maybe<ResolversTypes['Product']>, ParentType, ContextType>;
  fundraisingSettings?: Resolver<
    Maybe<ResolversTypes['FundraisingSettings']>,
    ParentType,
    ContextType
  >;
  leaderboard?: Resolver<
    Maybe<ResolversTypes['PageLeaderboardConnection']>,
    ParentType,
    ContextType,
    RequireFields<PageLeaderboardArgs, 'type' | 'first'>
  >;
  isJGPro?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  customCodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['CustomCode']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CustomCodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CustomCode'] = ResolversParentTypes['CustomCode']
> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageLeaderboardConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageLeaderboardConnection'] = ResolversParentTypes['PageLeaderboardConnection']
> = {
  leaderboardId?: Resolver<
    Maybe<ResolversTypes['UUID']>,
    ParentType,
    ContextType
  >;
  edges?: Resolver<
    Array<ResolversTypes['PageLeaderboardEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageInfo?: Resolver<
    ResolversTypes['ForwardOnlyPageInfo'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageLeaderboardEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageLeaderboardEdge'] = ResolversParentTypes['PageLeaderboardEdge']
> = {
  node?: Resolver<ResolversTypes['Page'], ParentType, ContextType>;
  tagValue?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  amounts?: Resolver<
    Array<ResolversTypes['TotalAmount']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundraisingSettingsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FundraisingSettings'] = ResolversParentTypes['FundraisingSettings']
> = {
  defaults?: Resolver<
    ResolversTypes['FundraisingDefaults'],
    ParentType,
    ContextType
  >;
  thankYouMessages?: Resolver<
    Array<Maybe<ResolversTypes['ThankYouMessage']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FundraisingDefaultsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FundraisingDefaults'] = ResolversParentTypes['FundraisingDefaults']
> = {
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  story?: Resolver<Maybe<ResolversTypes['Story']>, ParentType, ContextType>;
  targetAmount?: Resolver<
    Maybe<ResolversTypes['MonetaryAmount']>,
    ParentType,
    ContextType
  >;
  cover?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProductResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Product'] = ResolversParentTypes['Product']
> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageWithIdResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageWithId'] = ResolversParentTypes['PageWithId']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePagePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdatePagePayload'] = ResolversParentTypes['UpdatePagePayload']
> = {
  page?: Resolver<Maybe<ResolversTypes['PageWithId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PreferenceServicePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PreferenceServicePayload'] = ResolversParentTypes['PreferenceServicePayload']
> = {
  ok?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MonetaryAmountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MonetaryAmount'] = ResolversParentTypes['MonetaryAmount']
> = {
  value?: Resolver<ResolversTypes['MonetaryValue'], ParentType, ContextType>;
  currencyCode?: Resolver<
    ResolversTypes['CurrencyCode'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']
> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DonationPromptResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DonationPrompt'] = ResolversParentTypes['DonationPrompt']
> = {
  amount?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HeroResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Hero'] = ResolversParentTypes['Hero']
> = {
  imageUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  imageTitle?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BirthdayResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Birthday'] = ResolversParentTypes['Birthday']
> = {
  age?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  celebrationDate?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OccasionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Occasion'] = ResolversParentTypes['Occasion']
> = {
  type?: Resolver<ResolversTypes['OccasionType'], ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  names?: Resolver<
    Maybe<Array<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InMemoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InMemory'] = ResolversParentTypes['InMemory']
> = {
  firstNameOfDeceased?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  lastNameOfDeceased?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  dateOfBirth?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  dateOfDeath?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageTotalsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageTotals'] = ResolversParentTypes['PageTotals']
> = {
  displayOptions?: Resolver<
    ResolversTypes['PageTotalsDisplayOptions'],
    ParentType,
    ContextType
  >;
  primaryMeasurementType?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  timeline?: Resolver<
    Array<ResolversTypes['PageTotal']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageTotalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageTotal'] = ResolversParentTypes['PageTotal']
> = {
  measurementDomain?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  amounts?: Resolver<
    Array<ResolversTypes['TotalAmount']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ThankYouMessageResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ThankYouMessage'] = ResolversParentTypes['ThankYouMessage']
> = {
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<
    ResolversTypes['ThankYouMessageType'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetPageMediaPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetPageMediaPayload'] = ResolversParentTypes['SetPageMediaPayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePageCoverPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdatePageCoverPayload'] = ResolversParentTypes['UpdatePageCoverPayload']
> = {
  cover?: Resolver<Maybe<ResolversTypes['Media']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UpdatePageGalleryPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UpdatePageGalleryPayload'] = ResolversParentTypes['UpdatePageGalleryPayload']
> = {
  media?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CancelPagePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CancelPagePayload'] = ResolversParentTypes['CancelPagePayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipsPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationshipsPayload'] = ResolversParentTypes['PageRelationshipsPayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SetPageLifecyclePayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SetPageLifecyclePayload'] = ResolversParentTypes['SetPageLifecyclePayload']
> = {
  page?: Resolver<ResolversTypes['PageWithId'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageConnection'] = ResolversParentTypes['PageConnection']
> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['PageEdge']>>>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Page']>>>,
    ParentType,
    ContextType
  >;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageEdge'] = ResolversParentTypes['PageEdge']
> = {
  cursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Page'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageCreatedCountSummaryItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageCreatedCountSummaryItem'] = ResolversParentTypes['PageCreatedCountSummaryItem']
> = {
  pageCreatedDate?: Resolver<
    ResolversTypes['DateTime'],
    ParentType,
    ContextType
  >;
  pageCreatedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pageCreatedWithTagsCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  pageCreatedWithoutTagsCount?: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']
> = {
  startCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  endCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ForwardOnlyPageInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ForwardOnlyPageInfo'] = ResolversParentTypes['ForwardOnlyPageInfo']
> = {
  endCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReasonResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Reason'] = ResolversParentTypes['Reason']
> = {
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  reasonUrl?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationships'] = ResolversParentTypes['PageRelationships']
> = {
  beneficiaries?: Resolver<
    ResolversTypes['BeneficiaryConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsBeneficiariesArgs, never>
  >;
  parents?: Resolver<
    Array<ResolversTypes['PageRelationship']>,
    ParentType,
    ContextType
  >;
  members?: Resolver<
    ResolversTypes['PageRelationshipConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsMembersArgs, never>
  >;
  children?: Resolver<
    ResolversTypes['PageRelationshipConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsChildrenArgs, 'productName'>
  >;
  teams?: Resolver<
    ResolversTypes['PageRelationshipConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsTeamsArgs, never>
  >;
  events?: Resolver<
    ResolversTypes['EventConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsEventsArgs, never>
  >;
  campaigns?: Resolver<
    ResolversTypes['PageRelationshipConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsCampaignsArgs, never>
  >;
  companies?: Resolver<
    ResolversTypes['PageRelationshipConnection'],
    ParentType,
    ContextType,
    RequireFields<PageRelationshipsCompaniesArgs, never>
  >;
  config?: Resolver<
    Maybe<ResolversTypes['PageRelationshipConfig']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationship'] = ResolversParentTypes['PageRelationship']
> = {
  type?: Resolver<
    ResolversTypes['PageRelationshipType'],
    ParentType,
    ContextType
  >;
  page?: Resolver<Maybe<ResolversTypes['Page']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationshipConnection'] = ResolversParentTypes['PageRelationshipConnection']
> = {
  edges?: Resolver<
    Array<ResolversTypes['PageRelationshipEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes['Page']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationshipConfig'] = ResolversParentTypes['PageRelationshipConfig']
> = {
  membersDisabled?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageRelationshipEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PageRelationshipEdge'] = ResolversParentTypes['PageRelationshipEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Page'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeneficiaryConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryConnection'] = ResolversParentTypes['BeneficiaryConnection']
> = {
  edges?: Resolver<
    Array<ResolversTypes['BeneficiaryEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes['BeneficiaryItem']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeneficiaryEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryEdge'] = ResolversParentTypes['BeneficiaryEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['BeneficiaryItem'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BeneficiaryItemResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BeneficiaryItem'] = ResolversParentTypes['BeneficiaryItem']
> = {
  __resolveType: TypeResolveFn<'Charity' | 'User', ParentType, ContextType>;
};

export interface DateTimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export interface UrlScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['URL'], any> {
  name: 'URL';
}

export interface MonetaryValueScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['MonetaryValue'], any> {
  name: 'MonetaryValue';
}

export interface CurrencyCodeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['CurrencyCode'], any> {
  name: 'CurrencyCode';
}

export interface SlugScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Slug'], any> {
  name: 'Slug';
}

export interface PreviewScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Preview'], any> {
  name: 'Preview';
}

export interface LeaderboardIdScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['LeaderboardId'], any> {
  name: 'LeaderboardId';
}

export interface FixedFloatScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['FixedFloat'], any> {
  name: 'FixedFloat';
}

export interface UuidScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['UUID'], any> {
  name: 'UUID';
}

export interface JsonScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type StoryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Story'] = ResolversParentTypes['Story']
> = {
  type?: Resolver<ResolversTypes['StoryType'], ParentType, ContextType>;
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagValueResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TagValue'] = ResolversParentTypes['TagValue']
> = {
  tagDefinition?: Resolver<
    ResolversTypes['TagDefinition'],
    ParentType,
    ContextType
  >;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<
    Maybe<Array<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >;
  aggregation?: Resolver<
    Array<ResolversTypes['AggregationRule']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagDefinitionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TagDefinition'] = ResolversParentTypes['TagDefinition']
> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AggregationRuleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AggregationRule'] = ResolversParentTypes['AggregationRule']
> = {
  segment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  measurementDomains?: Resolver<
    Array<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  timeBox?: Resolver<Maybe<ResolversTypes['TimeBox']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimeBoxResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimeBox'] = ResolversParentTypes['TimeBox']
> = {
  notBefore?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  notAfter?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TotalAmountResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TotalAmount'] = ResolversParentTypes['TotalAmount']
> = {
  unit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Tag'] = ResolversParentTypes['Tag']
> = {
  tagDefinition?: Resolver<
    ResolversTypes['TagDefinition'],
    ParentType,
    ContextType
  >;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  values?: Resolver<
    Maybe<Array<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TasksResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Tasks'] = ResolversParentTypes['Tasks']
> = {
  completed?: Resolver<
    Array<Maybe<ResolversTypes['String']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type JoinTeamPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['JoinTeamPayload'] = ResolversParentTypes['JoinTeamPayload']
> = {
  page?: Resolver<Maybe<ResolversTypes['PageWithId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnlinkTeamPayloadResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UnlinkTeamPayload'] = ResolversParentTypes['UnlinkTeamPayload']
> = {
  page?: Resolver<Maybe<ResolversTypes['PageWithId']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimelineEntryConnectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimelineEntryConnection'] = ResolversParentTypes['TimelineEntryConnection']
> = {
  edges?: Resolver<
    Array<ResolversTypes['TimelineEntryEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<
    Array<ResolversTypes['TimelineEntry']>,
    ParentType,
    ContextType
  >;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TimelineEntryEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimelineEntryEdge'] = ResolversParentTypes['TimelineEntryEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['TimelineEntry'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TagWithNodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TagWithNode'] = ResolversParentTypes['TagWithNode']
> = {
  tagDefinition?: Resolver<
    ResolversTypes['TagDefinition'],
    ParentType,
    ContextType
  >;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  valueAsNode?: Resolver<
    Maybe<ResolversTypes['Node']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TotalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Total'] = ResolversParentTypes['Total']
> = {
  segment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  segmentAsNode?: Resolver<
    Maybe<ResolversTypes['Node']>,
    ParentType,
    ContextType
  >;
  tag?: Resolver<ResolversTypes['TagWithNode'], ParentType, ContextType>;
  measurementDomain?: Resolver<
    ResolversTypes['String'],
    ParentType,
    ContextType
  >;
  amounts?: Resolver<
    Array<ResolversTypes['TotalAmount']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrendingCharitiesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TrendingCharities'] = ResolversParentTypes['TrendingCharities']
> = {
  edges?: Resolver<
    Array<ResolversTypes['TrendingCharitiesEdge']>,
    ParentType,
    ContextType
  >;
  nodes?: Resolver<Array<ResolversTypes['Charity']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TrendingCharitiesEdgeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TrendingCharitiesEdge'] = ResolversParentTypes['TrendingCharitiesEdge']
> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Charity'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bio?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thirdPartyApplications?: Resolver<
    Maybe<ResolversTypes['ThirdPartyApplications']>,
    ParentType,
    ContextType
  >;
  page?: Resolver<
    Maybe<ResolversTypes['Page']>,
    ParentType,
    ContextType,
    RequireFields<UserPageArgs, 'type'>
  >;
  pages?: Resolver<
    Maybe<ResolversTypes['PageConnection']>,
    ParentType,
    ContextType,
    RequireFields<UserPagesArgs, never>
  >;
  asks?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['AsksItem']>>>,
    ParentType,
    ContextType
  >;
  donations?: Resolver<
    Maybe<ResolversTypes['DonationConnection']>,
    ParentType,
    ContextType,
    RequireFields<UserDonationsArgs, never>
  >;
  donationSummaries?: Resolver<
    Maybe<Array<ResolversTypes['DonorDonationSummary']>>,
    ParentType,
    ContextType
  >;
  eligibleChildPages?: Resolver<
    Maybe<ResolversTypes['PageConnection']>,
    ParentType,
    ContextType,
    RequireFields<UserEligibleChildPagesArgs, 'parentPageId'>
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Application?: ApplicationResolvers<ContextType>;
  FitnessApplicationSettings?: FitnessApplicationSettingsResolvers<ContextType>;
  FitnessApplication?: FitnessApplicationResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  ThirdPartyApplications?: ThirdPartyApplicationsResolvers<ContextType>;
  AsksItem?: AsksItemResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  AvailableSlugs?: AvailableSlugsResolvers<ContextType>;
  Branding?: BrandingResolvers<ContextType>;
  Cause?: CauseResolvers<ContextType>;
  CauseTip?: CauseTipResolvers<ContextType>;
  CauseBbms?: CauseBbmsResolvers<ContextType>;
  CauseGiftAid?: CauseGiftAidResolvers<ContextType>;
  TipJarConfiguration?: TipJarConfigurationResolvers<ContextType>;
  PaymentMethod?: PaymentMethodResolvers<ContextType>;
  Charity?: CharityResolvers<ContextType>;
  PaymentCardPointsBalance?: PaymentCardPointsBalanceResolvers<ContextType>;
  CheckoutInitialise3DSResponse?: CheckoutInitialise3DsResponseResolvers<
    ContextType
  >;
  Checkout3DSNonceBillingAddress?: Checkout3DsNonceBillingAddressResolvers<
    ContextType
  >;
  Checkout3DSNonceResponse?: Checkout3DsNonceResponseResolvers<ContextType>;
  CheckoutWalletVerification?: CheckoutWalletVerificationResolvers<ContextType>;
  Checkout3DSVerification?: Checkout3DsVerificationResolvers<ContextType>;
  CheckoutPayWithBankTransferInitData?: CheckoutPayWithBankTransferInitDataResolvers<
    ContextType
  >;
  CheckoutPayWithBankTransferKey?: CheckoutPayWithBankTransferKeyResolvers<
    ContextType
  >;
  Checkout3DSData?: Checkout3DsDataResolvers<ContextType>;
  CheckoutWalletToken?: CheckoutWalletTokenResolvers<ContextType>;
  Checkout?: CheckoutResolvers<ContextType>;
  TransactingUser?: TransactingUserResolvers<ContextType>;
  PaymentCard?: PaymentCardResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  PaymentCardPoints?: PaymentCardPointsResolvers<ContextType>;
  CustomAttributes?: CustomAttributesResolvers<ContextType>;
  Transaction?: TransactionResolvers<ContextType>;
  GiftAid?: GiftAidResolvers<ContextType>;
  TaxPayerDetails?: TaxPayerDetailsResolvers<ContextType>;
  Order?: OrderResolvers<ContextType>;
  SupportedCurrencies?: SupportedCurrenciesResolvers<ContextType>;
  CurrencyDefaults?: CurrencyDefaultsResolvers<ContextType>;
  SuggestedAmount?: SuggestedAmountResolvers<ContextType>;
  LineItem?: LineItemResolvers<ContextType>;
  LineItemDetails?: LineItemDetailsResolvers<ContextType>;
  DonationItemDetails?: DonationItemDetailsResolvers<ContextType>;
  ProductItemDetails?: ProductItemDetailsResolvers<ContextType>;
  DonationCause?: DonationCauseResolvers<ContextType>;
  Fees?: FeesResolvers<ContextType>;
  VoluntaryContributionConfig?: VoluntaryContributionConfigResolvers<
    ContextType
  >;
  SupportedFeatures?: SupportedFeaturesResolvers<ContextType>;
  Payment?: PaymentResolvers<ContextType>;
  PaymentDetails?: PaymentDetailsResolvers<ContextType>;
  DirectDebit?: DirectDebitResolvers<ContextType>;
  DonationPublicReadModel?: DonationPublicReadModelResolvers<ContextType>;
  StartSessionResult?: StartSessionResultResolvers<ContextType>;
  DiscoverPersistedPages?: DiscoverPersistedPagesResolvers<ContextType>;
  DiscoverItem?: DiscoverItemResolvers<ContextType>;
  DonationSummary?: DonationSummaryResolvers<ContextType>;
  DonationConnection?: DonationConnectionResolvers<ContextType>;
  DonationEdge?: DonationEdgeResolvers<ContextType>;
  Donation?: DonationResolvers<ContextType>;
  DonationMatch?: DonationMatchResolvers<ContextType>;
  Reaction?: ReactionResolvers<ContextType>;
  DonorDonationSummary?: DonorDonationSummaryResolvers<ContextType>;
  Event?: EventResolvers<ContextType>;
  EventConnection?: EventConnectionResolvers<ContextType>;
  EventEdge?: EventEdgeResolvers<ContextType>;
  TimelineEntry?: TimelineEntryResolvers<ContextType>;
  FitnessActivity?: FitnessActivityResolvers<ContextType>;
  Distance?: DistanceResolvers<ContextType>;
  Duration?: DurationResolvers<ContextType>;
  Steps?: StepsResolvers<ContextType>;
  Strava?: StravaResolvers<ContextType>;
  Fitbit?: FitbitResolvers<ContextType>;
  Account?: AccountResolvers<ContextType>;
  Funds?: FundsResolvers<ContextType>;
  Withdrawal?: WithdrawalResolvers<ContextType>;
  WithdrawalConnection?: WithdrawalConnectionResolvers<ContextType>;
  AccountConnectionTimeline?: AccountConnectionTimelineResolvers<ContextType>;
  TimeRemaining?: TimeRemainingResolvers<ContextType>;
  VideoStory?: VideoStoryResolvers<ContextType>;
  Goal?: GoalResolvers<ContextType>;
  FitnessGoal?: FitnessGoalResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  Leaderboard?: LeaderboardResolvers<ContextType>;
  LeaderboardDefinition?: LeaderboardDefinitionResolvers<ContextType>;
  LeaderboardTotal?: LeaderboardTotalResolvers<ContextType>;
  Lifecycle?: LifecycleResolvers<ContextType>;
  Livestream?: LivestreamResolvers<ContextType>;
  LivestreamMetaData?: LivestreamMetaDataResolvers<ContextType>;
  LivestreamEntries?: LivestreamEntriesResolvers<ContextType>;
  MediaConnection?: MediaConnectionResolvers<ContextType>;
  MediaEdge?: MediaEdgeResolvers<ContextType>;
  Media?: MediaResolvers<ContextType>;
  ImageMedia?: ImageMediaResolvers<ContextType>;
  VideoMedia?: VideoMediaResolvers<ContextType>;
  LivestreamMedia?: LivestreamMediaResolvers<ContextType>;
  DeleteMediaItemPayload?: DeleteMediaItemPayloadResolvers<ContextType>;
  AddMediaItemPayload?: AddMediaItemPayloadResolvers<ContextType>;
  Meta?: MetaResolvers<ContextType>;
  OfflineDonation?: OfflineDonationResolvers<ContextType>;
  OfflineDonationConnection?: OfflineDonationConnectionResolvers<ContextType>;
  OfflineDonationEdge?: OfflineDonationEdgeResolvers<ContextType>;
  Page?: PageResolvers<ContextType>;
  CustomCode?: CustomCodeResolvers<ContextType>;
  PageLeaderboardConnection?: PageLeaderboardConnectionResolvers<ContextType>;
  PageLeaderboardEdge?: PageLeaderboardEdgeResolvers<ContextType>;
  FundraisingSettings?: FundraisingSettingsResolvers<ContextType>;
  FundraisingDefaults?: FundraisingDefaultsResolvers<ContextType>;
  Product?: ProductResolvers<ContextType>;
  PageWithId?: PageWithIdResolvers<ContextType>;
  UpdatePagePayload?: UpdatePagePayloadResolvers<ContextType>;
  PreferenceServicePayload?: PreferenceServicePayloadResolvers<ContextType>;
  MonetaryAmount?: MonetaryAmountResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  DonationPrompt?: DonationPromptResolvers<ContextType>;
  Hero?: HeroResolvers<ContextType>;
  Birthday?: BirthdayResolvers<ContextType>;
  Occasion?: OccasionResolvers<ContextType>;
  InMemory?: InMemoryResolvers<ContextType>;
  PageTotals?: PageTotalsResolvers<ContextType>;
  PageTotal?: PageTotalResolvers<ContextType>;
  ThankYouMessage?: ThankYouMessageResolvers<ContextType>;
  SetPageMediaPayload?: SetPageMediaPayloadResolvers<ContextType>;
  UpdatePageCoverPayload?: UpdatePageCoverPayloadResolvers<ContextType>;
  UpdatePageGalleryPayload?: UpdatePageGalleryPayloadResolvers<ContextType>;
  CancelPagePayload?: CancelPagePayloadResolvers<ContextType>;
  PageRelationshipsPayload?: PageRelationshipsPayloadResolvers<ContextType>;
  SetPageLifecyclePayload?: SetPageLifecyclePayloadResolvers<ContextType>;
  PageConnection?: PageConnectionResolvers<ContextType>;
  PageEdge?: PageEdgeResolvers<ContextType>;
  PageCreatedCountSummaryItem?: PageCreatedCountSummaryItemResolvers<
    ContextType
  >;
  PageInfo?: PageInfoResolvers<ContextType>;
  ForwardOnlyPageInfo?: ForwardOnlyPageInfoResolvers<ContextType>;
  Reason?: ReasonResolvers<ContextType>;
  PageRelationships?: PageRelationshipsResolvers<ContextType>;
  PageRelationship?: PageRelationshipResolvers<ContextType>;
  PageRelationshipConnection?: PageRelationshipConnectionResolvers<ContextType>;
  PageRelationshipConfig?: PageRelationshipConfigResolvers<ContextType>;
  PageRelationshipEdge?: PageRelationshipEdgeResolvers<ContextType>;
  BeneficiaryConnection?: BeneficiaryConnectionResolvers<ContextType>;
  BeneficiaryEdge?: BeneficiaryEdgeResolvers<ContextType>;
  BeneficiaryItem?: BeneficiaryItemResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  URL?: GraphQLScalarType;
  MonetaryValue?: GraphQLScalarType;
  CurrencyCode?: GraphQLScalarType;
  Slug?: GraphQLScalarType;
  Preview?: GraphQLScalarType;
  LeaderboardId?: GraphQLScalarType;
  FixedFloat?: GraphQLScalarType;
  UUID?: GraphQLScalarType;
  JSON?: GraphQLScalarType;
  Story?: StoryResolvers<ContextType>;
  TagValue?: TagValueResolvers<ContextType>;
  TagDefinition?: TagDefinitionResolvers<ContextType>;
  AggregationRule?: AggregationRuleResolvers<ContextType>;
  TimeBox?: TimeBoxResolvers<ContextType>;
  TotalAmount?: TotalAmountResolvers<ContextType>;
  Tag?: TagResolvers<ContextType>;
  Tasks?: TasksResolvers<ContextType>;
  JoinTeamPayload?: JoinTeamPayloadResolvers<ContextType>;
  UnlinkTeamPayload?: UnlinkTeamPayloadResolvers<ContextType>;
  TimelineEntryConnection?: TimelineEntryConnectionResolvers<ContextType>;
  TimelineEntryEdge?: TimelineEntryEdgeResolvers<ContextType>;
  TagWithNode?: TagWithNodeResolvers<ContextType>;
  Total?: TotalResolvers<ContextType>;
  TrendingCharities?: TrendingCharitiesResolvers<ContextType>;
  TrendingCharitiesEdge?: TrendingCharitiesEdgeResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
};

/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>;
export type DirectiveResolvers<ContextType = any> = {
  complexity?: ComplexityDirectiveResolver<any, any, ContextType>;
  cacheControl?: CacheControlDirectiveResolver<any, any, ContextType>;
};

/**
 * @deprecated
 * Use "DirectiveResolvers" root object instead. If you wish to get "IDirectiveResolvers", add "typesPrefix: I" to your config.
 */
export type IDirectiveResolvers<ContextType = any> = DirectiveResolvers<
  ContextType
>;
